export default {
    common: {
        enhancement_banner: {
            title: 'This page is being improved',
            description:
                'This feature remains available during its redesign and will be improved very soon. A question or a suggestion?',
            description_alt: 'This feature remains accessible during its improvement.\nIt will be improved in the coming days.',
            link: "Let's discuss it!",
        },
        onboarding_banner: {
            title: 'Welcome',
            description:
                'This feature remains available during its redesign and will be improved very soon. A question or a suggestion?',
            description_alt: 'This feature remains accessible during its improvement.\nIt will be improved in the coming days.',
            link: "Let's discuss it!",
            first_step: 'First step',
            next_step: 'Next step',
            last_step: 'Last step',
            configure_now: 'Configure now',
            create_now: 'Create now',
            complete_info: 'Please complete the following information:',
            steps: {
                parameters: {
                    title: 'Parameters',
                    name: 'Establishment name',
                    company_name: 'Company name',
                    language: 'Language',
                    timezone: 'Timezone',
                    legal_form: 'Legal form',
                    registration_number: 'Registration number',
                    address: 'Establishment address',
                    hours: 'Opening hours',
                },
                experience: {
                    title: 'Create an experience bookable by your customers',
                    create: 'Create an experience',
                    photos: 'Add photos',
                    pricing: 'Define pricing',
                },
                stripe: {
                    title: 'Configure your Stripe account',
                },
            },
        },
        no_result: 'No result',
        add_question: 'Add a question',
        scheduleTime: {
            nextDayShort: 'next day',
            invalidTime: 'Please enter a valid time (e.g. 8:05 PM).',
            placeholder: 'Enter a precise time, e.g. 8:05 PM',
            closedAllDay: 'Closed all day',
            entered: 'entered',
        },
        select: 'Select...',
        change: 'Change',
        close: 'Close',
        validate: 'Validate',
        hide: 'Hide',
        minimize: 'Minimize',
        no_date: 'No date',
        invalid_date: 'Invalid date',
        crop: 'Crop',
        edit: 'Edit',
        enabled: 'Enabled',
        disabled: 'Disabled',
        visible: 'Visible',
        invisible: 'Invisible',
        show: 'View',
        delete: 'Delete',
        actions: 'Actions',
        no_results: 'No results',
        send: 'Send',
        download: 'Download',
        continue: 'Continue',
        faq: 'FAQ',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        cancel: 'Cancel',
        save: 'Save',
        saving: 'Saving...',
        optional: '(optional)',
        choose: '-- Choose --',
        confirm: 'Confirm',
        confirm_delete: 'Are you sure you want to delete this item?',
        reset: 'Reset',
        cropConfirm: 'Confirm crop',
        cropImage: 'Crop image',
        cropCancel: 'Cancel crop',
        list: 'List',
        calendar: 'Calendar',
        error_occurred: 'An error occurred',
        success_message: 'Operation successful',
        to: 'to',
        closed: 'Closed',
        formValidationError: 'Please correct any errors in the form.',
        please_fill: 'Please fill out',
        loadMore: 'Load more',
        placeholderSelect: 'Please select',
        allDays: 'All weekdays',
        allDaysNoWeekend: 'All weekdays except weekends',
        weekDays: 'Weekdays',
        weekendDays: 'All weekends',
        allDaysExpect: 'All days except',
        allSpecificDay: 'All',
        min: 'min',
        duration: {
            minutesOnly: '{n} min',
            hourSingular: '1 hour',
            hourPlural: '{n} hours',
            hourWithMinutes: '{h} hr {m} min',
        },
        search: 'Search...',
        linePerPage: 'Lines per page',
        from: 'From',
        to_date: 'to',
        and: 'and',
        yes: 'Yes',
        no: 'No',
        recommended_size: 'Recommended size',
        filter: 'Filter',
        all: 'All',
        max: 'max',
        add: 'Add',
        remove: 'Remove',
        replace: 'Replace',
        create: 'Create',
        add_images: 'Add images',
        copy_link: 'Copy link',
        copied: 'Copied!',
        activeFilters: 'Active filters',
        resetAll: 'Clear all',
        duplicate: 'Duplicate',
        none: 'None',
        apply: 'Apply',
        of: 'of',
        expired: 'Expired',
        now: 'Now',
        soon: 'Soon',
        address: 'Address',
        country: 'Country',
        postal_code: 'Postal code',
        steps: {
            parameters: {
                company_name: 'Company name',
            },
        },
        invalidUrlError: 'Please enter a valid URL (e.g., https://example.com).',
        deleteSelection: 'Delete selection',
        expires_at: 'expires on {date}',
        expired_at: 'Expired on {date}',
        yes_cancel: 'Yes, cancel',
        no_keep: 'No, keep',
        preview: 'Preview',
        essential: 'Essential',
        vat_rates: {
            normal: 'Normal rate',
            standard: 'Standard rate',
            intermediate: 'Intermediate rate',
            intermediate_culture: 'Intermediate rate (cultural services, leisure)',
            reduced: 'Reduced rate (unchanged)',
            reduced_food: 'Reduced rate (basic food)',
            special: 'Special rate (unchanged)',
            none: 'No VAT',
        },
        select_at_least_one_column: 'Please select at least one column',
        columns_saved_success: 'Columns have been saved successfully',
        fill_required_fields: 'Please complete all required fields before continuing.',
        save_error: 'An error occurred while saving.',
        generic_error: 'An error occurred',
        deleted_success: 'Deleted successfully',
        export_error: 'Export error',
        modified_success: 'Modified successfully',
        added_success: 'Added successfully',
        visibility_update_error: 'Error updating visibility',
        settings_updated_success: 'Settings updated successfully!',
        data_load_error: 'An error occurred while loading data.',
        excel_download_success: 'Excel file downloaded successfully.',
        config_updated_success: 'Configuration updated successfully!',
        slot_update_error: 'Error updating time slot',
        copy_error: 'Copy error',
        form_saved_success: 'Form saved successfully',
        tenant_not_found: 'Tenant not found',
        status_change_error: 'Error changing status',
        load_error: 'Error loading information',
        copied_clipboard: 'Copied to clipboard',
        enter_text_first: 'Please enter text before enhancing it.',
        text_enhanced_success: 'Text enhanced successfully!',
        file_too_large: 'File too large (max 5MB)',
        return: 'Back',
        status: 'Status',
        deleted_successfully: 'Deleted successfully',
        stay: 'Stay',
        error_validate: 'Validation error',
        formRequiredError: 'Please fill in this field.',
        options: 'Options',
    },
    karafun: {
        syncKarafun: 'Sync spaces from Karafun',
        syncSuccess: 'Sync successful!',
        syncError: 'Sync failed',
        titleKarafun: 'Karafun',
        selectKarafun: 'Select devices',
        selectSpaces: 'Select one or more spaces to link:',
    },
    mail_custom: {
        sections: {
            reminder_before: 'Reminder before reservation',
            birthday: 'Customer birthday gift',
            confirmation: 'Booking confirmation',
            request_imprint: 'Booking request with card imprint',
            thanks_after: 'Thanks after a visit',
            accept: 'Message after request acceptance',
            decline: 'Message after request refusal',
            fidelity: 'Loyalty tier reached',
            miss_you: 'We miss you',
            notification_settings: 'Notification settings',
        },
        fields: {
            reminder_text: 'Personalized message added to the email',
            reminder_days: 'Number of days before reminder',
            birthday_points: 'Number of points to credit',
            birthday_send_before_days: 'Sending delay before the birthday (in days)',
            treshold_1: 'Tier 1',
            treshold_2: 'Tier 2',
            treshold_3: 'Tier 3',
            revisit_time: 'Time without revisit before sending',
            select_roles: 'Select roles to notify',
            placeholder_roles: 'Select a role',
            booking_update_mail: 'Reservation modification — Notify the following roles',
            full_email_description: 'Write the entire email sent to the recipient',
            partial_email_description: 'Add a message that will be inserted into the default email',
            thanks_after_visit_time: 'Sending delay after visit (in days)',
            notice_google_link: 'Link to your Google review page',
        },
        title_page: 'Automatic emails',
    },
    annonce: {
        title: 'Announcements',
        add_banner: 'Banner',
        add_popup: 'Popup',
        filter_type: 'Filter by type',
        no_img: 'No Img',
        banner: 'Banner',
        popup: 'Popup',
        visible: 'Visible',
        invisible: 'Invisible',
        delete_title: 'Deletion',
        delete_description_multiple: 'Are you sure you want to delete the selected items?',
        delete_description_single: 'Are you sure you want to delete this item?',
        toggle_visibility_error: 'Error toggling visibility',
        delete_error: 'Error deleting',
        fetch_error: 'An error occurred',
        all: 'All',
        columns: {
            title: 'Title',
            type: 'Type',
            description: 'Description',
            visibility: 'Visibility',
            actions: 'Actions',
            date: 'Dates',
        },
    },
    notifications_push: {
        title: 'Push Notifications',
        tabs: {
            current: 'Current',
            history: 'History',
        },
        status: {
            all: 'All',
            current: 'Current',
            history: 'History',
        },
        add: 'New Push Campaign',
        columns: {
            system_title: 'System Title',
            title_notif: 'Notification Title',
            description: 'Description',
            send_time: 'Send Time',
            end_date: 'Send date',
            updated_at: 'Updated At',
            send: 'Send',
            actions: 'Actions',
        },
        edit: 'Edit notification',
        general_info: 'General Information',
        system_title_label: 'Internal name',
        system_title_placeholder: 'Ex: October Promo',
        title_notif_label: 'Notification Title',
        title_notif_placeholder: '🎉 Flash offer: -20% today!',
        desc_notif_label: 'Message',
        description_placeholder: 'Ex: Take advantage of our exceptional promo until tonight. Book fast!',
        delete_modal: {
            title: 'Delete notification',
            message: 'Are you sure you want to delete this notification? This action is irreversible.',
        },
        messages: {
            delete_success: 'Notification deleted.',
            save_success: 'Notification saved successfully.',
            error: 'An error occurred.',
            submit_error: 'Error during submission.',
            delete_error: 'Error during deletion.',
            validation: {
                system_title_required: 'System title is required.',
                title_required: 'Title is required.',
                description_required: 'Description is required.',
                time_required: 'Time is required.',
                date_required: 'End date is required.',
            },
        },
    },
    blog: {
        title: 'Blog',
        add_article: 'Add article',
        no_img: 'No image',
        published: 'Published',
        unpublished: 'Unpublished',
        delete_title: 'Deletion',
        delete_description_multiple: 'Are you sure you want to delete the selected articles?',
        delete_description_single: 'Are you sure you want to delete this article?',
        toggle_publish_error: 'Error toggling publish status',
        delete_error: 'Error deleting',
        fetch_error: 'An error occurred while loading articles',
        columns: {
            title: 'Title',
            blogger: 'Author',
            categories: 'Categories',
            publish_at: 'Publish Date',
            status: 'Status',
            actions: 'Actions',
        },
        add_blog: 'Create article',
        edit_blog: 'Edit article',
        main_information: 'Main information',
        short_desc: 'Short description',
        content: 'Content',
        image: 'Illustration',
        seo_optimization: 'SEO Optimization',
        create_success: 'Article created successfully',
        select_categories: 'Select one or more categories',
        titles: {
            category: 'Categories',
        },
        faq: 'Frequently Asked Questions (FAQ)',
        no_faq: 'No FAQ added yet.',
        faq_item: 'Question',
        faq_question: 'Question',
        faq_answer: 'Answer',
        btn_add_faq: 'Add a FAQ',
        save_draft: 'Save draft',
        publish: 'Publish',
        add_category: 'Add a category',
        category_name: 'Category name',
        category_create_success: 'Category created successfully',
    },
    form_question: {
        title: 'Quote Requests',
        tabs: {
            entreprise: 'Company Form',
            anniversaire: 'Birthday Formula',
            evg: 'Stag/Hen Party Form',
        },
        columns: {
            full_name: 'Full Name',
            email: 'Email',
            phone: 'Phone',
            date: 'Date',
            actions: 'Actions',
        },
        delete_title: 'Deletion',
        delete_description_multiple: 'Are you sure you want to delete the selected items?',
        delete_description_single: 'Are you sure you want to delete this item?',
        delete_error: 'Error deleting',
        fetch_error: 'An error occurred',
    },
    forms: {
        activeOnSite: 'Form active on the website',
        inactiveOnSite: 'Form disabled',
        addNew: 'New form',
        addNewLimit: 'New form · {count}/{max}',
        maxForms: '3 forms maximum',
        deleteFormTitle: 'Delete the form?',
        deleteFormMessage: 'Are you sure you want to delete this form? This action is irreversible.',
        formDeleted: 'Form deleted successfully',
        formDeleteError: 'Error while deleting the form',
        formCreateError: 'Error while creating the form',
        formListError: 'Error while loading the forms',
        formDuplicated: 'Form duplicated successfully',
        formDuplicateError: 'Error while duplicating the form',
        menu: {
            rename: 'Rename',
            duplicate: 'Duplicate',
            disable: 'Disable form',
            enable: 'Enable form',
            delete: 'Delete',
            cannotDeleteLast: 'The last form cannot be deleted',
            soon: 'Coming soon',
            options: 'Form options',
        },
        status: {
            active: 'Active',
            inactive: 'Inactive',
        },
        questionsHeader: {
            order: 'Display order for the client',
            noneRequired: 'No required answers',
            requiredSummary: '{n} required question{plural} out of {total}',
        },
        question: {
            label: 'Question',
            intitule: 'Question title',
            typeLabel: 'Answer type',
            placeholderLabel: 'Placeholder',
            placeholderHint: 'Hint text shown in the answer field',
            collapse: 'Collapse',
            optionsTitle: 'Proposed answers',
            required: 'Required',
            requiredAnswer: 'Required answer',
            minChoicesPrefix: 'The customer must check at least',
            numberBetween: 'Allowed value between',
            and: 'and',
            characterUnit: 'character',
            answerUnit: 'answer',
            boundsRequired: 'Please set a minimum and a maximum value.',
            maxLengthRequired: 'Please set the maximum length.',
            optional: 'Optional',
            emptyTitle: 'Untitled',
            add: 'Add a question',
            placeholder: 'Ask a question…',
            helpPlaceholder: 'Add a help text…',
            options: 'Options',
            optionPlaceholder: 'Option {n}',
            addOption: 'Add an option',
            validations: 'Validations',
            minLength: 'Minimum length',
            maxLengthLabel: 'Maximum length',
            minValue: 'Minimum value',
            maxValue: 'Maximum value',
            minChoicesLabel: 'Minimum number of answers',
            minChoicesHelp: 'Minimum number of checkboxes required to validate the question',
            dateRange: 'Date range',
            dateSingle: 'Single date',
            dateFormatLabel: 'Format',
            forbidPast: 'Forbid past dates',
            experiencesTitle: 'Proposed experiences',
            experiencesHint: 'Check the configured experiences to offer to the customer.',
            experiencesLoading: 'Loading experiences…',
            experiencesRetry: 'Retry',
            experiencesEmpty: 'No configured experiences yet.',
            experiencesSelectAll: 'Select all',
            experiencesClear: 'Clear all',
            experiencesSearch: 'Search for an experience…',
            experiencesClearSearch: 'Clear search',
            experiencesNoResult: 'No experience matches this search.',
            help: 'Help',
            order: 'Order',
            moveUp: 'Move up',
            moveDown: 'Move down',
            duplicate: 'Duplicate',
            delete: 'Delete',
            locked: 'Protected field: cannot be modified or deleted',
            deleteConfirmTitle: 'Delete the question',
            deleteConfirmMessage: 'Are you sure you want to delete this question?',
            cancel: 'Cancel',
            newQuestion: 'New question',
            summary: {
                textShort: 'Short text',
                textLong: 'Long text',
                number: 'Number',
                single: 'Single choice',
                multiple: 'Multiple choice',
                dropdown: 'Dropdown list',
                dateSingle: 'Single date',
                dateRange: 'Date range',
                answers: '{n} answer{plural}',
                minChoices: 'min. {n}',
                maxLength: '{n} characters max.',
                pastDates: 'Past dates forbidden',
                minMax: '{min}–{max}',
            },
        },
        type: {
            title: 'Choose a question type',
            short: 'Short text',
            long: 'Long text',
            number: 'Number',
            radio: 'Single choice',
            checkbox: 'Multiple choice',
            select: 'Dropdown list',
            date: 'Date',
            experience: 'Experience',
            desc: {
                short: 'Single line answer',
                long: 'Multi line answer',
                number: 'Numeric answer',
                radio: 'One answer from a list',
                checkbox: 'Multiple possible answers',
                select: 'Choice from a dropdown',
                date: 'Date answer',
                experience: 'Choice from the configured experiences',
            },
        },
        presentation: {
            title: 'Form presentation',
            description: 'General description',
            descriptionSubtitle: 'Shown at the top of the form, before the first question.',
            descriptionPlaceholder:
                "Describe your project in a few lines, we'll get back to you within 48 h with a detailed quote.",
            image: 'Header image',
            imageHint: 'JPG, PNG or WebP · 1 Mo max.',
        },
        faq: {
            title: 'FAQ',
            subtitle: 'Frequently asked questions shown next to the form, in the order defined here.',
            question: 'Question',
            questionPlaceholder: 'Write a question…',
            answer: 'Answer',
            answerPlaceholder: 'Answer displayed below the question',
            add: 'Add a frequently asked question',
            newQuestion: 'New frequently asked question',
            delete: 'Delete',
            propose: '✨ Suggest questions',
            proposeSoon: 'Coming soon',
        },
        save: {
            label: 'Save',
            saving: 'Saving…',
            saved: 'Form saved',
            minMaxRequired: '"Number" questions: please set a minimum and maximum value — {labels}',
            minMaxIncoherent: '"Number" questions: the minimum value must be less than or equal to the maximum value — {labels}',
            maxLengthRequired: '"Long text" questions: please set the maximum length — {labels}',
            boundsMixedRequired: 'Please set the required values of the questions — {labels}',
        },
    },
    treatment: {
        step_label: 'Step',
        step1: {
            subtitle: 'General information',
            content: 'Create a treatment / discovery offer',
            namePlaceholder: 'Give a name to your package',
            descriptionLabel: 'Package description',
            descriptionPlaceholder: 'Describe your package (optional)',
            illustrationLabel: 'Illustration',
            nameRequired: 'This field is required',
            descriptionRequired: 'This field is required',
            saveError: 'Error saving general information',
        },
        notifications: {
            success_add: 'the treatment has been successfully added',
            success_update: 'the treatment has been successfully modified',
            validationStepFirst: 'Please validate the current step before continuing.',
        },
        step2: {
            subtitle: 'Pricing',
            content: 'Define the price of your treatment',
            price_label: 'Selling Price',
            vat_label: 'VAT Rate',
            price_ht_label: 'Price Excl. VAT',
            placeholder_select: 'Select...',
            validation: {
                price_required: 'Please define a selling price',
                vat_required: 'Please select a VAT rate',
            },
        },
        step3: {
            subtitle: 'Parameters',
            content: 'Configure rules and time parameters for the treatment',
            reservation_mode: 'Reservation Mode',
            utilisations_label: 'Number of uses',
            limit_period: 'Limit by period',
            limit_usage_period: 'Number of uses per period',
            limit_total_peak: 'Limit total number of peak hours',
            limit_total_off_peak: 'Limit total number of off-peak hours',
            limit_max_off_peak_per: 'Limit max usage of off-peak hours per period',
            limit_max_peak_per: 'Limit max usage of peak hours per period',
            allow_peak_for_off_peak: 'Allow using peak hours for off-peak hours',
            empty_state: 'No activity has been added yet.',
            add_activity: 'Add an activity',
            select_activities_title: 'Select your activities to compose your treatment',
            activity_label: 'Activity',
            duration_label: 'Duration',
            quantity_label: 'Quantity',
            options: {
                participant_label: 'Per Participant',
                participant_subtitle: 'The pass is sold per seat, each participant must have their own ticket.',
                space_label: 'Per Space',
                space_subtitle: 'The pass applies to the entire booked space, regardless of the number of participants.',
                week: 'Week',
                month: 'Month',
            },
            validation: {
                add_one_activity: 'Please add at least one activity',
                complete_all_activities: 'Please complete all activities',
            },
        },
        step4: {
            subtitle: 'Activities',
            content: 'Select your activities to compose the treatment',
            empty_state: 'No activity has been added yet.',
            add_activity: 'Add an activity',
            select_title: 'Select your activities to compose your treatment',
            activity_label: 'Activity',
            duration_label: 'Duration',
            quantity_label: 'Quantity',
            validation: {
                add_one_activity: 'Please add at least one activity',
                complete_all_activities: 'Please complete all activities',
            },
        },
        step5: {
            subtitle: 'Options',
            content: 'Configure visibility and ticketing options',
            visible_label: 'Make this treatment visible to my clients',
            undated_label: 'Offer this treatment as an undated ticket',
            visible_section: 'Online visibility and display',
            ticketing_section: 'Ticketing options',
            success_save: 'Treatment saved successfully',
            error_save: 'Error while finalizing the treatment',
        },
        preview: {
            live_preview: 'Live Preview',
            estimated_time: 'Estimated total time',
            minutes: 'minutes',
            hours_config: 'Hours Configuration',
            peak_hours: 'Peak hours',
            off_peak_hours: 'Off-peak hours',
            max_peak_hours: 'Max peak hours',
            max_off_peak_hours: 'Max off-peak hours',
            visible_online: 'Visible online',
            hidden_online: 'Hidden online',
            undated_ticket: 'Undated ticket',
            list_prestations: 'List of services:',
            nb_utilisations: 'Number of uses:',
        },
    },
    format: {
        23: '2:3',
        45: '4:5',
        169: '16:9',
        square: 'Square (1:1)',
        free: 'Free',
        portrait: 'Portrait (3:4)',
        landscape: 'Landscape (4:3)',
        facebookCover: 'Facebook Cover',
        circle: 'Circle',
    },
    customers: {
        title: 'Customers',
        title_single: 'a customer',
        add: 'Add',
        export: 'Export',
        import: 'Import',
        csv: 'CSV Format',
        excel: 'Excel Format',
        merge: 'Merge',
        columns: 'Update columns',
        unspecified: 'Unspecified',
        setPassword: 'Set password',
        caisse: 'Cash register',
        edit: 'Edit',
        delete: 'Delete',
        disable: 'Disable',
        enable: 'Enable',
        scheduleReservation: 'Schedule reservation',
        selectedItems: '{count} item{plural} selected',
        deleteSelection: 'Delete selection',
        deletePopupTitle: 'Delete customer(s)',
        deletePopupDescriptionSingle: 'Are you sure you want to delete this customer?',
        deletePopupDescriptionMultiple: 'Are you sure you want to delete {count} customer(s)?',
        disableConfirmTitle: 'Do you want to disable this customer?',
        enableConfirmTitle: 'Do you want to re-enable this customer?',
        disableSuccess: 'User successfully disabled',
        enableSuccess: 'User successfully enabled',
        fields: {
            id: 'Id',
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email Address',
            phone: 'Phone',
            birthday: 'Birthday',
            age: 'Age',
            gender: 'Gender',
            account: 'Account',
            client: 'Client',
            guest: 'Guest',
            origin: 'Origin',
            spent: 'Amount spent',
            loyaltyPoints: 'Loyalty points',
            firstComing: 'First coming',
            lastComing: 'Last coming',
            createdAt: 'Date added',
            actions: 'Actions',
            status: 'Status',
            communication: 'Communication',
            subscribed: 'Subscribed',
            unsubscribed: 'Unsubscribed',
            type_customer: 'Type',
            social_reason: 'Company',
        },
        confirmDelete: 'Are you sure you want to delete {name}?',
        deleteSuccess: 'User successfully deleted',
        deleteError: 'Error deleting user',
        exportSuccess: 'Export generated successfully.',
        exportError: 'An error occurred during export.',
        navigation: {
            customers: 'Customers',
            groups: 'Groups',
            billetsNonDatees: 'Undated tickets',
            subscriptions: 'Subscriptions & Packages',
            vouchers: 'Gift vouchers',
        },
        importModal: {
            title: 'Import a CSV file',
            subtitle: 'Make sure the columns are present and correctly filled before importing.',
            downloadTemplate: 'Download the CSV file template',
            csvOnly: 'For better performance, use files with less than 20,000 lines.',
            analyzing: 'Analyzing file…',
            reviewTitle: 'Review before import —',
            ready: '{count} ready',
            autofilled: '{count} auto-completed (check before validating)',
            duplicates: '{count} duplicates',
            existing: '{count} already existing',
            totalLines: '(out of {count} lines)',
            cancel: 'Cancel',
            importing: 'Importing…',
            validateImport: 'Validate import ({count})',
            importInProgress: 'Import in progress…',
            flaggedRowsLabel: 'Auto-completed rows — correct if needed before validating:',
            colLine: 'Line',
            colFirstName: 'First name',
            colLastName: 'Last name',
            colEmail: 'Email',
            colPhone: 'Phone',
            colCompleted: 'Completed',
            importSuccess: 'Import completed successfully!',
            created: 'Customers created',
            alreadyExisting: 'Already existing',
            doublons: 'Duplicates',
            totalImported: 'Total lines',
            errorsLine: '{count} line(s) with errors (click to view)',
            close: 'Close',
            downloadError: 'Unable to download the template.',
        },
    },
    groups: {
        title: 'Groups',
        addTitle: 'Add a customer group',
        editTitle: 'Edit customer group',
        add: 'Add',
        export: 'Export',
        csv: 'CSV Format',
        excel: 'Excel Format',
        status: 'Status',
        active: 'Active',
        inactive: 'Inactive',
        name: 'Name',
        owner: 'Owner',
        customersCount: 'Customers count',
        actions: 'Actions',
        edit: 'Edit',
        delete: 'Delete',
        disable: 'Disable',
        disableConfirmTitle: 'Do you want to disable this group?',
        disableSuccess: 'Group successfully disabled',
        disableError: 'Error disabling group',
        enableSuccess: 'Group successfully enabled',
        enableConfirmTitle: 'Do you want to re-enable this group?',
        selectedItems: '{count} item{plural} selected',
        deleteSelection: 'Delete selection',
        deletePopupTitle: 'Delete group(s)',
        deletePopupDescriptionSingle: 'Are you sure you want to delete this group?',
        deletePopupDescriptionMultiple: 'Are you sure you want to delete {count} group(s)?',
        loadError: 'Unable to load groups.',
        exportError: 'An error occurred during export.',
        exportSuccess: 'Export generated successfully.',
        deleteSuccess: 'Group successfully deleted',
        deleteError: 'Error deleting group',
    },
    voucher: {
        title: 'Gift vouchers',
        add: 'Add',
        export: 'Export',
        columns: 'Columns',
        csv: 'CSV Format',
        excel: 'Excel Format',
        status: 'Status',
        all_status: 'All statuses',
        status_active: 'Active',
        status_used: 'Used',
        status_expired: 'Expired',
        status_blocked: 'Blocked',
        status_partially_used: 'Partially used',
        code: 'Code',
        gifted_by: 'Gifted by',
        gifted_to: 'Beneficiary',
        beneficiary: 'Beneficiary',
        send_date: 'Availability',
        availability: 'Availability',
        used_at: 'Date of use',
        date_end: 'Expiration date',
        total_amount: 'Amount',
        available_amount: 'Balance',
        actions: 'Actions',
        edit: 'Edit',
        history: 'History',
        delete: 'Delete',
        selectedItems: '{count} item{plural} selected',
        deleteSelection: 'Delete selection',
        deletePopupTitle: 'Delete gift voucher(s)',
        deletePopupDescriptionSingle: 'Are you sure you want to delete this gift voucher?',
        deletePopupDescriptionMultiple: 'Are you sure you want to delete {count} gift voucher(s)?',
        loadError: 'Unable to load gift vouchers.',
        exportError: 'An error occurred during export.',
        exportSuccess: 'Export generated successfully.',
        downloadSelection: 'Download',
        cancelSelection: 'Cancel',
        bulkDownloadSuccess: 'Voucher download has been successfully scheduled.',
        bulkDownloadError: 'An error occurred while downloading the vouchers.',
        enable: 'Enable',
        disable: 'Disable',
        resend: 'Resend by email',
        download: 'Download PDF',
        enablePopupTitle: 'Enable gift voucher',
        disablePopupTitle: 'Disable gift voucher',
        enablePopupDescription: 'Are you sure you want to enable this gift voucher?',
        disablePopupDescription: 'Are you sure you want to disable this gift voucher?',
        resendSuccess: 'Email resent successfully.',
        resendError: 'Error while resending email.',
        statusUpdateSuccess: 'Status updated successfully.',
        statusUpdateError: 'Error while updating status.',
        client: 'customer',
        send_title: 'Resend email',
        general_info: 'General information',
        resend_to_buyer: 'Resend to buyer',
        resend_to_recipient: 'Resend to recipient',
        buyer_email: "Buyer's email",
        buyer_email_placeholder: "Enter buyer's email",
        recipient_email: "Recipient's email",
        recipient_email_placeholder: "Enter recipient's email",
        message_optional: 'Your message (optional)',
        message_placeholder: 'Please fill in',
        updateSuccess: 'Gift voucher updated successfully.',
        updateError: 'Error updating gift voucher.',
        edit_title: 'Edit gift voucher',
        from_first_name: "Buyer's first name",
        from_last_name: "Buyer's last name",
        from_email: "Buyer's email",
        to_email: "Recipient's email",
        from_message: "Buyer's message",
    },
    billetNonDate: {
        title: 'Undated tickets',
        add: 'Add',
        export: 'Export',
        columns: 'Update columns',
        csv: 'CSV Format',
        excel: 'Excel Format',
        status: 'Status',
        all_status: 'All statuses',
        status_active: 'Active',
        status_used: 'Used',
        status_expired: 'Expired',
        status_blocked: 'Blocked',
        status_partially_used: 'Partially used',
        code: 'Code',
        gifted_by: 'Gifted by',
        gifted_to: 'Beneficiary',
        beneficiary: 'Beneficiary',
        send_date: 'Availability',
        availability: 'Availability',
        date_end: 'Expiration date',
        total_amount: 'Amount',
        available_amount: 'Balance',
        actions: 'Actions',
        edit: 'Edit',
        history: 'History',
        delete: 'Delete',
        selectedItems: '{count} item{plural} selected{plural}',
        deleteSelection: 'Delete selection',
        deletePopupTitle: 'Delete undated ticket(s)',
        deletePopupDescriptionSingle: 'Are you sure you want to delete this undated ticket?',
        deletePopupDescriptionMultiple: 'Are you sure you want to delete {count} undated ticket(s)?',
        loadError: 'Unable to load undated tickets.',
        exportError: 'An error occurred during export.',
        exportSuccess: 'Export generated successfully.',
        bulkDownloadSuccess: 'Voucher download has been successfully scheduled.',
        enable: 'Enable',
        disable: 'Disable',
        resend: 'Resend by email',
        download: 'Download PDF',
        resendSuccess: 'Email resent successfully.',
        resendError: 'Error while resending email.',
        statusUpdateSuccess: 'Status updated successfully.',
        statusUpdateError: 'Error updating status.',
        no_items: 'No items linked.',
        unnamed_item: 'Item',
        generate_invoice: 'Generate invoice',
        items: 'Contents',
        client: 'Client',
        import_note: 'Import note',
        edit_title: 'Edit undated tickets',
        from_first_name: "Buyer's first name",
        from_last_name: "Buyer's last name",
        from_email: "Buyer's email",
        from_message: "Buyer's message",
        to_first_name: "Recipient's first name",
        to_last_name: "Recipient's last name",
        to_email: "Recipient's email",
        created_at: 'Creation date',
        used_at: 'Usage date',
        enablePopupTitle: 'Re-enable undated ticket',
        disablePopupTitle: 'Block undated ticket',
        enablePopupDescription: 'Are you sure you want to re-enable this undated ticket?',
        disablePopupDescription: 'Are you sure you want to block this undated ticket?',
        bulkDownloadError: 'An error occurred while downloading the undated tickets.',
        downloadSelection: 'Download',
        cancelSelection: 'Cancel',
    },
    treatment_customer: {
        title: 'Subscriptions & Packages',
        export: 'Export',
        csv: 'CSV Format',
        excel: 'Excel Format',
        all_active: 'Active',
        archived: 'Archived',
        user_name: 'Customer',
        treatment_name: 'Offer',
        quantity_left: 'Remaining quantity',
        prestations_qty: 'Total quantity',
        loadError: 'Unable to load data.',
        exportError: 'An error occurred during export.',
        exportSuccess: 'Export generated successfully.',
        deleteSuccess: 'Item successfully disabled',
        deleteError: 'Error disabling item',
        deletePopupTitle: 'Disable',
        deletePopupDescription: 'Are you sure you want to disable this item?',
        selectedItems: '{count} item{plural} selected',
        cancelSelection: 'Cancel selection',
        disable: 'Disable',
    },
    datatable: {
        search: 'Search...',
        show: 'Show',
        entries: 'entries',
        noData: 'No data available',
        loading: 'Loading...',
        first: 'First',
        previous: 'Previous',
        next: 'Next',
        last: 'Last',
        showing: 'Showing',
        to: 'to',
        of: 'of',
        filtered: '(filtered from {total} total entries)',
        error: 'Error loading data',
        columns: {
            visible: 'Visible Columns',
            apply: 'Apply',
        },
        bulk_actions: 'Bulk Actions',
        modal: {
            title: 'Confirm Deletion',
            message: 'Are you sure you want to delete the selected items?',
            cancel: 'Cancel',
            confirm: 'Delete',
        },
    },
    resource_planning: {
        holiday: {
            title: 'Holiday Hours',
            description: 'Configure special hours for holiday periods',
            add_button: 'Add Holiday Hours',
            save: 'Save Holiday Hours',
            add_holiday: 'Add Holiday Hours',
            edit_holiday: 'Edit Holiday Hours',
            no_holidays: 'No Holiday Hours',
            no_holidays_description: 'No holiday hours have been configured yet.',
        },
        tabs: {
            regular: 'Regular Planning',
            holiday: 'Holiday Hours',
            exceptions: 'Temporary Closures',
        },
        subcards: {
            title: 'Opening Hours',
            description: 'Define your opening hours and closing periods.',
            regular: {
                title: 'Regular Hours',
                description: 'Define your opening slots for each day.',
            },
            holiday: {
                title: 'Closing Periods',
                description: 'Add holidays and exceptional closures.',
            },
            exceptions: {
                title: 'Public Holidays',
                description: 'Indicate your opening on public holidays.',
            },
        },
        break: 'Break',
        add_break: 'Add a break',
        remove_break: 'Remove break',
        start_time: 'Start Time',
        end_time: 'End Time',
        loading: 'Loading schedule...',
        save_success: 'Schedule saved successfully',
        week_number: 'Week',
        unplanned_hours: 'Unplanned',
        lunch_break: 'Lunch Break',
        title: 'Opening Hours',
        recap: 'Recap',
        closed: 'Closed',
        week_days: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday',
        },
        week_days_schedule: {
            mon: 'Mon',
            tue: 'Tue',
            wed: 'Wed',
            thu: 'Thu',
            fri: 'Fri',
            sat: 'Sat',
            sun: 'Sun',
        },
        weekRangeScheduling: {
            title: 'Week Range Scheduling',
            period_label: 'Period Name',
            period_placeholder: 'Enter a name for this range',
            date_begin_label: 'Start Date',
            date_end_label: 'End Date',
            period_date_placeholder: 'dd/mm/yyyy',
        },
        scheduling_temporary_closures: {
            all_day_title: 'All Day',
            time_slot_title: 'Time Slot',
            close_label: 'Closure Title',
            close_placeholder: 'Easter Holidays',
            color_label: 'Color',
            hour_begin_label: 'Start Time',
            hour_end_label: 'End Time',
            reason_label: 'Reason',
            reason_placeholder: 'Select a reason',
            closure_color: {
                red: 'Red',
                blue: 'Blue',
                green: 'Green',
                orange: 'Orange',
                purple: 'Purple',
                pink: 'Pink',
                cyan: 'Cyan',
                yellow: 'Yellow',
                gray: 'Gray',
                dark_blue: 'Dark Blue',
            },
            hour_peack_begin_label: 'Off-peak start time',
            hour_peack_end_label: 'Off-peak end time',
        },
        reasons: {
            works: 'Works',
            maintenance: 'Maintenance',
            exceptional_closure: 'Exceptional Closure',
            team_meeting: 'Team Meeting',
            private_event: 'Private Event',
            breakdown: 'Breakdown',
        },
        errors: {
            no_data: 'No schedule data to save',
            save_error: 'An error occurred while saving the schedule',
            update_error: 'Failed to update the schedule. Please try again.',
            invalid_time_range: 'Invalid time range for {day}: end time must be after start time',
            invalid_lunch_range: 'Invalid lunch break time for {day}: end time must be after start time',
            lunch_outside_work_hours: 'Lunch break for {day} must be within working hours',
        },
        schedule_updated: 'Schedule updated successfully',
        error_updating_schedule: 'Error updating the schedule',
        exceptions: {
            title: 'Temporary Closures',
            description: 'Manage exceptions to your regular schedule',
            add_button: 'Add an Exception',
            add_exception: 'Schedule Temporary Closures',
            set_special_hours: 'Set Special Hours',
            edit_exception: 'Edit Closure',
            establishment: 'Establishment',
            establishment_id: 'Establishment ID',
            establishment_id_placeholder: 'Enter the establishment ID',
            status: 'Status',
            period: 'Period',
            start_date: 'Start Date',
            end_date: 'End Date',
            quick_select: 'Quick Select',
            today: 'Today',
            month: 'Month',
            day: 'day',
            tomorrow: 'Tomorrow',
            this_week: 'This Week',
            next_week: 'Next Week',
            this_weekend: 'This Weekend',
            next_weekend: 'Next Weekend',
            next_month: 'Next Month',
            all_day: 'All Day',
            specific_hours: 'Specific Hours',
            start_time: 'Start Time',
            end_time: 'End Time',
            notes: 'Notes',
            notes_placeholder: 'Add notes about this exception',
            save: 'Save Exception',
            cancel: 'Cancel',
            exceptions: 'Schedule Temporary Closures',
            exceptions_description: 'Manage schedule exceptions for specific days',
            no_exceptions: 'No Exceptions Found',
            no_exceptions_description: 'No schedule exceptions have been configured yet.',
            exception_types: {
                open: 'Open',
                open2: 'Opening',
                closed: 'Closed',
                close: 'Closure',
                by_appointment: 'By Appointment',
                special_hours: 'Special Hours',
                temporarily_closed: 'Temporarily Closed',
                works: 'Works',
                holiday: 'Holiday',
                breakdown: 'Breakdown',
                maintenance: 'Maintenance',
                training: 'Training',
                special_event: 'Special Event',
            },
            status_options: {
                0: {
                    title: 'Inactive',
                    description: 'The exception is not active',
                },
                1: {
                    title: 'Active',
                    description: 'The exception is currently active',
                },
                2: {
                    title: 'Archived',
                    description: 'The exception is archived',
                },
            },
            preview: 'Preview',
            confirm_delete: 'Confirm Deletion',
            confirm_delete_message: 'Are you sure you want to delete this exception?',
            save_success: 'Exception saved successfully',
            save_error: 'Error while saving the exception',
            delete_success: 'Exception deleted successfully',
            create_success: 'Exception created successfully',
            update_success: 'Exception updated successfully',
            delete_error: 'Error while deleting the exception',
            validation: {
                establishment_required: 'Establishment ID is required',
                status_required: 'Status is required',
                start_date_required: 'Start date is required',
                start_heure_required: 'Start time is required',
                end_date_required: 'End date is required',
                end_heure_required: 'End time is required',
                selected_days_required: 'Days is required',
                end_date_after_start: 'End date must be after start date',
            },
        },
    },
    PlanningRegulier: {
        title: 'Custom Hours',
        description:
            'Customize the hours you want to display on your site. You can mention special cases such as opening on request, privatization or any other specific operation. The entered text will be displayed as is.',
        ctaButton: 'Custom Hours',
        toggleLabel: 'Display these custom hours on the booking site',
        tableHeader: 'Hours',
        inputPlaceholder: 'Ex: Closed, 9am - 6pm',
        backButton: '← Back',
        saveButton: 'Save My Hours',
        notifications: {
            loadError: 'Unable to load custom hours.',
            saveSuccess: 'Hours saved successfully.',
            saveErrorDefault: 'An error occurred while saving.',
        },
    },
    configuration: {
        stripeSetup: {
            fields: {
                stripeStatus: {
                    label: 'Enable Stripe',
                    description: 'Enable this option to accept online payments via Stripe.',
                },
                stripeMode: {
                    label: 'Stripe Mode',
                    description: 'Use test mode for testing and production mode for real transactions.',
                    options: {
                        production: {
                            label: 'Production',
                            description: 'Real transactions with your customers.',
                        },
                        sandbox: {
                            label: 'Test',
                            description: 'Test mode, no real transactions.',
                        },
                    },
                },
                stripeKey: {
                    label: 'Public Key',
                    placeholder: 'pk_live_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
                },
                stripeSecret: {
                    label: 'Secret Key',
                    placeholder: 'sk_live_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
                    helper: 'Your secret key is encrypted, securely stored, and never shared.',
                },
                klarna: {
                    label: 'Enable Klarna',
                    link: 'https://www.youtube.com/watch?v=T5FM2X4G_Kw',
                },
                applePay: {
                    label: 'Enable Apple Pay',
                    link: 'https://www.youtube.com/watch?v=J4MJsC6C5Ng',
                },
                googlePay: {
                    label: 'Enable Google Pay',
                    link: 'https://www.youtube.com/watch?v=KChUrPf8UdE',
                },
                howToActivateGoogleApplePay: {
                    label: 'How to enable Google Pay / Apple Pay?',
                    link: 'https://www.youtube.com/watch?v=KChUrPf8UdE',
                },
                stripeSharedPayment: {
                    label: 'Enable shared payments',
                    description: 'Allow your customers to share the payment of a reservation among themselves.',
                },
            },
            errors: {
                invalidLivePublishableKey: 'Invalid Live Publishable Key (must start with pk_live_)',
                invalidLiveSecretKey: 'Invalid Live Secret Key (must start with sk_live_)',
                invalidTestPublishableKey: 'Invalid Test Publishable Key (must start with pk_test_)',
                invalidTestSecretKey: 'Invalid Test Secret Key (must start with sk_test_)',
                invalidStatus: 'Invalid Stripe configuration',
            },
            security: {
                ipRestriction: {
                    title: 'Important: Restrict your Stripe API key by IP address',
                    description:
                        'To protect your Stripe account against unauthorized use, go to your Stripe Dashboard > Developers > API Keys, then click "Manage IP restrictions" on your Secret Key and add the server IP below.',
                    serverIp: 'Server IP (copy and add to Stripe)',
                },
            },
        },
        reservationCancellationRulesForm: {
            nav: {
                reservation: 'Reservation',
                cancellation: 'Cancellation',
                modification: 'Modification',
            },
            sections: {
                reservation: {
                    title: 'Reservation',
                    autoConfirmation: {
                        label: 'Automatic confirmation',
                        description: 'Reservations are confirmed automatically, without validation on your part.',
                        messageBox:
                            'Each request must be manually approved. The customer will receive a confirmation email (including a payment link, if enabled) once the request has been accepted.',
                    },
                    minTime: {
                        label: 'Minimum time before reservation',
                        description: 'The customer cannot book less than X hours before the slot.',
                        suffix: 'hours',
                    },
                    basketLock: {
                        label: 'Basket blocking duration',
                        description: 'The slot is released if the reservation is not completed within the given time.',
                        suffix: 'minutes',
                        error: 'The value must be greater than or equal to 5 minutes.',
                    },
                    bankImprint: {
                        label: 'Bank imprint release delay',
                        description: 'The imprint is released after this delay if the reservation does not proceed.',
                        suffix: 'hours',
                    },
                    transparency: {
                        label: 'Customer display (Transparency)',
                        options: {
                            displayCancellationPolicy: {
                                label: 'Display the cancellation policy on the booking page',
                                description: 'Displays a clear explanation of your cancellation rules at the time of booking.',
                            },
                            joinConditions: {
                                label: 'Attach conditions to confirmation emails',
                                description:
                                    'Terms and conditions or cancellation conditions are automatically attached to emails.',
                            },
                            displayImprintInformation: {
                                label: 'Display bank imprint or deposit information',
                                description:
                                    'Indicates to the customer that a bank imprint or deposit is required, if applicable.',
                            },
                        },
                        placesDisponibles: 'Display available places for clients (activities)',
                    },
                },
                cancellation: {
                    title: 'Cancellation',
                    byCustomer: {
                        label: 'Allow cancellation by the customer',
                        description: 'The customer can cancel their reservation online.',
                    },
                    tiers: {
                        title: 'Refund tiers',
                        description:
                            'Portion refunded to the customer based on the cancellation date. Ex: 20% refunded, you keep 80%.',
                        columnDelay: 'Cancellation delay',
                        columnPercent: '% refunded',
                        prefixDays: 'J \u2212',
                        suffixPercent: '%',
                        deleteTitle: 'Delete the tier',
                        addTier: 'Add a tier',
                    },
                },
                modification: {
                    title: 'Modification',
                    enabled: {
                        label: 'Allow modification by the customer',
                        description: 'The customer can modify their reservation online.',
                    },
                    deadline: {
                        label: 'Modification deadline',
                        description: 'After this delay, the reservation can no longer be modified.',
                        suffix: 'days',
                    },
                    complement: {
                        title: 'Higher amount \u2014 difference payment',
                        description: 'The customer pays the difference \u2014 credit card as priority.',
                        options: {
                            stripe: 'Credit card (via Stripe)',
                            wallet: 'Wallet',
                            voucher: 'Gift voucher',
                        },
                        error: 'At least one payment method must be selected.',
                    },
                    refund: {
                        title: 'Lower amount \u2014 refund of the difference',
                        description: 'Refund method',
                        keepOriginal: {
                            label: 'Prefer the original payment method',
                            description: 'The refund is made using the same method that was used to pay for the reservation.',
                        },
                        fallback: 'If refund using the original payment method is not possible',
                        options: {
                            wallet: 'Wallet',
                            voucher: 'Gift voucher',
                        },
                        error: 'At least one refund method must be selected.',
                    },
                },
            },
        },
        title: 'Settings',
        subtitle: '',
        description: '',
        infoMessage: 'You have filled only 45% of your space.',
        cards: {
            establishment: {
                title: 'Establishment',
                description: 'Fill in all the basic information about your establishment.',
                button: 'Access',
            },
            schedule: {
                title: 'Opening Hours',
                description: 'Set your opening hours and closure periods.',
                button: 'Access',
                editDayTitle: 'Edit Schedule',
            },
            billing: {
                title: 'Billing & Payments',
                description: 'Select the payment methods you wish to offer your customers.',
                button: 'Access',
            },
            legal: {
                title: 'Legal, GDPR & CSR',
                description: 'Enter your legal and compliance information.',
                button: 'Access',
            },
            rules: {
                title: 'Reservation Rules',
                description: "Define your establishment's reservation conditions.",
                button: 'Access',
            },
            booklet: {
                title: 'Quotes & Welcome Booklets',
                description: 'Fill in all the basic information about your establishment',
                button: 'Access',
            },
        },
        integration: {
            title: 'Applications',
            apiKey: 'API Key',
            secretKey: 'Secret Key',
            authUrl: 'Authentication (optional)',
            baseUrl: 'Base URL',
            token: 'Token',
            secret: 'Secret',
            apiKeyPlaceholder: 'Public API Key',
            tokenPlaceholder: 'Your access token',
            authUrlPlaceholder: 'Authentication URL',
            success: 'Settings updated successfully',
            error: 'An error occurred during the update',
            activationError: 'Impossible to activate the integration because the form is empty.',
            noSettings: 'No settings available for this integration.',
            notAvailable: 'Settings not available for this integration.',
            karafunDesc: 'Integrate Karafun to manage your karaoke sessions.',
            googleDesc: 'Sync your bookings with Google Calendar.',
            googleCalendarParams: 'Google Calendar Notification Settings',
            authorizeGoogle: 'Authorize Google Calendar',
            googleConnected: 'Connected to Google Calendar',
            linkAnotherAccount: 'Link another account',
            selectRolesToNotify: 'Select roles to notify',
            selectRolesPlaceholder: 'Select roles...',
            noRoleSelectedHint: 'No role selected: events will not be shared with anyone.',
            mailjet: 'Mailjet',
            mailjetDesc: 'Configure Mailjet to send your transactional and marketing emails.',
            mailjetApiKeyPlaceholder: 'Your Mailjet API Key',
            mailjetSecretKeyPlaceholder: 'Your Mailjet Secret Key',
            sendTestEmail: 'Test configuration',
            testAndSave: 'Test and save',
            testEmailSending: 'Connection test in progress…',
            testEmailSuccess: 'Connection to Mailjet successful',
            testEmailError: 'Connection failed — check your keys',
            mailjetSecretKeyHelper: 'Available in your Mailjet account, under "API Settings".',
            keyAlreadyConfigured: 'Key already configured — leave blank to keep it',
            modification_success: 'Modification successful',
            geminiDesc: 'Use Gemini AI to generate and improve your content.',
            karafun: 'Karafun',
            google: 'Google',
            gemini: 'Gemini',
            mcp: 'AI assistant (MCP)',
            mcpDesc: 'Connect Claude, ChatGPT or Claude Desktop to your venue.',
            mcpUrlTitle: 'Your MCP server address',
            mcpUrlHint: 'This address is specific to your venue. Paste it into your AI assistant.',
            mcpTokenTitle: 'Access token',
            mcpTokenHint:
                'The token gives the assistant exactly your permissions, no more. It is valid for {days} days and can be revoked at any time.',
            mcpTokenNamePlaceholder: 'Token name (e.g. "Claude — front desk")',
            mcpGenerate: 'Generate a token',
            mcpTokenOnce: 'Copy this token now: it will never be shown again.',
            mcpCopy: 'Copy',
            mcpCopied: 'Copied',
            mcpCopyError: 'Copy failed — please select the text manually.',
            mcpActiveTokens: 'Active tokens',
            mcpColAccess: 'Access',
            mcpAccessRead: 'Read only',
            mcpAccessReadWrite: 'Read + write',
            mcpAccessReadHint:
                'Read only: the assistant can read your data but cannot propose any change. Recommended for a widget or a dashboard.',
            mcpAccessReadWriteHint:
                'Read + write: the assistant can also propose changes (note, customer, rescheduling, prices), to be confirmed by a person in the back-office.',
            mcpColName: 'Name',
            mcpColOwner: 'Created by',
            mcpColLastUsed: 'Last used',
            mcpColExpires: 'Expires on',
            mcpNever: 'Never',
            mcpExpired: 'Expired',
            mcpRevoke: 'Revoke',
            mcpConfirmRevoke: 'Confirm?',
            mcpHowToTitle: 'How to connect your assistant',
            mcpClaudeStep1: 'Open claude.ai → Settings → Connectors → Add custom connector.',
            mcpClaudeStep2: 'Paste this as the MCP server URL:',
            mcpClaudeStep3: 'Leave Authentication set to "None".',
            mcpClaudeStep4:
                'Add a custom header named x-api-key with the token as its value. claude.ai does not allow the header',
            mcpBearerHint: 'These clients accept the standard header: use the same URL with the token as a Bearer.',
            mcpYourToken: 'your token',
            field_required: 'This field is required',
        },
        inlineCards: {
            general: {
                title: 'General Information',
                description: 'Enter the legal and visible information of your establishment to get started.',
            },
            tax: {
                title: 'Tax Information',
                description: 'Declare your tax information to ensure compliant billing.',
            },
            headOffice: {
                title: 'Head Office Address',
                description: 'Enter the legal administrative address of your company.',
            },
            location: {
                title: 'Establishment Address',
                description: 'Provide the physical address of your establishment to help your customers find you easily.',
            },
            contacts: {
                title: 'Establishment Contact Details',
                description: 'Add contact methods for your customers and your team.',
            },
            billing: {
                title: 'Accepted Payment Methods',
                description:
                    'Select the payment methods to offer your customers (visible during online bookings and at checkout).',
            },
            stripeSetup: {
                title: 'Stripe Setup',
                description:
                    'Collect payments from your customers via card, Apple Pay, Google Pay, and more — via Stripe, our secure payment partner.',
            },
            paymentPrepaidSolutions: {
                title: 'Configuration of Your Prepaid Solutions',
                description: 'Configure the use of your gift vouchers, packages, subscriptions, undated tickets.',
            },
            deposit: {
                title: 'Deposit',
                description: 'Define whether your customers must pay a deposit.',
            },
            billingPolicy: {
                title: 'Billing Policy',
                description: 'Automate the generation and tracking of your invoices.',
            },
            devis: {
                title: 'Quote Policy',
                description: 'Manage the configuration of your quotes.',
            },
            bankDetails: {
                title: 'Bank Details (RIB)',
                description: 'Enter your bank information for payments by transfer.',
            },
            wallet: {
                title: 'Electronic Wallet',
                description: 'Offer an electronic wallet system to your customers.',
            },
            loyaltyProgram: {
                title: 'Loyalty Program',
                description: 'Reward your customers with a loyalty points system.',
            },
            invoiceFooter: {
                title: 'Invoice Footer',
                description: 'Customize the legal message displayed on all your invoices.',
            },
        },
        generalInformation: {
            fields: {
                establishmentName: {
                    label: 'Establishment Name',
                    description: 'Publicly known name if different from the legal business name.',
                    placeholder: 'The Adventure X Passion',
                    requiredError: 'Establishment name is required',
                },
                companyName: {
                    label: 'Company Name',
                    description: 'Legal name of your company.',
                    placeholder: 'ADVENTURE GROUP SAS',
                    requiredError: 'Company name is required',
                },
                legalForm: {
                    label: 'Legal Form',
                    description: '',
                    requiredError: 'Legal form is required',
                },
                registrationNumber: {
                    label: 'Registration Number',
                    description: 'Official identification number (SIREN, ICE...).',
                    placeholder: '80345678000015',
                    requiredError: 'Registration number is required',
                },
                activityCode: {
                    label: 'Activity Code',
                    description: 'APE / NAF code or equivalent.',
                    placeholder: 'APE 9329Z',
                },
                socialCapital: {
                    label: 'Share Capital',
                    description: 'Amount of capital declared when the company was created.',
                    placeholder: '5000',
                },
                officialWebsite: {
                    label: 'Official Website',
                    placeholder: 'https://www.my-site.com',
                },
                officialWebsiteActive: {
                    label: 'Official Website Active',
                    description: 'Enable this option to display the official website of your establishment.',
                },
                logo: {
                    label: 'Establishment Logo',
                    description: 'Square image 512*512 (1MB/JPG)',
                    requiredError: 'Establishment logo is required',
                },
            },
            legalFormOptions: {
                SAS: 'SAS',
                SARL: 'SARL',
                EI: 'EI',
                EURL: 'EURL',
                SA: 'SA',
                SNC: 'SNC',
                SCS: 'SCS',
                MICRO: 'Micro-enterprise',
            },
        },
        tax: {
            fields: {
                legalAddress: {
                    label: 'Tax Information',
                    description: 'Enter the legal address of your company.',
                    placeholder: '',
                },
                country: {
                    label: 'Country of Registration',
                    description: 'Select the country where your company is registered.',
                },
                vatApplicable: {
                    label: 'Do you invoice with VAT?',
                    description: 'Indicate if you apply VAT on your invoices.',
                    options: {
                        yes: 'Yes',
                        no: 'No',
                    },
                },
                vatNumber: {
                    label: 'VAT Number',
                    description: 'Enter your intra-community or national VAT number (if applicable).',
                    placeholder: 'FR12345678901',
                },
                currency: {
                    label: 'Billing Currency',
                    description: 'Choose the main currency used for issuing your invoices.',
                },
            },
        },
        contacts: {
            formDescription: 'Contact methods.',
            fields: {
                email_contact_client: {
                    label: 'Email for your customers.',
                    description: 'Used for sending confirmations, reminders and cancellations to your customers.',
                    placeholder: 'contact@your-company.com',
                },
                email: {
                    label: 'Email for the administrator.',
                    description: 'This contact will receive technical alerts and reports.',
                    placeholder: 'admin@your-company.com',
                },
                phone_number: {
                    label: 'Main Phone Number',
                    description: 'Phone number that customers can call.',
                    placeholder: '+33 1 23 45 67 89',
                },
                phone_number2: {
                    label: 'Secondary Phone Number',
                    description: 'Backup line or for internal use.',
                    placeholder: '+33 1 23 45 67 89',
                },
                phone_number_whatsapp: {
                    label: 'WhatsApp Number',
                    description: 'To chat with your customers on WhatsApp.',
                    placeholder: '+33 1 23 45 67 89',
                },
            },
            errors: {
                email_contact_client: {
                    required: 'Customer contact email is required',
                    invalid: 'Invalid email format',
                },
                email: {
                    required: 'Administrator contact email is required',
                    invalid: 'Invalid email format',
                },
                phone_number: {
                    required: 'Main phone number is required',
                    invalid: 'Invalid phone number format',
                },
                phone_number2: {
                    invalid: 'Invalid phone number format',
                },
                phone_number_whatsapp: {
                    invalid: 'Invalid WhatsApp number format',
                },
            },
            visibilityBox: {
                title: 'Do you want to display your phone numbers to customers?',
                description: '(You can choose to hide them if you prefer)',
                help: 'Phone Number Confidentiality',
                options: {
                    show: {
                        label: 'Yes, display the numbers',
                        desc: 'They will be visible in emails, quotes, invoices and on your website.',
                        emails: 'emails sent to customers',
                        pdf: 'quotes and invoices (PDF)',
                        booklets: 'welcome booklets',
                        website: 'the website and widgets',
                    },
                    hide: {
                        label: 'No, hide the numbers',
                        desc: 'They will not be visible anywhere. They will only be used internally.',
                        emails: 'all customer emails',
                        pdf: 'quotes, invoices and PDF booklets',
                        website: 'the website and any customer-facing material',
                        whatsapp: 'WhatsApp buttons or links',
                    },
                },
            },
        },
        locationForm: {
            fields: {
                address: {
                    label: 'Establishment Address',
                    description: '(Number and street, locality, etc.)',
                    placeholder: '12 Result Street',
                },
                complement: {
                    label: 'Address Complement',
                    description: '(Building, floor, P.O. box…)',
                    placeholder: 'Building A - 3rd floor',
                },
                city: {
                    label: 'City',
                    placeholder: 'Champagneux',
                },
                postalCode: {
                    label: 'Postal Code',
                    placeholder: '73240',
                },
                country: {
                    label: 'Country',
                },
                timezone: {
                    label: 'Time Zone',
                    description: 'Time zone of your establishment',
                },
                language: {
                    label: 'Language',
                },
                isSameBillingAddress: {
                    label: 'Is the billing address the same as the head office address?',
                    description:
                        'If you select "Yes", the establishment address will be automatically taken from the head office address. This saves you from having to enter it a second time.',
                },
            },
            interactiveMap: {
                label: 'Interactive Map',
                description: 'Position your establishment on the map to help your customers find you easily.',
            },
            errors: {
                addressRequired: 'Address is required',
                cityRequired: 'City is required',
                postalCodeRequired: 'Postal code is required',
                countryRequired: 'Country is required',
                timezoneRequired: 'Time zone is required',
            },
        },
        colorPalette: {
            predefinedTitle: 'Predefined Palettes',
            selectPaletteLabel: 'Select a palette:',
            separator: 'OR',
            customTitle: 'Color Picker',
            customDescription: 'Customize your color by choosing a specific code according to your preferences.',
            palettes: {
                ocean_frais: 'Fresh Ocean',
                foret_profonde: 'Deep Forest',
                energie_vive: 'Vivid Energy',
                terracotta_chic: 'Terracotta Chic',
                noir_or: 'Black & Gold',
            },
            fields: {
                primary: {
                    label: 'Primary Color',
                    hint: 'For header, main buttons',
                    description: 'Main color of your brand identity.',
                    required: 'Primary color is required',
                    invalid: 'Invalid hexadecimal format',
                },
                secondary: {
                    label: 'Secondary Color',
                    hint: 'For backgrounds and secondary sections',
                    description: 'Background or complementary color.',
                    required: 'Secondary color is required',
                    invalid: 'Invalid hexadecimal format',
                },
                accent: {
                    label: 'Accent Color',
                    hint: 'For elements you want to stand out',
                    description: 'For links and buttons.',
                    invalid: 'Invalid hexadecimal format',
                },
            },
            globalError: 'Please correct the color errors',
        },
    },
    establishment: {
        scheduling: {
            save_success: 'Holiday period added successfully',
            update_success: 'Holiday period updated successfully',
            confirm_delete_holiday: 'Are you sure you want to delete this holiday period? This action is irreversible.',
            delete_success: 'Holiday hours deleted successfully',
            confirm_delete_exception: 'Are you sure you want to delete this exception? This action is irreversible.',
            exception_saved: 'Exception saved successfully',
            exception_deleted: 'Exception deleted successfully',
            delete_error: 'An error occurred while deleting the holiday period.',
        },
    },
    views: {
        list: 'List',
        calendar: 'Calendar',
    },
    loading: 'Loading schedule...',
    no_schedule: 'No schedule available',
    remove_break: 'Remove this break',
    save: 'Save',
    saving: 'Saving...',
    editDay: {
        title: 'Edit Day',
        edit: 'Edit',
    },
    day: {
        copy: 'Copy',
        addBreak: 'Add a break',
        periods: {
            start: 'Start',
            end: 'End',
        },
    },
    paymentMethods: {
        dragHint: 'Drag to reorder payment methods',
        details: {
            discount: {
                description: 'Applicable discount method',
                infoMessage: 'This method applies only to specific discounts.',
            },
            cure: {
                description: 'Enables payments via customer subscriptions.',
                infoMessage: 'Subscriptions are automatically detected during reservation.',
            },
            series: {
                description: 'Allows the use of multi-entry or multi-activity packages.',
                infoMessage: 'No additional configuration required. Packages are automatically offered if they are active.',
            },
            card: {
                description: 'Allow payment by credit card on site.',
                infoMessage: '',
            },
            cheque: {
                description: 'Accept payments by cheque made out to your establishment.',
                infoMessage: '',
            },
            cash: {
                description: 'Allow cash payments on site.',
                infoMessage: '',
            },
            transfer: {
                description: 'Allow payments by bank transfer.',
                infoMessage: 'You will need to fill in your bank details in the RIB section.',
            },
            gift_card: {
                description: 'Allow the use of gift vouchers issued by your establishment.',
                infoMessage: 'Once enabled, options will appear in the <Payment via Prepaid Solutions> section.',
            },
            stripe: {
                description: 'Allow online payment via Credit Card, Apple Pay, Google Pay and soon Bancontact.',
                infoMessage: '',
            },
            wallet: {
                description: 'Accept payment via the electronic wallet.',
                infoMessage: 'Your customers can top up their wallet in advance and use it easily for their purchases.',
            },
            undated_ticket: {
                description: 'Allow your customers to prepay a ticket for future use, without specifying a date and time.',
                infoMessage: 'Once enabled, options will appear in the "Payment via prepaid solutions" section.',
            },
            ancv: {
                description: 'Allow payment by ANCV holiday vouchers.',
                infoMessage: '',
            },
            culture_pass: {
                description: 'Allow young people to pay using their Pass Culture.',
                infoMessage: '',
            },
            money_banking: {
                description: 'Allow phone payments through Money Banking.',
                infoMessage: 'Available on the POS only.',
            },
        },
    },
    quotes: {
        title: 'Quotes',
        create: 'Create a quote',
        all_quotes: 'All quotes',
        accepted_quotes: 'Accepted quotes',
        pending_quotes: 'Pending quotes',
        expired_quotes: 'Expired quotes',
        edit_columns: 'Edit columns',
        columns_short: 'Columns',
        validate_quote: 'Validate quote',
        types: {
            all: 'All',
            demande: 'Request',
            envoye: 'Sent',
            signe: 'Signed',
            paye: 'Fully paid',
            perdu: 'Lost',
            anniversaire: 'Birthday',
            entreprise: 'Corporate',
            evg_evjf: 'Stag/Hen Party',
            manuel: 'Manual',
        },
        send_modal: {
            title: 'Send to "{client}"',
            subject_label: 'Subject:',
            subject_value: 'Your quote no. {number}',
            content_label: 'Message content',
            content_placeholder: 'Write the message that will go with the quote...',
            content_required: 'The message content is required.',
            attachment_label: 'Attachment',
            send: 'Send',
        },
        answer_modal: {
            title: 'Request #{id}',
            email: 'Email address',
            phone: 'Phone number',
            reply: 'Reply',
        },
        view: {
            list: 'List view',
            kanban: 'Kanban view',
        },
        columns: {
            status: 'Status',
            type: 'Type',
            created_at: 'Creation date',
            emission: 'Issue date',
            due_date: 'Due date',
            customer: 'Customer',
            number: 'Number',
            amount_ht: 'Amount excl. tax',
        },
        kanban: {
            columns: {
                brouillon: 'Drafts',
                demande: 'Requests',
                envoye: 'Sent',
                expire: 'Expired',
                gagne: 'Won',
                perdu: 'Lost',
            },
            loading_board: 'Loading board...',
            empty: 'No quote',
            loading: 'Loading...',
            load_more: 'Show more quotes',
            load_error: 'Error while loading quotes',
        },
        card: {
            deleted_client: 'Deleted customer',
            default_type: 'Quote',
            created_by: 'Created by {name}',
            relance_tag: 'Reminder sent on {date}',
            already_invoiced: 'Already invoiced',
            view_edit: 'View / Edit',
            download: 'Download',
            duplicate: 'Duplicate',
            mark_won: 'Mark as won',
            mark_lost: 'Mark as lost',
            delete: 'Delete',
            actions: {
                respond: 'Reply',
                relaunch: 'Follow up',
                invoice_balance: 'Invoice balance',
                invoice: 'Invoice',
                validate: 'Validate',
                preview_invoice: 'Preview invoice',
                reopen: 'Reopen',
                send: 'Send',
                send_simple: 'Simple send',
                send_custom: 'Custom send',
            },
            toasts: {
                not_implemented: 'Action not implemented in this demo',
                sent: 'Quote sent to the customer by email',
                draft_created: 'Quote draft created',
                downloading: 'Downloading...',
                duplicating: 'Duplicating...',
                marked_won: 'Quote marked as won',
                error: 'Error',
                marked_lost: 'Marked as lost',
                relaunched: 'The quote has been resent successfully',
                reopened: 'The quote has been reopened and moved to drafts',
                invoiced: 'Invoice created and sent to the customer',
                deleting: 'Deleting...',
            },
        },
        experience_dates: {
            title: 'Experience dates required',
            section: 'Experiences to date',
            date_label: 'Date:',
            choose_date: 'Choose a date',
            required: 'Required',
            alert: 'One experience has no date. Set it before validating this quote.',
            alert_plural: 'Some experiences have no date. Set them before validating this quote.',
            confirm: 'Set dates',
            slot_saved: 'Slot saved',
            slot_error: 'Error while saving the slot',
            capacity_ok: 'Capacity OK · {available}/{max} spots',
            capacity_over: 'Capacity exceeded · {available}/{max} spots',
            participants: '{count} participants',
            date_past: 'Date passed',
            modify_date: 'Change the date',
            alert_past: 'One or more dates are in the past. You can change them or convert the quote as is.',
        },
    },
    devisV3: {
        clientSelector: {
            civility: {
                mme: 'Ms.',
                m: 'Mr.',
                man: 'Man',
                woman: 'Woman',
                other: 'Other',
            },
            newClient: 'New customer',
            editClient: 'Edit client record',
            backToCreation: '+ New record',
            save: 'Save',
            civilityLabel: 'Title',
            validate: 'Confirm',
            placeholders: {
                lastName: 'e.g. Dupont',
                firstName: 'e.g. Marie',
                email: 'first.last@domain.com',
                phone: '6 12 34 56 78',
                address: 'Street, postcode, city',
                socialReason: 'Company or association name',
                identificationNumber: 'SIREN, VAT ID, etc.',
                phoneByCountry: {
                    fr: '6 12 34 56 78',
                    be: '470 12 34 56',
                    ch: '79 123 45 67',
                    lu: '621 123 456',
                    de: '1512 3456789',
                    es: '612 34 56 78',
                    it: '312 345 6789',
                    gb: '7400 123456',
                    tn: '20 123 456',
                    ma: '612 345 678',
                    dz: '551 23 45 67',
                    us: '(202) 555-0123',
                },
            },
            types: {
                individual: 'Individual',
                company: 'Professional',
            },
            companyLookup: 'Search for a company',
            companyLookupPlaceholder: 'Company name, SIREN or SIRET',
            companySearching: 'Searching…',
            companyNoResult: 'No results — your entry will be kept',
            companyDataSource: 'Data from',
            companyDataSourceName: 'French Business Directory API (data.gouv.fr)',
            changeCompany: 'Change company',
            discardConfirmation: {
                title: 'Unsaved changes',
                message: 'If you leave now, your changes will be lost.',
                leaveWithoutSaving: 'Leave without saving',
                saveAndExit: 'Save and exit',
            },
            socialReason: 'Company name',
            identificationNumber: 'Identification number (recommended)',
            siret: 'SIRET',
            function: 'Position',
            tva: 'VAT Number',
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email address',
            phone: 'Phone',
            address: 'Address',
            addressSearching: 'Searching addresses…',
            addressNoResult: 'No address found — your input will be kept.',
            addressDataSource: 'Google Places Addresses',
            city: 'City',
            postalCode: 'Postal code',
            country: 'Country',
            or: 'or',
            add: 'Add',
            errors: {
                invalidEmail: 'Email address must be valid',
                updateSuccess: 'Client record updated',
                loadError: 'Could not load the client record',
                formError: 'Please correct the errors in the form',
                createSuccess: 'Customer created successfully',
                createError: 'Error during creation',
            },
        },
        clientSearch: {
            label: 'Client',
            placeholder: 'Search for a client...',
            noResults: 'No client found',
            recent: 'Recent clients',
            createBlank: 'Create a new client',
            createTyped: 'Create “{query}”',
            blankHint: 'Blank record',
            prefillHints: {
                email: 'Email pre-filled',
                phone: 'Phone pre-filled, country code detected',
                identifier: 'Professional mode, identification number pre-filled',
                company: 'Professional mode, company name and directory suggestions',
                name: 'Name pre-filled',
                fullName: 'Name and first name pre-filled',
            },
            change: 'Change client',
            edit: 'Edit client record',
            createPrefix: 'Create',
        },
    },
    messageBox: {
        payment: {
            start: {
                title: 'Select the payment methods you want to offer to your customers. These options will be visible during online reservations and at the cash register.',
            },
            examples: {
                title: 'Concrete Example:',
                text: 'A treetop adventure park offers credit cards, cash, checks, gift vouchers and Stripe for online reservations. Customers can thus book on the website with Stripe or use a gift voucher given by a relative.',
            },
            advice: {
                title: 'Configuration Advice:',
                text: 'For leisure establishments, we recommend activating at least credit cards, cash and Stripe. Gift vouchers are particularly popular for leisure activities and can represent up to 30% of revenue during holidays.',
            },
        },
        stripeSetup: {
            start: {
                title: 'Connect your Stripe account to accept online payments and offer modern methods like Apple Pay, Google Pay, Klarna or PayPal.',
            },
        },
        paymentPrepaidSolutions: {
            start: {
                title: 'Accept payments via gift vouchers, packages, subscriptions or undated tickets. A simple way to retain your customers and collect payments in advance.',
            },
        },
        depositForm: {
            start: {
                title: 'Define whether your customers must pay a deposit and choose its amount. Secure your time slots while offering flexibility to your customers.',
            },
        },
        billingPolicy: {
            start: {
                title: 'Define your billing and cancellation policy. This text will be displayed on your documents and online.',
            },
        },
        devis: {
            start: {
                title: 'Define your quote policy. Configure if quotes should be linked to time slots.',
            },
        },
        bankDetails: {
            start: {
                title: 'Indicate the details of your bank account for your customers transfers and PlayPro direct debits. This information will appear on your invoices and quotes.',
            },
        },
        wallet: {
            start: {
                title: 'Activate the wallet to allow your customers to store credits and pay faster. An excellent way to build loyalty!',
            },
        },
        loyaltyProgram: {
            start: {
                title: 'Reward your loyal customers by allowing them to accumulate points convertible into benefits.',
            },
        },
        invoiceFooter: {
            start: {
                title: 'Customize the text displayed at the bottom of all your invoices. You can indicate your legal notices, payment conditions or internal notes.',
            },
        },
        reservationCancellationRulesForm: {
            start: {
                title: 'Configure your reservation behavior: automatic or manual validation, deadlines, customer cancellation, penalties, and transparency.',
            },
        },
    },
    prepaidSolutionsConfiguration: {
        fields: {
            prepaidVoucher: {
                label: 'Gift Voucher',
                tool_tip_msg: 'The validity period starts from the date of purchase. Example: 365 = 1 year.',
                description: 'Gift voucher validity (in days)',
            },
            prepaidUndatedTicket: {
                label: 'Undated Ticket',
                tool_tip_msg: 'The validity period starts from the date of purchase. Example: 180 = 6 months.',
                description: 'Undated ticket validity (in days)',
            },
            prepaidPackages: {
                label: 'Packages (prepaid packs)',
                message: 'Packages are automatically offered as a payment method if they are active in your offer.',
            },
            prepaidActiveSubscriptions: {
                label: 'Active Subscriptions',
                message: 'Valid subscriptions are automatically detected for the concerned customers.',
            },
            giftEnabled: {
                label: 'Enable Gift Voucher Sales',
                description: 'Activate this option to allow your customers to purchase gift vouchers on your website.',
                error: 'An error occurred while enabling gift vouchers.',
            },
        },
    },
    depositForm: {
        fields: {
            isDeposit: {
                label: 'Enable Deposit',
                description: 'Allows requesting a partial payment when booking. Useful for securing your time slots.',
            },
            depositType: {
                label: 'Deposit type to select',
                description:
                    'Choose whether the deposit is calculated as a fixed amount or as a percentage of the total reservation.',
                options: {
                    amount: {
                        label: 'Fixed Amount',
                        description: 'You always request the same amount, regardless of the total reservation amount',
                    },
                    percent: {
                        label: 'Percentage',
                        description:
                            'Example: If the deposit is 30%, for a reservation of {symbol}100, an amount of {symbol}30 will be requested.',
                    },
                },
            },
            depositValuePercent: {
                label: 'Deposit Percentage',
                placeholder: '30',
            },
            depositValueAmount: {
                label: 'Deposit Amount',
                placeholder: 'Ex. 30',
            },
            depositIsRequested: {
                label: 'Define where the deposit is requested (optional)',
                options: {
                    unicInSite: {
                        label: 'Force payment with deposit only on the booking website',
                        description: 'The customer will not be able to pay the full amount online.',
                    },
                    viaPaymentLink: {
                        label: 'Force payment with deposit via payment links',
                        description: 'Payment links sent will only request the deposit.',
                    },
                },
            },
        },
    },
    billingPolicy: {
        fields: {
            policyText: {
                label: 'Billing Policy',
                placeholder: 'Enter your billing and cancellation conditions here...',
            },
            activateAutoBilling: {
                label: 'Enable Automatic Billing',
                description: 'If enabled, invoices will be generated automatically at the end of each reservation or activity.',
                options: {
                    draftInvoices: {
                        label: 'Allow Draft Invoices',
                        description: 'Allows generating draft invoices before full payment, useful for professional customers.',
                    },
                },
            },
            numberingFormat: {
                label: 'Numbering Format',
                infoMessage: 'Choose the format for your invoice numbers. YYYY: Year, MM: Month, Number: Sequential number.',
            },
            startingNumber: {
                label: 'Starting Billing Number',
                infoMessage: 'Indicate the number from which your invoice numbering will start.',
            },
            paymentDeadline: {
                label: 'Payment Deadline',
                infoMessage:
                    'Number of days granted to your customers to pay the balance after the service. This deadline will appear on your invoices.',
            },
        },
    },
    bankDetails: {
        fields: {
            bankingInstitution: {
                label: 'Banking Institution',
                infoMessage: 'Indicate the full name of your bank.',
                placeholder: 'Crédit Mutuel',
            },
            accountName: {
                label: 'Indicate the exact name of the account holder as it appears on your RIB',
                infoMessage: 'Indicate the exact name of the account holder as it appears on your RIB.',
                placeholder: 'SARL LOISIRS AVENTURE',
            },
            iban: {
                label: 'IBAN',
                infoMessage: 'International account number (27 characters).',
                placeholder: 'FR76 XXXX XXXX XXXX XXXX XXXX XXX',
            },
            bic: {
                label: 'BIC/SWIFT ',
                infoMessage: 'Bank identification code (8 or 11 characters).',
                placeholder: 'CMCIFR2A',
            },
            options: {
                accurateInformation: {
                    label: 'I certify that the banking information provided is accurate and authorize PlayPro to use it for all operations necessary for the proper functioning of the service.',
                },
            },
        },
    },
    wallet: {
        fields: {
            enableWallet: {
                label: 'Enable Wallet',
                description:
                    'Allow your clients to store credits and pay in advance. Secure your revenue and build customer loyalty.',
                labelCashback: 'Enable a customer reward (cashback)',
                descriptionCashback:
                    'Offer a bonus to your clients when they top up their wallet. Receive advance payments and boost your revenue.',
                additionalOfferDescription: 'Automatically offer an additional amount ...',
            },
            bonusOffered: {
                label: 'Bonus offered',
                placeholder: 'Bonus offered',
                infoMessage:
                    "The percentage of bonus you wish to credit to your customers' wallet. Example with 5%: they deposit {symbol}100 and receive a total of {symbol}105.",
            },
        },
    },
    loyaltyProgram: {
        fields: {
            enableLoyaltyProgram: {
                label: 'Enable Loyalty Program',
                description: 'Allows your customers to accumulate points with each purchase and convert them into benefits.',
            },
            pointsPerEuro: {
                label: 'Points earned per {symbol}1',
                infoMessage: 'Number of points credited for each euro spent.',
            },
            pointsValue: {
                label: 'Points value',
                infoMessage: 'Determines how many points are needed to get {symbol}1 of credit.',
            },
            autoTransferThreshold: {
                label: 'Automatic transfer threshold',
                infoMessage: 'Threshold at which points are automatically transferred to the e-wallet.',
            },
        },
    },
    invoiceFooter: {
        fields: {
            footerText: {
                label: 'Text displayed at the bottom of invoices',
                placeholder: 'Enter the footer text for your invoice here...',
                infoMessage:
                    'This text will automatically appear at the bottom of all your invoices. It can include mandatory legal notices or specific conditions (penalties, deadlines, etc.). You can edit it or revert to the default template at any time.',
            },
        },
    },
    datatable_customer_email_v2_edit: {
        subject: 'Subject',
        sentDate: 'Sent Date',
    },
    title_datatable_customer_email_v2_edit: 'Emails',
    title_datatable_customer_booking_v2_edit: 'Bookings',
    datatable_customer_booking_v2_edit: {
        date: 'Booking date',
        created_at: 'Creation date',
        prestations: 'Activity',
        for: 'Recipient',
        space: 'Room',
        staff: 'Staff',
        status: 'Status',
        payment: 'Payment',
        action: 'Action',
        actions: {
            send_sms: {
                label: 'Send SMS',
                title: 'Send reminder SMS',
            },
            schedule_reservation: {
                label: 'Schedule booking',
                title: 'Schedule appointment',
            },
            reschedule_reservations: {
                label: 'Reschedule booking',
                title: '',
            },
            send_email: {
                label: 'Send email',
                title: 'Send reminder email',
            },
            historical: {
                label: 'History',
                title: 'History',
            },
        },
        status_item: {
            absent: 'Absent',
            present: 'Present',
            booked: 'Booked',
            payed: 'Paid',
            fenced: 'Closed',
            pre_recorded: 'Pre-recorded',
            ruler: 'Settled',
            canceled: 'Canceled',
        },
    },
    title_datatable_customer_products_purchased_v2_edit: 'Purchased products',
    datatable_customer_products_purchased_v2_edit: {
        name: 'Product name',
        type: 'Type',
        created_at: 'Purchase date',
        price: 'Price',
        delivery: 'Delivery',
        status: 'Status',
        staff: 'Seller',
        consumption: 'Consumption',
        action: 'Action',
        actions: {
            btn_box: {
                label: 'cash register',
                title: 'Create a sale for this product',
            },
            btn_receipt: {
                label: 'receipt',
                title: 'Receipt',
            },
        },
        status_item: {
            in_progess: 'in progress',
            on_hold: 'on hold',
            paid: 'paid',
            delivered: 'delivered',
            blocked: 'blocked',
            saved: 'saved',
            fenced: 'closed',
            finished: 'Finished',
        },
    },
    title_datatable_customer_vouchers_purchased_v2_edit: 'Gift vouchers',
    datatable_customer_vouchers_purchased_v2_edit: {
        code: 'Code',
        purchase: 'Purchase',
        invoice: 'Invoice',
        delivery: 'Offered by',
        to: 'For',
        send_date: 'Issue date',
        date_end: 'Expiry date',
        prestations_prices: 'Activity',
        balance: 'Remaining balance',
        status: 'Status',
        action: 'Action',
        days: 'Days',
        actions: {
            btn_donwload: {
                label: 'Download',
                title: 'Download',
            },
            btn_modify: {
                label: 'Edit',
                title: 'Edit',
            },
            btn_history: {
                label: 'History',
                title: 'History',
            },
            btn_send_email: {
                label: 'Send by email',
                title: 'Send by email',
            },
            btn_disabled: {
                label: 'Disable',
                title: 'Disable gift voucher',
            },
            btn_enabled: {
                label: 'Reactivate',
                title: 'Reactivate gift voucher',
            },
        },
        status_item: {
            expired: 'Expired',
            not_sent: 'Not sent',
            totally_used: 'Fully used',
            partially_used: 'Partially used',
            not_used: 'Not used',
        },
    },
    voucherDatatable: {
        columns: {
            code: 'Code',
            send_date: 'Sent date',
            date_end: 'Expiry date',
            import_note: 'Import note',
            total_amount: 'Total amount',
            available_amount: 'Balance',
            gifted_by: 'Offered by',
            gifted_to: 'Offered to',
            actions: 'Actions',
            created_at: 'Creation date',
            status: {
                placeholder: 'All statuses',
                options: {
                    active: 'Active',
                    used: 'Used',
                    expired: 'Expired',
                    blocked: 'Blocked',
                    partially_used: 'Partially used',
                },
            },
            items: {
                empty: 'No linked item.',
                article: 'Article',
            },
        },
        actions: {
            edit: 'Edit',
            generate_invoice: 'Generate invoice',
            reactivate: 'Reactivate',
            disable: 'Disable',
            history: 'History',
            resend_email: 'Resend email',
            download: 'Download',
        },
        modal: {
            title: {
                reactivate: 'Do you want to reactivate this gift voucher?',
                disable: 'Do you want to disable this gift voucher?',
            },
            button: {
                reactivate: 'Activate',
                disable: 'Disable',
            },
            cancel: 'Close',
        },
        notifications: {
            loadError: 'An error occurred while loading the data.',
            exportSuccess: 'The Excel file has been successfully downloaded.',
        },
    },
    title_datatable_customer_treatement_v2_edit: 'Packages | Discovery offer',
    datatable_customer_treatement_v2_edit: {
        name: 'Name',
        date_of_purchase: 'Purchase date',
        price_of_purchase: 'Purchase price',
        authorized_activities: 'Authorized activities',
        initial_quantity: 'Initial quantity',
        remaining_quantity: 'Remaining quantity',
        expiry: 'Expiration',
        linked_reservation: 'Linked reservation',
        action: 'Action',
        actions: {
            btn_chedule: {
                label: 'Schedule booking',
                title: 'Schedule a booking',
            },
        },
        status_item: {
            expired: 'Expired',
            valid_until: 'Valid until',
            none: 'None',
        },
    },
    title_datatable_customer_serie_v2_edit: 'Subscriptions',
    validation: {
        date_range_required: 'Please select a start date and an end date',
        schedule_data_required: 'No schedule data available',
        label_required: 'Please enter a label',
        check_planning: 'Please check the planning',
        start_date_before_end_date: 'Start date must be before end date',
        start_time_before_end_time: 'Start time must be before end time',
        title_required: 'Title is required',
        start_date_required: 'Start date is required',
        end_date_required: 'End date is required',
        reason_required: 'Please select a reason',
    },
    datatable_customer_serie_v2_edit: {
        name: 'Name',
        date_of_purchase: 'Purchase date',
        price_of_purchase: 'Purchase price',
        authorized_activities: 'Authorized activities',
        initial_quantity: 'Initial quantity',
        remaining_quantity: 'Remaining quantity',
        expiry: 'Expiration',
        payment: 'Payment',
        next_collection: 'Next collection',
        linked_reservation: 'Linked reservation',
        action: 'Action',
        actions: {
            btn_chedule: {
                label: 'Schedule booking',
                title: 'Schedule a booking',
            },
            btn_download: {
                label: 'Download',
                title: 'Download',
            },
            btn_delete: {
                label: 'Delete',
                title: 'Delete',
            },
        },
        duree_inline: {
            every_week: 'Every week',
            every_fifteen_days: 'Every fifteen days',
            every_month: 'Every month',
            every_two_months: 'Every two months',
            every_three_months: 'Every three months',
            once_a_year: 'Once a year',
            only: 'Unique',
        },
        status_item: {
            expires: 'Expires on',
            expired_on: 'Expired on',
            none: 'None',
        },
    },
    form_customer_v2: {
        action_setting: {
            loyalty_points: 'Loyalty points',
            either: 'Either',
            in_your_establishment: 'in your establishment',
            wallet_balance: 'Wallet balance',
            btn_create_booking: 'Create booking',
            btn_payment_subscription_management: 'Payment & Subscription Management',
            btn_quick_sale: 'Quick sale',
        },
        main_information: {
            title_infomation: 'Main information',
            label_professional_customer: 'Professional customer',
            label_individual_customer: 'Individual customer',
            first_name: {
                label: 'First name',
                placeholder: 'Enter a name',
                required: 'First name is required.',
            },
            last_name: {
                label: 'Last name',
                placeholder: 'Enter a last name',
                required: 'Last name is required.',
            },
            function: {
                label: 'Function',
                placeholder: 'Enter a function',
            },
            civility: {
                label: 'Civility',
                placeholder: 'Enter a civility',
            },
            email: {
                label: 'Email',
                placeholder: 'Enter an email',
                required: 'Email is required',
            },
            phone: {
                label: 'Phone',
                placeholder: 'Enter a phone',
                required: 'Phone is required',
            },
            fix_phone: {
                label: 'Landline',
                placeholder: 'Enter a landline',
            },
            customer_group: {
                label: 'Customer group',
                placeholder: 'Select a customer group',
            },
            origin: {
                label: 'Origin',
                placeholder: '--Choose an origin--',
            },
            date_of_birth: {
                label: 'Date of birth',
                placeholder: 'Date of birth',
            },
            gender: {
                label: 'Gender',
                placeholder: '--Choose a gender--',
            },
            permissions: 'Permissions',
            GDPR: 'GDPR',
            block_online_booking: 'Block online booking',
            block_payment_by_gift_voucher: 'Block payment by gift voucher',
            allow_receiving_emails: 'Allow receiving emails',
            allow_receiving_sms_messages: 'Allow receiving SMS messages',
            company_name: {
                label: 'Company Name',
                placeholder: 'Enter a Company Name',
            },
            siret: {
                label: 'Siret',
                placeholder: 'Enter a tax number',
            },
            individual: {
                label: 'Individual',
            },
            professional: {
                label: 'Professional',
            },
            customer_type: {
                label: 'Type',
            },
            subscribed_to_communications: 'Subscribed to communications',
            vat: {
                label: 'Intra-community VAT number',
                placeholder: 'Enter the intra-community VAT number',
            },
        },
        addresses: {
            title: 'Addresses',
            title_addresses: 'Addresses',
            country: {
                label: 'Country',
                placeholder: 'Enter a country',
                required: 'Country is required.',
            },
            city: {
                label: 'City',
                placeholder: 'Enter a city',
                required: 'City is required.',
            },
            address: {
                label: 'Address',
                placeholder: 'Enter an address',
                required: 'Address is required.',
            },
            zip_code: {
                label: 'Postal code',
                placeholder: 'Enter a postal code',
                required: 'Postal code is required.',
            },
        },
        internal_notes: {
            title: 'Internal notes',
            important: 'Important note',
            placeholder: 'New note...',
            setting: 'Note category settings',
        },
        customer_alerts: {
            title: 'Customer alerts',
            no_present: 'No-show',
            placeholder: 'New note...',
        },
        btn: {
            reset: 'Reset',
            validate: 'Validate',
        },
        breadcrum: {
            label_1: 'Customers',
            label_2: 'Customer base',
            label_mod: 'Edit',
            label_new: 'New',
        },
    },
    form_model_template_v2: {
        breadcrum: {
            label_1: 'Template model',
            label_mod: 'Edit',
            label_new: 'Add',
        },
        main_information: {
            title_infomation: 'General information',
            title: {
                label: 'Model name',
                placeholder: 'Model name',
                required: 'Title is required',
            },
        },
        config_header: {
            title: 'Present your offers like a real sales brochure',
            description:
                'Create customized quotes with a cover page, visuals or marketing content, as well as your legal notices and terms. Design multiple templates tailored to your offers, integrate options such as electronic signature and send them in one click from your management interface.',
        },
        customize_label: 'Customize each page of your template:',
        breadcrumb_edit: 'Edit a quote template',
        breadcrumb_create: 'Create a quote template',
        btn_save: 'Save',
        btn_validate: 'Validate',
    },
    datatable_model_template_edit: {
        actions: {
            modify: {
                title: 'Edit',
                label: 'Edit',
            },
            gestion_template: {
                title: 'Quote template',
                label: 'Quote template',
            },
            delete: {
                title: 'Delete',
                label: 'Delete',
            },
        },
        title: 'Title',
        action: 'Actions',
    },
    experience: {
        live_preview: 'Live preview',
        add_option: 'Add an option',
        estimated_time: 'Estimated total time: {time}',
        capacity_label: 'Capacity: {capacity}',
        preview_slots: 'Slots preview:',
        total_amount: 'Total amount: {price}',
        prix: 'Price: {price}',
        acompte_to_pay: 'Deposit to pay: {acompte}',
        number_of_tickets: 'Number of tickets: {count}',
        rules_selection: 'Selection rules: {min} - {max}',
        delay_between_activities: 'Delay between activities: {delay} min',
        category_selected: 'Selected category:',
        step: 'Step',
        titleClosePopup: 'Your changes will be lost',
        descriptionClosePopup: 'Leaving this page will discard all your changes.',
        btnStay: 'Stay on page',
        btnLeave: 'Leave',
        next: 'Next',
        finish: 'Finish',
        btnSaveAndLeave: 'Save and leave',
        backToExperiences: 'Back to experiences',
        errorDisponibility: 'Define the availability of your experience',
        step1: {
            subtitle: 'General information',
            content: 'What type of experience do you want to create today?',
            startUp: 'Start',
            card1: {
                title: 'Experience',
                description: 'An activity or event that your customers can book.',
            },
            card2: {
                title: 'Combo<br/>formula',
                description: 'A grouping of multiple experiences in the same formula.',
            },
            card3: {
                title: 'Package',
                description: 'A pass giving access to your experiences, with a number of uses and rules defined in advance.',
            },
            card4: {
                title: 'Subscription',
                description: 'A pass giving recurring access to your experiences, with renewal.',
            },
        },
        step2: {
            subtitle: 'Experience',
            content: 'Create an experience',
            labelNom: 'Your experience name',
            nom: 'Name your experience',
            labelInternalName: 'Internal name',
            internalName: 'Internal name (management use)',
            labelDescription: 'Your experience description',
            description: 'Short description of the experience (optional)...',
            labelUpload: 'Your experience illustration',
            importFile1: 'Click to import',
            importFile2: 'or drag and drop your file',
            requiredTypeFile: 'JPG, JPEG, PNG, WEBP less than 1 MB.',
            requiredTypeFileDimensions: 'Recommended dimensions: {dimensions}',
            requiredTypeFileVideo: 'MP4, MOV, WEBM, AVI or M4V less than 5 MB.',
            errors: {
                imageOnly: 'Only images are accepted (JPG, JPEG, PNG, WEBP).',
            },
            improveInProgress: 'Improvement in progress...',
            improveWithAI: 'Improve with AI',
            defaultText: 'Enter your text here',
        },
        step3: {
            subtitle: 'Capacity',
            content: 'configure your fields, rooms, equipment, which will define your capacity.',
            sub_content: 'Example: 1 field accommodating 10 people, or 20 laser game vests in stock.',
            yourFacilites: 'Your facilities',
            yourEquipment: 'Your equipment',
            example: 'Example',
            activated: 'enabled',
            disabled: 'disabled',
            people: 'people',
            stock: 'Stock',
            usedInExperience: 'used in {count} experience',
            usedInExperiences: 'used in {count} experiences',
            name: {
                required: 'Name is required.',
            },
            capacity: {
                required: 'Capacity is required.',
                error: 'Capacity must be a positive number.',
            },
            popup: {
                add: 'Add {item}',
                edit: 'Edit {item}',
                installation: 'a facility',
                equipment: 'an equipment',
                titleKarafun: 'Karafun link',
                selectKarafun: 'Choose one or more spaces to link',
            },
            equipment: {
                title: 'Configure your equipment',
                name: 'Equipment name',
                capacity: 'Stock quantity',
                placeholder: {
                    name: 'Launchers, vests, harnesses, karts, etc.',
                },
                error_fetch: 'Error loading equipment',
            },
            installation: {
                title: 'Configure your facilities',
                name: 'Facility name',
                capacity: 'Accommodation capacity',
                mixingGroup: 'Allow group mixing',
                karafun: 'Enable Karafun link',
                karafunNotConfigured: 'Karafun integration is not configured.',
                karafunGoToIntegration: 'Configure in Integrations',
                placeholder: {
                    name: 'Field, Room, Park, Circuit, etc.',
                },
                at_least_one: 'You must select at least one facility.',
                error_fetch: 'Error loading spaces',
            },
            dashedCapacityOptions: {
                title: 'Advanced mixing options',
                option_1: 'Allow group mixing between multiple spaces',
                option_2: 'Prohibit mixing above a certain number of people:',
                option_3: 'Show facility names to customer during booking',
                option_dynamic_duration: 'Dynamic duration based on the number of people (bowling)',
                option_same_space: 'Mix groups in the same space',
                at_least_one: 'You must select at least one advanced option.',
            },
            isOptionCard: {
                title: 'Option configuration',
                isOptionLabel: 'Is this activity an option?',
                parentActivityLabel: 'Parent activity',
                selectParent: 'Select a parent activity',
            },
            oneScheduleOnlyOneInstallation:
                'For "One schedule for everyone" mode, only one installation can be selected. Others have been deselected.',
            detection: {
                ambiguityHint: 'Multiple types possible - please specify your choices',
                waitingConfig: 'Waiting for configuration...',
                detectedType: 'Detected type: {typeName}',
                detectedTypeAmbiguous: 'Detected type: {typeName} (ambiguity detected)',
                confidence_label: 'Confidence',
            },
        },
        // Ticketing — "Availability" step (StepTicketAvailability.vue).
        // Separate from `step4`, which remains the availability step of a regular experience.
        stepAvailability: {
            subtitle: 'Availability',
            allDay: {
                title: 'All day',
                description: 'The ticket is valid all day, based on your opening hours.',
            },
            fixed: {
                title: 'Fixed slots',
                description: 'Slots are generated automatically from your opening hours.',
            },
            custom: {
                title: 'Custom slots',
                description: 'You define each validity range yourself.',
            },
            defaultBadge: 'Default',
            validityDuration: 'Validity duration',
            customDuration: 'Custom',
            minutes: 'min',
            fixedHelp: 'If the duration does not divide the range exactly, the trailing remainder is not offered.',
            name: 'Name',
            bookingRange: 'Booking range',
            addSlot: 'Add a slot',
            newSlotName: 'New slot',
            edit: 'Edit',
            delete: 'Delete',
            nextDay: '(+1)',
            purgeConfirmTitle: 'Hourly prices to remove',
            purgeConfirm:
                'This configuration removes {count} hourly price(s) of the "Ticketing options" step that no longer match these availabilities. Continue?',
            purgedToast: '{count} hourly price(s) removed from the "Ticketing options" step.',
            deleteConfirm: 'Delete the slot “{name}”? This cannot be undone.',
            generatedCount: 'i.e. {count} slot of {duration} | i.e. {count} slots of {duration}',
            errors: {
                nameRequired: 'The slot name is required',
                nameTooLong: 'The name cannot exceed 40 characters',
                endAfterStart: 'The end time must be later than the start time',
                endMax: 'A slot cannot end after 3 AM the next day',
                rangeMax: 'A booking range cannot exceed 24 hours',
                overlap: 'Overlaps with “{name}”. Adjust the range.',
                rangeTooShort: 'Range too short',
                durationRange: 'The duration must be between 5 and 720 minutes',
                modeRequired: 'Choose an availability mode before saving',
                atLeastOneSlot: 'Add at least one slot',
                noFreeSpace: 'No free space left in the day: adjust an existing slot before adding another.',
                invalidCustomSlotElsewhere: 'A custom slot is invalid ({error}). Fix it under “Custom slots” before saving.',
            },
        },
        step4: {
            subtitle: 'Availability',
            advancedParams: 'Advanced parameters',
            reservationMode: {
                title: 'Reservation mode',
                Question: 'How will customers book your experience?',
                ResponseTitle1: 'Multiple time slot choices during the day',
                Description1:
                    'Customers choose from different slots offered during the day (e.g., escape game, sports activity).',
                ResponseTitle2: 'One schedule for everyone',
                Description2: 'Customers book for a specific date and time (e.g., show, event, etc.).',
                ResponseTitle3: 'Free access all day',
                Description3: 'Customers come whenever they want during opening hours (e.g., park, zoo, etc.).',
                tooltipPublished:
                    'Reservation mode cannot be changed for a published experience. Create a draft to make changes.',
                Tooltip: 'Choose the reservation mode for this experience',
            },
            interval: {
                Question: 'What is the booking interval?',
                inputLabel: 'Interval',
                option1: 'Every 15 minutes',
                option2: 'Every 30 minutes',
                option3: 'Every hour',
            },
            duration: {
                Question: 'What is the duration of the experience?',
                inputLabel: 'Duration',
                option1: '1 hour',
                option2: '1h30',
                option3: '2 hours',
            },
            add_start_time: {
                Question: 'Interval between activities (in minutes)',
            },
            cleaning_time: {
                Question: 'Additional cleaning/tidying time (in minutes)',
            },
            optionDuration: {
                title: 'Duration options',
                Question: 'Duration option?',
                optionPrefix: 'Option',
                optionNameLabel: 'Option name',
                durationLabel: 'Duration',
                customLabel: 'Custom',
                addButton: 'Add a duration option',
                emptyHint: 'No duration option added yet.',
                option1: '2 hours',
                option2: '2h30',
                option3: '3 hours',
                confirmDelete: 'Delete duration',
                confirmDeleteText: 'Are you sure you want to delete this duration?',
            },
            specificMode: {
                disponibilityTitle: 'Define availability for your experience',
                emptyDisponibility: 'No availability has been added yet.',
                addDisponibility: 'Add availability',
                popupTitleSection: 'Select your dates and times',
                editDisponibility: 'Edit availability',
                specificDays: 'Specific days',
                saisieMode: 'Entry',
                calendarMode: 'Calendar',
                calendar: {
                    recurring: 'Recurrence',
                    confirmCheckbox: 'Apply this configuration to other dates',
                    typeRecurrence: {
                        once: 'Once',
                        weekly: 'Weekly',
                        monthly: 'Monthly',
                        yearly: 'Yearly',
                        weekdays: 'Weekdays',
                        custom: 'Custom',
                        card: {
                            title: 'Recurrence',
                            label: 'Repeat every',
                            labelDay: 'day(s)',
                            labelEnd: 'End',
                            checkNever: 'Never',
                            checkLe: 'On',
                        },
                    },
                },
            },
            multiMode: {
                schedule: {
                    btnEdit: 'Edit hours',
                    titlePopup: 'Customize hours for this experience',
                    configSchedule: 'Configure custom hours',
                    legend: 'Adjust the opening slots for each day of the week.',
                    addSlot: 'Add a time slot',
                    removeSlot: 'Remove the time slot',
                    applyToAll: 'Apply to all days',
                    applied: 'Applied',
                    copyToSelected: 'Copy to selected days only',
                    copyTo: 'Copy to',
                    apply: 'Apply',
                    pause: 'Break',
                    pauseUnavailable: 'Break unavailable',
                    pauseUnavailableHint: "The system handles a single break per day: the previous day's night already uses it.",
                    nightFrom: 'Night of',
                    attachedToDay: 'attached to this day',
                    nightUntil: 'Night until',
                    error: {
                        invalidTime: 'Invalid time',
                        startTooLate: 'Start must be before 24:00.',
                        endTooLate: 'End cannot exceed 5:00 AM (next day).',
                        slotTooShort: 'A slot must last at least 30 minutes.',
                        pauseTooShort: 'The break must last at least 30 minutes.',
                        pauseTooLate: 'The break must end before 24:00.',
                    },
                },
            },
            custom_duration: {
                title: 'custom',
            },
            specifityHoraire: {
                Question: 'Do you want to configure custom hours?',
                ResponseTitle1: 'Yes, define custom hours',
                Description1: 'The hours for this experience are different from your establishment opening hours.',
                ResponseTitle2: 'No, use establishment opening hours',
                Description2: 'This experience will follow your establishment opening hours. Edit hours',
            },
            reservationPeriods: {
                title: 'Customize the slots displayed at the reservation',
                dayPreview: 'DAY PREVIEW',
                noPeriods: 'No segments defined, all slots are displayed.',
                startTime: 'Start time',
                endTime: 'End time',
                active: 'Enabled',
                add: 'Add a time slot',
                addPeriodButton: 'Add a time slot',
                addSuccess: 'The period has been added successfully.',
                deleteSuccess: 'The period has been deleted successfully.',
                validationError: 'End time must be after start time.',
                conflict: 'This period overlaps with an existing period.',
                errorFetch: 'Error loading periods.',
                errorAdd: 'Error adding the period.',
                errorUpdate: 'Error updating the period.',
                errorDelete: 'Error deleting the period.',
            },
            sharedSpaceWarning: {
                bannerMessage: 'This space is shared with other experiences. This change may impact their schedule.',
                modalTitle: 'Shared space detected',
                modalMessage: 'This space is shared with other experiences. This change will impact their schedule.',
                affectedExperiences: 'Affected experiences:',
                confirmButton: 'Continue anyway',
                cancelButton: 'Cancel',
            },
        },
        // Tiers "nb of people -> duration + price". Shared by the Availability step (duration only)
        // and the Pricing step (duration + price): same labels on both sides.
        tiers: {
            configureLink: 'Configure durations per number of people',
            hideLink: 'Hide durations per number of people',
            configurePricingLink: 'Configure degressive pricing',
            blockingError: 'Fix the tiers in error before saving.',
            durationRequired: 'Duration is required.',
            durationInvalid: 'Duration must be a number of minutes greater than 0.',
            palier: 'Tier',
            persons: 'Nbr. of pers.',
            duration: 'Duration',
            durationUnit: 'min',
            price: 'Price',
            // Explicit labels per pricing mode (Pricing step) — the DEFAULT row is always
            // "Price / pers." (outside the tier list, option price × headcount); only the
            // tiers carry the all-inclusive group total in "per group" mode.
            pricePerPerson: 'Price / pers.',
            priceGroup: 'Group price',
            add: 'Add a tier',
            duplicatePersons: 'A tier already exists for {persons} people (tier {palier})',
            fallbackHint:
                "A headcount with no tier of its own inherits the tier just below; outside the tier list (below the first or beyond the last), the option's duration and per-person price apply.",
        },
        step5: {
            subtitle: 'Pricing',
            tva: {
                Question: 'What is the VAT rate for this experience?',
            },
            price: {
                Question: 'What is the price for this experience?',
                priceTTc: 'Price (incl. tax)',
            },
            reservationMode: {
                title: 'How do you want to set the price for this experience?',
                nbrParticipant: 'Number of participants',
                nbrParticipantShort: 'Nbr. of pers.',
            },
            tarif_mode: {
                person: {
                    label: 'Price per person',
                    subtitle: 'The price is calculated based on the number of participants',
                },
                group: {
                    label: 'Price per group',
                    subtitle: 'A fixed price for the whole group, regardless of the number of participants',
                },
            },
            labelPricingMode: 'Pricing mode',
            labelPrice: 'Price',
            priceOptionalHint: 'Price is optional for simple tickets without options',
            labelMinTickets: 'Minimum number of tickets',
            labelMaxTickets: 'Maximum number of tickets',
            unlimitedPlaceholder: '-1 for unlimited',
            isOptionLabel: 'Is an option for another experience',
            labelParentExperience: 'Parent experience',
            parentExperiencePlaceholder: 'Parent experience ID',
            pricingModeLockedByCircuit: 'Pricing mode is automatically set based on the experience type ({circuit})',
            pricingModeLockedByBowling: 'Bowling (dynamic duration) is always priced per group.',
            specificPricingUniformPriceOnly: 'This option is only available when the price per person is the same on every tier.',
            pricingModeTooltipPublished:
                'Pricing mode cannot be changed for a published experience. Create a draft to make changes.',
            many_options: {
                no: {
                    label: 'No',
                    subtitle: 'Single price for this experience',
                },
                yes: {
                    label: 'Yes',
                    subtitle: 'Multiple prices based on duration or number of people',
                },
            },
            multiMode: {
                title: 'Do you offer multiple options?',
                schedule: {
                    configSchedule: 'Configure options and tiered pricing',
                    configTarif: 'Configure specific pricing by day and time',
                    accompte: 'Request a deposit',
                },
            },
            planningCalendar: {
                title: 'Price Planning',
            },
            specificMode: {
                title: 'Specific pricing',
                emptyTarif: 'No specific pricing has been added yet.',
                addTarif: 'Add specific pricing',
                dates: 'Dates',
                tarif: 'Price',
                titlePopup: 'Configure specific pricing',
                popupTitleSection: 'Date selection',
                applicableDays: 'Applicable days',
            },
            demandeAcompte: {
                titleSelect: 'Deposit type',
                optionPercent: 'Percentage (%)',
                optionAmount: 'Amount ({symbol})',
                amountAcompte: 'Deposit amount',
                percentAcompte: 'Deposit percentage',
            },
            errors: {
                requiredPricingMode: 'Please select a pricing mode',
                minTicketOne: 'Minimum number of tickets must be at least 1',
                minGreaterThanMax: 'Minimum cannot be greater than maximum',
                maxLessThanMin: 'Maximum cannot be less than minimum',
                duplicateTarif: 'This price already exists for these dates and hours.',
            },
        },
        stepTicketOptions: {
            subtitle: 'Ticketing options',
            createVariants: 'Create variants for this ticket',
            variantName: 'Name',
            variantNamePlaceholder: 'Variant',
            price: 'Price',
            tva: 'VAT',
            degressifLabel: 'Degressive pricing',
            palierLabel: 'Tier',
            nbTickets: 'No. of tickets',
            addPalier: 'Add a tier',
            addVariant: 'Add a rate',
            undatedLabel: 'Offer this variant as an undated ticket',
            configModalTitle: 'Variant configuration',
            billetterieOptions: 'Ticketing options',
            variantInfo: 'Variant information',
            degressifTitle: 'Degressive pricing',
            degressifSubtitle: 'Reduce the unit price based on tiers.',
            specificPricingTitle: 'Specific pricing by day / hour',
            specificPricingSubtitle: 'Vary your rates for specific hours/days.',
            advancedOptions: 'Advanced ticketing options',
            variantsTitle: 'VARIANTS',
            copy: 'Copy',
            delete: 'Delete',
            startingFrom: 'Starting from',
            unitPrice: 'Unit price',
            tickets: 'tickets',
            uniquePrice: 'Unique price',
            sansNom: 'Unnamed',
            rulesCount: '{count} rule | {count} rules',
            configureSelectedDates: 'Configure selected dates',
            reduction: 'discount',
            fromPrice: 'From',
            // Shape of specific prices according to the "Availability" step mode
            duplicateTarifsIgnored:
                '{count} duplicate price(s) ignored (same dates, same hours): only the billed price is kept, the duplicate will be removed on save.',
            pricingMode: {
                allDay: 'One price per day — "All day" mode (Availability step)',
                fixed: 'Prices per time range — fixed slots of {duration} min (Availability step)',
                custom: 'One price per slot of the Availability step',
                legacy: 'Prices per time range — ticket without a saved availability mode',
            },
            errors: {
                variantNameRequired: 'Variant name is required',
                variantPriceRequired: 'Price is required',
                palierNbRequired: 'Number of tickets is required',
                palierPriceRequired: 'Tier price is required',
            },
        },
        step6: {
            subtitle: 'Additional sales',
            pro_banner_text: 'This feature is reserved for {type} subscriptions',
            passer_pro: 'Upgrade to {type}',
            labelUpload: 'Product images',
            labelNom: 'Product name',
            nom: 'Name',
            labelDescription: 'Short description',
            description: 'Description',
            labelPrice: 'Price',
            labelTva: 'VAT',
            switch1: 'Automatically adjust quantity to number of participants',
            switch2: 'Limit to 1 copy',
            switch3: 'Make mandatory',
            popup: {
                title: 'Add a product',
            },
        },
        step7: {
            subtitle: 'Options',
            specificMode: {
                disponibilityTitle: 'Practical information',
                emptyDisponibility: 'No FAQ has been added yet.',
                addDisponibility: 'Add a question',
                popupTitle: 'Configure your instructions and frequently asked questions',
                popupTitleSection: 'Practical information',
                confirmDelete: 'Delete information?',
                confirmDeleteText: 'Are you sure you want to delete this practical information? This action is irreversible.',
                editInfo: 'Edit slot',
                addInfo: 'Add slot',
            },
            putOnline: {
                title: 'Online publishing',
                description: 'Make this experience visible to my customers',
                visibilityPosLabel: 'Make this experience visible on POS',
            },
            displayOptions: {
                title: 'Display options',
                showAvailableSpots: 'Show the number of available spots',
                showDifficultyLevel: 'Show the difficulty level',
                showBookEntierSpace: 'Show the option to book the entire space',
            },
            stock_management: {
                title: 'Stock management',
                switch_label: 'Enable stock management',
                description:
                    'The stock of each product will be automatically decremented for each reservation, according to the quantity and rule chosen.',
                products_consumed: 'Consumed products',
                column_product: 'Product',
                column_quantity: 'Qty.',
                rule_per_reservation: 'Per reservation',
                rule_per_person: 'Per person',
            },
            ticketingOptions: {
                title: 'Ticketing options',
                description_switch_1: 'Offer this experience as an undated ticket',
                description_switch_2: 'Attach a file to the confirmation email',
                labelUpload: 'Attach a file to the confirmation email',
                requiredTypeFile: 'JPG, JPEG, PNG, WEBP or PDF less than 5 MB.',
                selectBtn: 'Select all',
                deselectBtn: 'Deselect all',
                viewPdf: 'View PDF file',
            },
            labels: {
                required: 'Required',
                options: 'Options',
                option: 'Option',
                optionnel: 'Optional',
            },
            labelNom: 'Title',
            nom: 'Title',
            labelDescription: 'Information',
            description: 'Type your information',
            tickets_possibles: {
                title: 'Possible tickets',
                min: 'Minimum number of players',
                max: 'Maximum number of players',
                player: 'Player',
                label: 'Possible tickets',
            },
            questionCustomer: {
                title: 'Customer questions',
                emptyQuestion: 'No questions have been added yet',
                addQuestion: 'Add a question',
                titlePopupQuestion: 'Questions for the customer',
                labelNom: 'Question',
                type_reponse: 'Response type',
                confirmDelete: 'Delete question?',
                confirmDeleteText: 'Are you sure you want to delete this question? This action is irreversible.',
                question: 'Question',
            },
            question_types: {
                text: 'Short text',
                textarea: 'Long text',
                select: 'Dropdown list',
                checkbox: 'Checkboxes',
                multiple: 'Multiple selection',
                radio: 'Single choice',
            },
        },
        errors: {
            requiredName: 'Name is required',
            requiredDuration: 'Duration is required',
            requiredPrice: 'Price is required',
            positivePrice: 'Price must be greater than 0',
            requiredNbrParticipant: 'Number of participants is required.',
            required: 'Field is required.',
            requiredPricingMode: 'Please select a pricing mode',
            invalidNumber: 'Invalid format',
            requiredAcompteType: 'Deposit type is required.',
            requiredAmount: 'Deposit amount must be greater than or equal to 0.',
            amountRange: 'The deposit amount must be less than the experience price.',
            percentageRange: 'Percentage must be between 0 and 100.',
            incompatibleDateEnd: 'End date must be greater than or equal to start date',
            incompatibleTimeEnd: 'End time must be after start time',
            incompatibleNbreMinMax: 'Minimum number of tickets cannot be greater than maximum number of tickets',
            save: 'Error during saving',
            selectInterval: 'Please select an interval',
            selectDuration: 'Please select an experience duration',
            productExists: 'The product "{productName}" already exists (it may be disabled in the product list).',
            overlapDisponibility: 'An availability already exists on this time slot.',
        },
        success: {
            title: 'Congratulations, your experience is ready!',
            url: 'Get your first booking by sharing it with your customers!',
        },
        timeSpecific: {
            priceTTCPerPerson: 'Price incl. tax per person',
            timeType: 'Time type',
            allowMixing: 'Allow mixing',
            activatePause: 'Activate break',
            forbidMixing: 'Forbid mixing',
            allowMixingOption: 'Allow mixing',
            peakHour: 'Peak hour',
            offPeakHour: 'Off-peak hour',
            days: {
                mon: 'M',
                tue: 'T',
                wed: 'W',
                thu: 'T',
                fri: 'F',
                sat: 'S',
                sun: 'S',
            },
        },
        planningModal: {
            title: 'Selected dates planning',
            configureBtn: 'Configure selected dates',
            dateStart: 'Start date',
            dateEnd: 'End date',
            dayRepetition: 'Day repetition',
            creneau: 'Time slot',
            peakHour: 'Peak Hour',
            offPeakHour: 'Off-Peak Hour',
            forbidMixing: 'Forbid mixing',
            allowMixing: 'Allow mixing',
            startTime: 'Start time',
            endTime: 'End time',
            vatRate: 'VAT rate',
            sellingPrice: 'Selling price',
            errorRequired: 'Please fill in all required fields for each time slot.',
            errorTimeRange: 'End time must be after start time.',
            conflictError: 'Conflicts exist between time ranges.',
            duplicateError: 'A price already exists for these dates and time slot. Change the date or the time.',
            errorEndDateRequired: 'Please set an end date when specific days are selected.',
            addCreneau: 'Add a time Slot',
            allDayHint:
                'In "All day" mode, the ticket is sold as a single slot per day: one price per day. To sell several time ranges at different prices (morning, evening…), choose "Custom slots" in the Availability step.',
            fixedHint: 'A price applies to every {duration}-minute slot that starts within its time range.',
            legacyHint:
                'A price applies to every slot that starts within its time range. To choose which slots are sold, configure the Availability step.',
            nextDayHint: 'A slot ending the next day is priced until 23:59; its sub-slots after midnight keep the base price.',
            nextDaySuffix: '(+1)',
            basePricePlaceholder: 'Base price',
            errorResetCoveredDay: 'This day is covered by a price range: enter the base price to override it, or edit the range.',
            deleteCreneau: 'Delete this time slot',
            cannotEditTime: 'You cannot make any changes to the planning because this event already has reservations',
            selectDateRange: 'Select a date or a period',
            ranges: {
                today: 'Today',
                next7days: '+ 7 days',
                next15days: '+ 15 days',
                next30days: '+ 30 days',
                thisMonth: 'This month',
                nextMonth: 'Next month',
                nextYear: 'Next year',
            },
            reprogramTitle: 'Are you sure you want to reprogram this event for the date of {date}',
            periodUpdateSuccess: 'The period has been successfully updated.',
            periodAddSuccess: 'The period has been successfully added.',
            requiredField: 'This field is required',
        },
        saved: 'Experience updated',
    },
    widgetIntegration: {
        widgets: {
            listing: {
                title: 'Activities listing',
                description: 'This widget displays the list of your products/activities, from reservation to final payment.',
            },
            activite: {
                title: 'Experiences',
                description: 'Your bookable experiences.',
            },
            formules: {
                title: 'Combined packages',
                description: 'Several experiences in one package.',
            },
            bonCadeau: {
                title: 'Gift vouchers',
                description: 'The gift voucher purchase page.',
            },
            evenements: {
                title: 'Events',
                description: 'Your parties and events.',
            },
            forfaits: {
                title: 'Passes',
                description: 'Prepaid packs, passes and credits.',
            },
            abonnements: {
                title: 'Subscriptions',
                description: 'Your recurring subscriptions.',
            },
            billetsNonDates: {
                title: 'Undated tickets',
                description: 'Your experiences sold as undated tickets.',
            },
            categorie: {
                title: 'By category',
                description: 'The experiences of a category.',
            },
            panier: {
                title: 'Cart',
                description: 'The cart and payment.',
            },
            profile: {
                title: 'Customer area',
                description: 'Login, personal info and booking management.',
            },
            devis: {
                title: 'Quote request',
                description: 'Custom quote forms.',
            },
            restaurant: {
                title: 'Restaurant menu',
                description: 'Your menu and online ordering.',
            },
        },
        stepHeaders: {
            integration: {
                title: 'Widget integration',
                description:
                    'Widgets allow you to integrate our reservation and gift voucher modules directly on your own website.',
            },
            activitySelection: {
                title: 'Activity selection',
                description: 'Choose the activity you want to integrate into your widget.',
            },
            activityPage: {
                title: 'Activity page',
                description:
                    'This page displays the reservation module (calendar, availabilities), a description, illustration and allows reservations up to final payment.',
            },
        },
        headers: {
            activite: {
                title: 'Experiences',
                description: 'Displays your bookable experiences — from activity selection to payment.',
            },
            restaurant: {
                title: 'Restaurant menu',
                description: 'Your restaurant menu and online ordering, complementing a reservation.',
            },
            'bon-cadeau': {
                title: 'Gift vouchers',
                description: 'The gift voucher purchase page: amount, customization and payment.',
            },
            panier: {
                title: 'Cart',
                description: 'The cart and complete checkout tunnel for your visitors.',
            },
            evenements: {
                title: 'Events',
                description: 'Your one-off parties and events, with online ticketing.',
            },
            formules: {
                title: 'Combined packages',
                description: 'Several experiences grouped and sold together at a discounted rate.',
            },
            abonnements: {
                title: 'Subscriptions',
                description: 'Your recurring subscriptions and their member benefits.',
            },
            'billets-non-dates': {
                title: 'Undated tickets',
                description: 'All your experiences offered as undated tickets, to be used later.',
            },
            devis: {
                title: 'Quote request',
                description: 'Your quote request forms: privatization, birthdays, companies and custom events.',
            },
            categorie: {
                title: 'By category',
                description: 'Displays all experiences linked to a category (birthday, team building...).',
            },
            forfaits: {
                title: 'Passes',
                description: 'Your prepaid passes: entry packs, passes and credits to use.',
            },
            profile: {
                title: 'Customer area',
                description: 'Customer area with login: personal info and booking management.',
            },
            default: {
                title: 'Widget integration',
                description: 'Choose the module to integrate on your site, then generate the code to copy.',
            },
        },
        stepConfigs: {
            modifyExperience: 'Modify this experience',
            createExperience: 'Create a new experience',
            modifyFormule: 'Modify this package',
            createFormule: 'Create a new combined package',
            modifyAbonnement: 'Modify this subscription',
            createAbonnement: 'Create a new subscription',
            modifyForfait: 'Modify this pass',
            createForfait: 'Create a new pass',
            modifyDevis: 'Modify this quote template',
            createDevis: 'Create a new quote template',
            selectCategory: 'Select a category',
            noConfigNeeded: 'This module requires no setup. It is ready to be integrated.',
        },
        selectActivity: 'Select an activity',
        chooseActivity: 'Choose an activity...',
        needChange: 'Need to make a change?',
        modifyActivity: 'Modify this activity',
        createNewActivity: 'Create a new activity',
        modifyCombo: 'Modify this combo',
        createNewCombo: 'Create a new combo',
        categories: {
            mostUsed: 'MOST USED',
            offres: 'DEALS',
            ventes: 'SALES',
            restaurant: 'RESTAURANT',
        },
        back: 'Back',
        generateCode: 'Generate the code',
        next: 'Next',
        preview: 'Preview',
        loading: 'Loading...',
        activityNotAccessible: 'Activity not accessible',
        activityNotFound: 'Activity not found',
        activityError: 'Error verifying activity',
        completeConfiguration: 'Please complete the configuration first.',
        widgetTitle: 'Playpro reservation widget',
        live: 'Live',
        backToWidgets: 'Back to widgets',
        fullListInfo: 'The full list will be displayed — no item to select.',
        noSelection: 'What do you want to display?',
        modify: 'Edit',
        create: 'Create',
        defaultPreviewTitle: 'Choose a module to integrate',
        defaultPreviewDescription: 'Its live preview will appear here, as your customers will see it.',
        statusPublished: 'Published',
    },
    codeModal: {
        installCodeOnSite: 'Install this code on your site',
        widgetCode: 'Widget code',
        copyCode: 'Copy code',
        copied: 'Copied! ✅',
        copyError: 'Error copying',
        close: 'Close',
        integrationCode: 'Integration code',
        infoBanner: 'Copy this code and paste it on your site, at the exact location where the module should appear.',
        codeToPaste: 'Code to paste',
        cookieManagement: 'Cookie management',
        withoutCookieBanner: 'Without cookie banner',
        withCookieBanner: 'With my cookie banner',
        cookieConsentHint: 'The widget respects your cookie banner choices (CMP) before loading.',
        noCookieConsentHint: 'The simplest option. The widget loads directly, without waiting for consent.',
        whatToDisplay: 'What do you want to display',
        allList: 'All list',
        oneInParticular: 'One in particular',
        title: 'Integration code',
    },
    experiences: {
        filters: {
            filterByType: 'Filter by type',
            all: 'All',
            experience: 'Experience',
            pack: 'Pack',
            forfait: 'Package',
            abonnement: 'Subscription',
            filterByTag: 'Filter by category',
        },
        actions: {
            export: 'Export',
            create: 'Create',
            edit: 'Edit',
            duplicate: 'Duplicate',
            delete: 'Delete',
            deleteSelection: 'Delete selection',
            preview: 'Preview',
            backToCategories: 'Back to categories',
            viewSubcategories: 'View subcategories',
        },
        table: {
            name: 'Name',
            status: 'Status',
            imageTag: 'picture',
            type: 'Type',
            state: 'State',
            actions: 'Actions',
            lastModified: 'Modified on',
            duplicationSuccess: 'Duplication successful',
            color: 'Color',
            category: 'Category',
            subcategory: 'Subcategory',
            tag: 'Category',
            noTag: 'None',
            orderUpdated: 'Order updated successfully',
            orderUpdateFailed: 'Error updating order',
        },
        status: {
            published: 'Published',
            draft: 'Draft',
        },
        export: {
            csv: 'CSV format',
            pdf: 'PDF format',
        },
        selection: {
            itemsSelected: '{count} item selected | {count} items selected',
        },
        deletePopup: {
            title: 'Confirm deletion',
            message: 'Are you sure you want to delete this category? Subcategories will also be deleted.',
            cancel: 'Cancel',
            confirm: 'Delete',
        },
        navigation: {
            experiences: 'Experiences',
            installations: 'Installations',
            equipements: 'Equipment',
            categories: 'Categories',
        },
        createPopup: {
            title: 'Create a category',
            titleUpdate: 'Edit category',
            nameLabel: 'Name',
            namePlaceholder: 'Enter name',
            slugLabel: 'Slug',
            slugPlaceholder: 'category-slug',
            slugPlaceholderSub: 'subcategory-slug',
            colorLabel: 'Color',
            illustrationLabel: 'Illustration',
            chooseImage: 'Choose an image',
            validate: 'Validate',
            titleSub: 'Create a subcategory',
            titleUpdateSub: 'Edit subcategory',
            categoryLabel: 'Category',
            selectCategory: 'Select a category',
            nameRequired: 'Name is required',
            categoryRequired: 'Category is required',
            createSuccess: 'Created successfully',
            updateSuccess: 'Updated successfully',
            errorOccurred: 'An error occurred',
        },
    },
    tag: {
        loading: 'Loading...',
        titleUpdateTag: 'Update category',
        titleTag: 'Create category',
        nameLabel: 'Name',
        namePlaceholder: 'Enter the name',
        parentLabel: 'Parent category',
        parentPlaceholder: 'Select a category',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Enter a description',
        generalDescriptionLabel: 'General description',
        generalDescriptionPlaceholder: 'Enter a general description',
        activitiesAndCombosTitle: 'Activities & Combos',
        activitiesLabel: 'Choose activities',
        combosLabel: 'Choose combos',
        faqTitle: 'FAQ',
        faqEditTitle: 'Edit FAQ',
        faqAddTitle: 'Add FAQ',
        faqQuestionLabel: 'Question',
        faqQuestionPlaceholder: 'Enter the question',
        faqAnswerLabel: 'Answer',
        faqAnswerPlaceholder: 'Enter the answer',
        faqQuestionRequired: 'Question is required',
        faqAnswerRequired: 'Answer is required',
        nameRequired: 'Name is required',
        successMessage: 'Operation successful',
        errorMessage: 'An error occurred',
        illustrationLabel: 'Illustration',
        chooseImage: 'Choose an image',
        visibilityLabel: 'Show on site',
        activeLabel: 'Active',
        updatedStatus: 'Category updated',
        viewOnSite: 'View on site',
        deleteSuccess: 'Category deleted successfully',
        experiencesCount: 'Experiences',
        combosCount: 'Combos',
        selectItemNone: 'None',
        deletePopupConfirm: 'delete',
    },
    equipements: {
        filters: {
            filterByType: 'Filter by type',
            all: 'All',
            materiel: 'Equipment',
            installation: 'Installation',
        },
        actions: {
            export: 'Export',
            create: 'Create',
            edit: 'Edit',
            duplicate: 'Duplicate',
            delete: 'Delete',
            deleteSelection: 'Delete selection',
            create_original: 'Create',
        },
        table: {
            name: 'Name',
            used_by: 'Used by',
            experience_singular: 'experience',
            experiences_plural: 'experiences',
            status: 'Status',
            type: 'Type',
            capacity: 'Capacity',
            actions: 'Actions',
        },
        status: {
            active: 'Active',
            inactive: 'Inactive',
        },
        types: {
            salle: 'Room',
            materiel: 'Equipment',
            equipement: 'Equipment',
        },
        export: {
            csv: 'CSV format',
            xls: 'XLS format',
        },
        selection: {
            itemsSelected: '{count} item selected | {count} items selected',
        },
        deletePopup: {
            title: 'Confirm deletion',
            message: 'Do you really want to delete the selection?',
            messageMultiple: 'Do you really want to delete these selections?',
            deleteWarning: 'Warning: This item is linked to {count} experience(s). Deleting it may impact these services.',
            deleteWarningMultiple:
                'Warning: These items are linked to {count} experience(s). Deleting them may impact these services.',
            deleteSuccess: 'Item(s) deleted successfully.',
            cancel: 'Cancel',
            confirm: 'Delete',
        },
        disablePopup: {
            title: 'Confirm deactivation',
            message: 'Do you really want to deactivate this resource?',
            usageWarning:
                'Warning: this resource is used by {count} experience. It will stay configured with an unavailable resource, and the resource will no longer appear in this list. | Warning: this resource is used by {count} experiences. They will stay configured with an unavailable resource, and the resource will no longer appear in this list.',
            unusedWarning:
                'This resource is not used by any experience, but it will disappear from this list and cannot be re-activated from this screen.',
            cancel: 'Cancel',
            confirm: 'Deactivate',
        },
        form: {
            name: {
                label: 'Equipment name',
                placeholder: 'Name',
            },
            type: {
                label: 'Status',
                placeholder: '',
            },
            capacity: {
                label: 'Number in stock',
                placeholder: 'Number',
            },
            diseable: {
                label: 'How many are out of service?',
                placeholder: 'Maximum:6',
            },
            title_edit: 'Edit equipment',
            title_create: 'Add equipment',
            options: {
                disabled: 'Disabled',
                free: 'Free',
                repair: 'Repair',
            },
        },
        notifications: {
            success_add: 'an installation has been successfully added',
            success_update: 'an installation has been successfully modified',
            statusError: 'Could not update the resource status.',
            positions_updated: 'Resource order updated successfully',
            positionsError: 'Could not update the resource order.',
            savingPositions: 'Please wait for the current save to finish...',
        },
        modal: {
            info_materiel: 'Manage your equipment and materials here.',
            info_salle: 'Manage your installations and booking spaces here.',
        },
    },
    spaces: {
        form: {
            name: {
                label: 'Installation name',
                placeholder: 'Name',
            },
            type: {
                label: 'Space type',
                placeholder: '',
            },
            capacity: {
                label: 'Reception capacity',
                placeholder: 'Capacity',
            },
            price: {
                label: 'Price',
                placeholder: 'Please fill',
            },
            diseable: {
                label: 'How many are out of service?',
                placeholder: 'Maximum:6',
            },
            title_edit: 'Edit installation',
            title_create: 'Add installation',
            switches: {
                authorize_mixing: 'Allow mixing',
                link_space: 'Link spaces',
            },
            types: {
                private: 'Private',
                public: 'Public',
            },
            hours: {
                customTitle: 'Configure custom hours',
                sharedSpaceWarning:
                    'This space is used by {count} experience. Changing a schedule will update those experiences. | This space is used by {count} experiences. Changing a schedule will update those experiences.',
            },
        },
    },
    package: {
        notifications: {
            validationStepFirst: 'Please validate the current step before continuing.',
            success_update: 'Package updated',
            success_add: 'Package added',
            saveErrorDefault: 'An error occurred while saving.',
        },
        step1: {
            subtitle: 'General information',
            content: 'General information',
            description: 'Select the type of formula you want to create',
            typeLabel: 'Formula type',
            types: {
                specific: {
                    label: 'Formula with specific activities',
                    subtitle: 'Choose the activities that make up your formula',
                },
                family: {
                    label: 'Family formula',
                    subtitle: 'Participants can choose different activities',
                },
            },
            errors: {
                typeRequired: 'Please select a formula type',
            },
        },
        step2: {
            subtitle: 'General information',
            content: 'Create a combo formula',
            nameLabel: 'Formula name',
            namePlaceholder: 'Give your formula a name',
            internalNameLabel: 'Internal name',
            internalNamePlaceholder: 'Internal name (management use)',
            descriptionLabel: 'Formula description',
            descriptionPlaceholder: 'Describe your formula...',
            imageLabel: 'Formula illustration',
            errors: {
                nameRequired: 'This field is required',
            },
            notifications: {
                success_add: 'the formula has been successfully added',
                success_update: 'the formula has been successfully modified',
            },
            saveError: 'Error saving',
        },
        step3: {
            subtitle: 'Formula choice',
            title: 'Select your experiences to compose your formula',
            emptyState: {
                message: 'No experiences have been created yet.',
                button: 'Create an experience',
            },
            choiceLabel: 'Choice',
            activityLabel: 'Select an activity',
            noActivity: 'No activity available',
            durationLabel: 'Duration',
            durationPlaceholder: 'Duration',
            toggles: {
                required: 'Required',
                hidden: 'Hide',
            },
            addButton: 'Add an item to the combo',
            sameTimeQuestion: 'Are the durations and times the same for each element?',
            confirmChangeSameTime: 'Changing this option will delete all selected activities. Do you want to continue?',
            confirmChangeSameTimeTitle: 'Confirm change',
            slotSuccessionLabel: 'Time between activities',
            slotSuccessionHelp: 'Defines a time interval between each activity (0 to chain them).',
            errors: {
                atLeastOne: 'Please add at least one experience',
                incomplete: 'Please complete all selected experiences',
                durationMismatch: 'The selected durations are not the same.',
            },
            success: 'Formula saved successfully',
            saveError: 'Error saving',
        },
        step4: {
            subtitle: 'Pricing',
            specificPrice: 'Define a specific price for the formula',
            pricingType: {
                label: 'Pricing type',
                group: 'Per group',
                per_person: 'Per person',
                group_hint: 'A single price, whatever the number of participants.',
                per_person_hint: 'The price is multiplied by the number of participants of the booking.',
                per_person_suffix: ' / participant',
            },
            packagePrice: 'Formula price',
            vat: 'VAT',
            deposit: 'Request a deposit',
            priceHT: 'Price excl. tax',
            barcode: 'Barcode',
            placeholderBarcode: 'EAN code',
            discountLabel: 'Apply discounts to activities',
            discountPercent: 'Discount percentage',
            differentParticipants: {
                question: 'Are the durations and times the same for each element?',
            },
            errors: {
                priceRequired: 'Please define a selling price',
                vatRequired: 'Please select a VAT rate',
                remiseRequired: 'Discount percentage must be between 1 and 100',
            },
            discountApply: 'Apply a discount',
        },
        step5: {
            subtitle: 'Settings',
            selectionRules: 'Configure experience selection rules',
            minItems: 'Minimum number of items',
            maxItems: 'Maximum number of items',
            breakTime: 'Do you want to schedule a break time between each item?',
            breakDuration: 'Break duration',
            minutes: 'minutes',
            select: 'Please select',
            errors: {
                breakDurationRequired: 'Break duration is required',
                maxItemsInvalid: 'The maximum must be greater than or equal to the minimum',
            },
            sameOrder: {
                question: 'Must participants follow the defined order?',
                yes: 'Yes - The defined order must be followed',
                yesSubtitle: 'Participants will have to follow the order as you defined it.',
                no: 'No',
                noSubtitle: 'Participants are free to choose the order.',
            },
            sameSchedule: {
                question: 'Are the schedules identical for each activity?',
                yes: 'Yes',
                yesSubtitle: 'Same duration, same schedule and same start intervals for all.',
                no: 'No',
                noSubtitle: 'Each item has its own duration and schedules.',
            },
            differentParticipants: {
                question: 'Can the number of participants be different for each item?',
                yes: 'Yes',
                yesSubtitle: 'The number of participants can be different for each item.',
                no: 'No',
                noSubtitle: 'The number of participants will always be identical for each item selected in the formula.',
            },
        },
        step6: {
            subtitle: 'Options',
            onlineDisplay: {
                title: 'Online publishing and display',
                visibilityLabel: 'Make this formula visible to my customers',
                visibilityPosLabel: 'Make this formula visible on POS',
                mergeQuestionsLabel: 'Group identical customer questions to avoid duplicates',
            },
            categories: {
                title: 'Categories',
                label: 'Select the categories in which this formula will be visible',
                placeholder: 'Category 1, Category 2',
            },
        },
        step7: {
            subtitle: 'Finish',
        },
    },
    invoices: {
        deferred_modal: {
            title: 'Create invoice',
            order: 'Order',
            total_amount: 'Total amount',
            info_banner_1: 'An invoice will be generated immediately for this order.',
            info_banner_2: 'No payment will be recorded automatically.',
            due_date: 'Due date',
            due_date_required: 'The due date is required.',
            due_date_must_be_future: 'The due date must be later than today.',
            error_occured: 'An error occurred.',
            success_message: 'Invoice {fiscal_number} created — due on {due_date}',
            generate_invoice: 'Generate invoice',
        },
        credit_note_modal: {
            title: 'Create a credit note',
            invoice: 'Invoice',
            total_amount: 'Total amount',
            remaining_to_credit: 'Remaining to credit',
            already_credited: 'Already credited: {amount}',
            refundable: 'Refundable',
            paid_minus_refunded: '{paid} paid − {refunded} already refunded',
            cap_error:
                'An amount exceeds what remains refundable on its payment method: a tender cannot refund more than it collected.',
            reason: 'Reason',
            select_reason: '- Select a reason -',
            reasons: {
                entry_error: 'Entry error',
                customer_cancellation: 'Customer cancellation',
                commercial_gesture: 'Goodwill gesture',
                product_unavailable: 'Product unavailable',
                other: 'Other',
            },
            emit_refund: 'Issue a refund',
            emit_refund_hint: 'Refund the customer and generate an accounting credit note',
            payment_method: 'Payment method',
            paid: 'Paid',
            to_refund: 'To refund',
            total: 'Total',
            badge_auto: 'Refunded automatically',
            badge_credited: 'Credited automatically',
            badge_manual: 'Manual operation',
            balance_error: 'The sum of the amounts must equal {total}.',
            refund_total: 'Total refund',
            refund_partial: 'Partial refund',
            partial_error: 'The amount must be greater than 0 and at most {total}.',
            submit_refund: 'Create credit note and refund',
            submit_only: 'Create credit note',
            cancel: 'Cancel',
            error_occured: 'An error occurred while creating the credit note.',
        },
        loading: 'Loading data...',
        loading_invoices: 'Loading invoices...',
        type_filters: {
            all: 'All',
            draft: 'Draft',
            upcoming: 'Upcoming',
            overdue: 'Overdue',
            paid: 'Paid',
        },
        columns: {
            type: 'Type',
            order_status: 'Status',
            order_status_label: 'Status',
            emission: 'Issued',
            due_date: 'Due date',
            customer: 'Customer',
            fiscal_number: 'Number',
            price_ht: 'Amount excl. tax',
            price_ttc: 'Amount incl. tax',
            order_number: 'Order No.',
            articles: 'Items',
            total: 'Total',
            status: 'Status',
            date: 'Date',
            actions: 'Actions',
            e_invoice: 'E-invoice',
        },
        payment_status: {
            pending: 'Pending',
            partially_paid: 'Partially paid',
            paid: 'Paid',
            cancelled: 'Cancelled',
            avoir: 'Credit note',
        },
        status_labels: {
            unknown: 'Unknown',
        },
        invoice: 'Invoice',
        amount_refunded: 'Amount refunded',
        validated_order_invoice: 'Validated invoice',
        deleted_customer: 'Deleted or non-existent customer',
        deleted_order: 'Deleted or non-existent order',
        send_by_email: 'Send by email',
        generate_pdf: 'Generate a PDF',
        confirm_send_email: 'Do you want to send this invoice by email?',
        export_error_msg: 'Export error:',
        export_filename_prefix: 'invoices',
        export_filename_drafts: 'draft_orders',
        title: 'Invoices',
        create_invoice: 'Create invoice',
        preview_title: 'Invoice Preview',
        download: 'Download',
        option_1: 'Option 1',
        option_2: 'Option 2',
        filter_type: 'Type',
        filter_due_date: 'Due Date',
        filter_advanced: 'Filters',
        filter_status: 'Status',
        remove_all_filters: 'Remove all filters',
        advanced_filters_title: 'Advanced Filters',
        has_refund: 'Has a refund',
        promo_code_used: 'Promo code used',
        payment_method: 'Payment method',
        staff_concerned: 'Staff member',
        amount: 'Amount',
        active_filters: 'active filter(s)',
        reset_all: 'Reset all',
        apply_filters: 'Apply filters',
        filters_applied: 'Filters applied',
        filters_saved_success: 'Filters saved successfully',
        filters_save_error: 'Error saving filters',
        saving: 'Saving...',
        orders: 'Orders',
        orders_count: 'No. of orders',
        total_ttc: 'Total (incl. tax)',
        type: 'Type',
        export: 'Export',
        export_csv: 'CSV',
        export_excel: 'Excel',
        loading_orders: 'Loading orders...',
        walk_in_customer: 'Walk-in customer',
        articles: 'item(s)',
        article: 'Item',
        draft: 'Draft',
        view_details: 'View more details',
        view_invoice: 'View a copy of invoice',
        view_invoice_action: 'View invoice',
        view_order: 'View order',
        download_invoice: 'Download invoice',
        create_credit_note: 'Create credit note',
        credit_note_created_success: 'Credit note created successfully',
        types: {
            anniversaire: 'Birthday',
            entreprise: 'Corporate',
            evg_evjf: 'Bachelor / Bachelorette party',
            manuel: 'Manual',
        },
        stats: {
            ca_factured: 'Total Invoiced',
            ca_paid: 'Total Paid',
            overdue_invoices: 'Overdue Invoices',
            ht: 'Excl. Tax',
            ttc: 'Incl. Tax',
            invoices_count: 'Invoices issued',
            total_invoiced: 'Total invoiced',
            paid: 'Paid',
            transformation_rate: 'Collection rate',
        },
        export_filename_selection: 'invoices_selection',
        filters_updated_success: 'Filters updated successfully',
        date_filter: {
            today: 'Today',
            yesterday: 'Yesterday',
            this_month: 'This month',
            last_month: 'Last month',
            this_year: 'This year',
            last_year: 'Last year',
            apply: 'Apply',
            cancel: 'Cancel',
            custom: 'Custom',
            select_period: 'Select a period',
            status: 'Status',
            emission: 'Issue Date',
            due_date: 'Due Date',
            customer: 'Customer',
            fiscal_number: 'Number',
            remaining: 'Remaining Excl. Tax',
            total: 'Amount Excl. Tax',
            price_ht: 'Amount Excl. Tax',
            price_ttc: 'Amount Incl. Tax',
            order_status_label: 'Order Status',
            invoice_number: 'Invoice No.',
            open_date: 'Opening Date',
            close_date: 'Closing Date',
            total_products: 'Total products (if applicable)',
            total_prestations: 'Total activities (if applicable)',
            total_series: 'Total subscriptions (if applicable)',
            base_price: 'Base price',
            paid_price: 'Paid price',
            total_packages: 'Total packages (if applicable)',
            total_vouchers: 'Total gift voucher (if applicable)',
            total_promo: 'Total promo code (if applicable)',
            refund_amount: 'Refund amount (if applicable)',
            email: 'Email',
            phone: 'Phone number',
            payment_method: 'Payment method',
            voucher_promo_used: 'Gift voucher / Promo code used',
            order_number: 'Order No.',
            articles: 'Items',
            date: 'Date',
            actions: 'Actions',
            type: 'Type',
            order_status: 'Status',
        },
        edit_columns: 'Edit columns',
        columns_short: 'Columns',
        export_selection: 'Export selection',
        selected_items: '{count} item{plural} selected',
        status: {
            all: 'All',
            paid: 'Paid',
            partial: 'Partial',
            due: 'Due',
        },
        clear_filters_dialog: {
            title: 'Remove all filters?',
            message: 'Are you sure you want to remove all active filters? This action cannot be undone.',
            confirm: 'Yes, remove all',
            cancel: 'Cancel',
        },
        selected_elements: 'selected items',
        errors: {
            load_reference: 'Error loading reference data.',
            update_filters: 'Error updating filters',
            validation: 'Validation error',
            connection: 'Connection error',
            connection_retry: 'Server connection error. Please try again.',
            server_connection: 'Server connection error',
            generic: 'An error occurred',
            export_drafts: 'Error exporting {format} drafts',
            server_error: 'Server error',
        },
        filters: {
            refund: 'Refund',
            voucher: 'Gift Voucher',
            promo_code: 'Promo Code',
            payment_method: 'Payment',
            activities: 'Activities',
            products: 'Products',
            packages: 'Packages',
            subscriptions: 'Subscriptions',
            employee: 'Employee',
            status: 'Status',
            min_amount: 'Min Amount',
            max_amount: 'Max Amount',
            order_status: 'Status',
        },
        selected: 'selected',
        yes: 'Yes',
        no: 'No',
        view_copy_invoice: 'View a copy of invoice',
        more_options: 'More options',
        modify: 'Modify',
        modify_order: 'Edit order',
        encaisser_order: 'Process order',
        create_proforma: 'Create a pro-forma invoice',
        cancel_order: 'Cancel order',
        confirm_cancel_order: 'Are you sure you want to cancel order',
        yes_cancel: 'Yes, cancel',
        order_cancelled_success: 'Order cancelled successfully',
        order_cancel_error: 'Error cancelling the order',
        success: 'Success',
        error: 'Error',
        ok: 'OK',
        filter_event_type: 'Event type',
        loading_drafts: 'Loading drafts...',
    },
    devis: {
        status: {
            request: 'Request',
            sent: 'Sent',
            signed: 'Signed',
            fully_paid: 'Fully paid',
            lost: 'Lost',
            draft: 'Draft',
            expired: 'Expired',
        },
        fields: {
            makeDevisWithTimeSlot: {
                label: 'Create quote with time slot',
                description: 'If enabled, quotes will be created with a specific time slot blocking availability.',
            },
        },
        v3: {
            create_title: 'Create a quote',
            quote_label: 'QUOTE',
            preview_pdf: 'PDF Preview',
            save: 'Save',
            send: 'Send',
            view_client_request: 'View client request',
            show_client_request: 'Show client request',
            hide_client_request: 'Hide client request',
            add_at_least_one_line: 'You must add at least one line',
            no_template: 'no template',
            select_template: 'Select a template',
            template_label: 'Template:',
            issue_date: 'Issue date:',
            due_date: 'Due date:',
            iban_label: 'IBAN:',
            swift_label: 'SWIFT:',
            view_client_record: 'View client record',
            select_or_add_client: 'Select or add a client',
            associate_or_create_client: 'Associate or create a new client',
            change_client: 'Change',
            passage_client: 'Walk-in customer',
            designation: 'Description',
            qty: 'Qty',
            unit_price_ht: 'Unit price (excl. VAT)',
            unit_price_ttc: 'Unit price incl. VAT',
            price_display_label: 'Prices shown:',
            price_display_title: 'Choose displayed prices (excl. or incl. VAT)',
            price_display_ttc: 'Incl. VAT',
            price_display_ht: 'Excl. VAT',
            price_display_option_ht: 'Total excl. VAT',
            price_display_option_ttc: 'Total incl. VAT',
            discount: 'Discount',
            tva: 'VAT',
            total: 'Total',
            total_ht: 'Total excl. VAT',
            total_ttc: 'TOTAL incl. VAT',
            edit_total: 'Edit total (recalculates unit price)',
            edit_total_error: 'Cannot edit this total with the current quantity or discount.',
            add_line: 'Add a line',
            edit: 'Edit',
            custom_line_title: 'Add',
            custom_line_subtitle: 'Custom line',
            catalog_line_title: 'Choose',
            catalog_line_subtitle: 'From the catalog',
            or: 'or',
            custom_line_default: 'Custom item',
            draft_validate: 'Validate line',
            option: 'option',
            add_option: 'Add an option',
            optional_line: 'Optional',
            suggest_products: 'Options',
            suggest_experiences: 'Experiences',
            suggest_foods: 'Food',
            locked_accepted: 'Quote accepted by the client — editing disabled (options only)',
            locked_banner: 'This quote has been accepted by the client. Only options can still be changed.',
            accepted_badge: 'Accepted',
            signed_by: 'Signed by {name} on {date}',
            signature_alt: 'Client signature',
            apply_discount: '+ Apply a discount',
            discount_code: 'Code',
            remove_discount: 'Remove discount',
            manual_discount: 'Discount amount',
            discount_amount_placeholder: '0',
            discount_mode: 'Discount type',
            discount_percentage: 'Percentage',
            discount_amount: 'Fixed amount',
            discount_code_group_percentage: 'Percentage',
            discount_code_group_amount: 'Fixed amount',
            remise_specific: 'Specific discount',
            remises_specific: 'Specific discounts',
            cancel: 'Cancel',
            deposit_title: 'Request a deposit',
            deposit_subtitle: 'In % or fixed amount — optional',
            deposit_label: 'Deposit',
            remove_deposit: 'Remove deposit',
            deposit_amount_placeholder: 'e.g. 30',
            deposit_mode: 'Deposit type',
            must_select_client: 'You must select a client',
            payment_conditions: 'PAYMENT CONDITIONS',
            payment_methods_text: 'Bank transfer / Credit card / Cheque',
            notes_header: 'NOTES',
            note_field_placeholder: 'Add a note…',
            signature_header: 'SIGNATURE',
            add_at_least_reservation: 'Please add at least one reservation',
            select_client_first: 'Please select a client',
            finalized_success: 'Quote finalized successfully',
            error_finalizing: 'Error finalizing the quote',
            send_simple: 'Simple send',
            send_custom: 'Custom send',
            sent_success: 'Quote sent to the customer by email',
            sent_error: 'Error while sending the quote',
            no_quote_generated: 'No quote generated yet. Please add an item.',
            item_added: 'Item added',
            error_adding: 'Error adding item',
            item_removed: 'Item removed',
            error_removing: 'Error removing item',
            item_duplicated: 'Item duplicated',
            error_duplicating: 'Error duplicating item',
            cannot_remove_last: 'You cannot remove the last item from the quote.',
            container_line: 'Service priced at €0: the amount is carried by the tickets below',
            confirm_remove_last_child: 'This is the last ticket: the whole service will be removed from the quote. Continue?',
            confirm_remove: 'Are you sure you want to remove this item?',
            add_note: 'Add a note',
            note_saved: 'Note saved',
            item_note_placeholder: 'Add a note (Shift + Enter for a new line)',
            note_error: 'Could not save the note',
            remove_item_title: 'Delete this item',
            remove_item_confirm: 'Delete',
            select_client_first_long: 'Please select a client first',
            template_updated: 'Template updated',
            error_template: 'Error updating template',
            order_updated: 'Line order updated',
            note_placeholder: "Enter the client's request...",
            client_creation_soon: 'Client creation coming soon',
            unnamed_article: 'Item',
            date_prefix: 'On',
            options_title: 'Options',
            conditions_title: 'Conditions',
            conditions_desc: 'Configure the validity period and payment terms of your quote.',
            validity_label: 'Validity period',
            validity_1month: '1 month',
            validity_15days: '15 days',
            validity_7days: '7 days',
            validity_custom_days: '{days} days',
            due_date_computed_hint: 'Computed: issue date + validity period (Options panel)',
            due_date_before_last_item:
                'Invalid due date: {due} comes before the last service on the quote ({item}). Move or remove that line before shortening the validity period.',
            error_due_date: 'The validity period could not be saved.',
            error_auto_reminder: 'The automatic reminder delay could not be saved.',
            error_payment_methods: 'The payment methods could not be saved.',
            error_quote_client: 'The client could not be saved on the quote.',
            no_payment_method_selected: 'No payment method selected',
            auto_reminder_label: 'Automatic reminder',
            reminder_7before: '7 days before due date',
            reminder_3before: '3 days before due date',
            reminder_1before: '1 day before due date',
            payment_methods_title: 'Payment methods',
            no_payment_methods: 'No payment method configured for this establishment.',
            virement: 'Bank transfer',
            activate_evirement: 'Enable automatic e-transfer',
            etablissement: 'Establishment',
            iban: 'IBAN',
            bic: 'BIC',
            participants_outside_recommended_range:
                'Warning: this number of people is outside the recommended range for the associated space (between {min} and {max}).',
            bank_first_entry_hint: 'No bank details saved yet: your entry will be added to the establishment settings.',
            bank_saved_success: 'Bank details saved in the establishment settings.',
            bank_save_error: 'Unable to save the bank details.',
            online_payment: 'Online payment',
            carte: 'Credit card',
            cheque: 'Cheque',
            especes: 'Cash',
            esignature_title: 'Electronic signature',
            request_esignature: 'Request an electronic signature',
            e_virement_banner_text:
                'A dedicated IBAN will be created by Stripe for this quote. Upon receipt of payment, the quote will be automatically validated.',
            block_resources_label: 'Block resources',
            block_resources_none: 'Do not block',
            step_selection: 'Select an experience',
            step_participants: 'Number of people',
            step_planning: 'Date & Slot',
            experiences: 'Experiences',
            packages: 'Combined packages',
            resto: 'Food',
            food_menus: 'Menus',
            food_open_category: 'Browse',
            no_food_in_category: 'No dish in this category.',
            no_food_available: 'No dish available.',
            food_loading: 'Loading dish…',
            food_detail_error: 'This dish could not be loaded.',
            food_no_addon: 'No extras for this dish.',
            food_required: 'Required',
            food_required_missing: 'Still to complete: {groups}',
            food_included: 'Included',
            food_min: 'min. {min}',
            food_max: 'max. {max}',
            food_min_max: 'min. {min} · max. {max}',
            food_confirm: 'Confirm',
            food_pack_choose_hint: 'Please pick one product at each level.',
            all_filter: 'All',
            nav_loading: 'Loading categories…',
            search_results: 'Results',
            add_to_quote: 'Add to quote',
            choose_date: 'Choose date',
            planning_mode_date: 'Pick a date',
            planning_mode_slot: 'Block a slot',
            planning_mode_none: 'No date',
            planning_none_title: 'No date on this line',
            planning_none_text: 'The date can be set later, directly from the quote.',
            planning_none_summary: 'To be scheduled later',
            daypart_morning: 'Morning',
            daypart_afternoon: 'Afternoon',
            daypart_evening: 'Evening',
            edit_price: 'Edit price',
            rename_line: 'Rename line',
            remove_line: 'Remove from quote',
            remove_option: 'Remove option',
            qty_decrease: 'Decrease quantity',
            qty_increase: 'Increase quantity',
            qty_edit: 'Edit quantity',
            food_options_to_configure: 'Options to configure',
            food_choices_count: '{count} choice | {count} choices',
            summary_title: 'Summary',
            summary_lines: '{count} line | {count} lines',
            summary_col_article: 'Item',
            summary_col_qty: 'Qty',
            summary_col_unit_ht: 'Unit price excl. VAT',
            summary_col_total: 'Total',
            summary_subtotal_ht: 'Subtotal excl. VAT',
            summary_vat_on: 'on',
            summary_close: 'Close summary',
            summary_edit_line: 'Edit this line',
            summary_no_date: 'No date',
            summary_negotiated_price: 'Negotiated price',
            summary_duration_minutes: '{count} min',
            participants_less: 'One person fewer',
            participants_more: 'One person more',
            participants_whole_space: 'Whole space',
            participants_shared_slot: 'Shareable slot',
            edit_slot: 'Edit time slot',
            no_item_found: 'No item found.',
            no_item_available: 'No item available in this category.',
            options: 'Options',
            confirm: 'Confirm',
            next: 'Next',
            back: 'Back',
        },
    },
    marketing: {
        abandoned_cart: {
            title: 'Abandoned Cart Recovery',
            subject: 'Email subject',
            subject_placeholder: 'Ex: Hurry up, this slot is in high demand!',
            message_body: 'Message body',
            usable_variables: 'Variables you can use in your message',
            button_text: 'Reservation button text',
            button_text_placeholder: 'Complete my reservation',
            sending_delay: 'Sending delay after abandonment',
            select_delay: 'Select a delay',
            preview_title: 'Email preview',
            subject_label: 'Subject:',
        },
        campaigns: {
            title: 'Email Campaigns',
            create: 'Create a campaign',
            untitled: 'Untitled',
            edit_name: 'Edit name',
            step_recipients: 'Who are you sending this email to?',
            step_from: 'Who is sending this email?',
            step_subject: 'What is the subject line for this email?',
            step_time: 'Send time',
            step_content: 'Content',
            add_recipients: 'Add recipients',
            send_to: 'Send to',
            add_filters: 'Add filters',
            customer_list: 'customer list',
            no_results_for: 'No results found for',
            no_element_found: 'No element found.',
            do_not_send_to: 'Do not send to (optional)',
            remove_emails: 'Remove emails',
            no_user_found: 'No user found.',
            who_sends: 'Who is sending this email?',
            add_sender: 'Add sender',
            instance_name: 'Instance name',
            marketing_email: 'Marketing email',
            required: 'Required',
            subject: 'Subject',
            add_subject: 'Add subject',
            subject_tip: 'Discover the performance of your latest subject lines. Consult our guide.',
            preview_text: 'Preview text',
            preview_text_tip: 'The preview text appears in the inbox after the subject line.',
            when_to_send: 'When should we send this email?',
            send_now_label: 'Send your emails now',
            send_prog_label: 'Schedule sending',
            modify_send_time: 'Modify send time',
            optimize_timing: 'Optimize your timing',
            make_email_reach_now: 'Send email now',
            send_date: 'Send date',
            design_content: 'Design your email content',
            create_email: 'Create an email',
            choose_ready_email: 'Choose a ready email',
            finish_later: 'Finish later',
            send_test: 'Send a test',
            send: 'Send',
            security_tip:
                'To avoid sending emails to customers who received emails in the last hour, it is recommended to enable security.',
            test_email_placeholder: 'Email',
            test_subject_placeholder: 'Subject',
            save_model: 'Save model',
            design_filename: 'model',
            status: {
                all: 'All',
                draft: 'Draft',
                scheduled: 'Scheduled',
                in_progress: 'In progress',
                canceled: 'Canceled',
                failed: 'Failed',
                sent: 'Sent',
                finished: 'Finished',
            },
            success: 'Success',
            failed: 'Failed',
            actions: {
                duplicate: 'Duplicate',
                edit: 'Edit',
                delete: 'Delete',
            },
            empty_state: 'Created email campaigns appear here.',
            empty_state_title: 'Reach your audience in just a few minutes',
            no_subject: 'No subject',
            filter_results: 'Filter search results',
            no_results: 'No item was found.',
            emails_sent_count: 'No. of emails sent',
            creation_date: 'Creation date',
            which_subject: 'What is the subject line for this email?',
            placeholder_search_emails: 'Search emails...',
            status_header: 'Status',
            actions_header: 'Action(s)',
            view_detail: 'View detail',
            last_modification: 'Last modification',
            free_models: 'Free models',
            models: {
                halloween: 'Halloween',
                new_year: 'New Year',
                christmas: 'Christmas',
            },
            config_checks: {
                instance_name: 'instance name',
                marketing_email: 'marketing email',
                subject: 'subject',
                customer_list: 'customer list',
                confirmation: 'confirmation',
                content: 'content',
            },
            list_view: 'List view',
            calendar_view: 'Calendar view',
            stats_view: 'Statistics view',
            indicate_filename: 'Enter file name...',
        },
        messages: {
            saved_success: 'Saved successfully.',
            sending_started: 'Email sending will be launched',
            test_sending_started: 'Test email sending will be launched.',
            operation_success: 'Operation completed successfully.',
        },
    },
    checkout: {
        title: 'Checkout',
        version_banner: {
            v3: {
                title: 'Welcome to the new version!',
                badge: 'NEW',
                description:
                    'A redesigned interface, faster and clearer. Some features are still evolving — your feedback helps us improve it.',
                cta: 'Go back to the old version',
            },
            v2: {
                title: 'The new version is available',
                badge: 'BETA',
                description:
                    'Discover a redesigned interface, faster and more intuitive. You can switch now — and come back here anytime.',
                cta: 'Switch to the new version',
            },
        },
        categories: {
            activity: 'Experiences',
            products: 'Additional sales',
            subscriptions: 'Subscriptions',
            vouchers: 'Vouchers',
            undated_ticket: 'Undated ticket',
            bundles: 'Bundles',
            wallet: 'Wallet',
            treatments: 'Treatments',
        },
        cart: {
            title: 'Cart',
            empty_cart: 'Empty cart',
            empty_cart_confirm: 'Do you want to empty the cart?',
            price: 'Price',
            action: 'Action',
            total: 'Total',
            validate_selection: 'Validate selection',
            select_article: 'Select an article',
            no_results_found: 'No results found',
            no_results_subcategory: 'No results for this sub-category.',
            available_qty: 'Available qty:',
        },
        sale: {
            title: 'Sale',
            add_company: 'Add a company to the invoice',
            address: 'Address',
            postal_code: 'Postal code',
            country: 'Country',
            close_sale_title: 'Close the sale',
            close_sale_confirm: 'Do you want to close the sale?',
            invoice: 'Invoice',
            cash_in_only: 'Cash in only',
            close: 'Close',
            waiting_sales: 'Current Orders',
            order_number: 'Order No.',
            prepayment: 'Prepayment',
            remain_amount: 'Remaining amount:',
            load_cart: 'Load cart',
            no_waiting_sales: 'No waiting sales.',
            tracking: 'Sale tracking',
            seller: 'Sale',
            adviser: 'Advice',
            none: 'None',
        },
        serie_modal: {
            select_activities_title: 'Select activities',
            select_activities_label: 'Select the activities to which it should apply:',
            no_activities: 'No activities for this package',
        },
        security: {
            title: 'Security',
            date: 'Date',
            type: 'Type',
            amount: 'Amount',
            voucher: 'Gift voucher',
            subscription: 'Subscription',
            package: 'Package',
            collect_title: 'Collect security',
            delete_title: 'Delete fingerprint',
            collect_btn: 'Collect',
            delete_btn: 'Delete',
        },
        fingerprint: {
            collect_title: 'Collect security',
            delete_title: 'Delete fingerprint',
            amount: 'Amount',
            invalid_value: 'Incorrect value.',
            required: 'Required field.',
            wrong_format: 'Incorrect format',
            cancel: 'Cancel',
            collect: 'Collect',
            delete: 'Delete',
            error: 'An error occurred',
        },
        contributor: {
            title: 'Participant(s)',
            last_name: 'Last name',
            first_name: 'First name',
            email: 'Email',
            price: 'Price',
            status: 'Status',
            paid: 'Paid',
            not_paid: 'Not paid',
            no_participants: 'No participants available.',
        },
        add_card: {
            title: 'Add a credit card',
            holder_name: 'Account holder name',
            close: 'Close',
            add: 'Add',
            stripe_load_error: 'Failed to load Stripe.',
            success: 'The card has been added successfully.',
            error: 'Error',
        },
        payment_klarna: {
            three_times: 'Pay in 3 installments',
            pay_three_times: 'Pay in 3 installments',
            error: 'An error occurred',
        },
        refund: {
            title: 'Issue a refund',
            amount_to_refund: 'Amount to refund',
            max_amount_error: 'The amount must not exceed {amount}.',
            initial_amount: 'Initial amount:',
            cancel: 'Cancel',
            processing: 'Processing...',
            submit: 'Refund',
            required: 'Required field.',
            wrong_format: 'Incorrect format',
            wrong_float_format: 'Incorrect decimal format',
            error_message: 'An error occurred during the refund',
        },
        v3: {
            nomad_checkout: 'Nomad Checkout',
            new_sale: 'New sale',
            open_sales: 'Pending sales',
            cancel_btn: 'Cancel',
            load_error: 'Could not load checkout state',
            empty_cart: 'The cart is empty',
            sale_closed: 'Sale closed',
            deposit_collected: 'Deposit collected',
            client_label: 'CUSTOMER',
            search_client_placeholder: 'Search for a customer...',
            walk_in_customer: 'Walk-in customer',
            no_email: 'No email',
            registered_clients: 'REGISTERED CUSTOMERS',
            loading: 'Loading...',
            no_clients: 'No customers',
            new_client: 'New customer',
            guest_client: 'Walk-in customer',
            none: 'None',
            error_selecting_client: 'Could not select this customer',
            error_creating_client: 'Error creating the customer',
            search_item_placeholder: 'Search for an item...',
            caisse_crumb: 'Checkout',
            soon: 'soon',
            no_category: 'No category',
            free_amount: 'Free amount',
            validate: 'Validate',
            no_item: 'No item',
            unit_h: 'h',
            unit_m: 'min',
            all_day: 'Full day',
            tile_soon_toast: '"{label}" is coming in a future phase',
            pos_only: 'POS only',
            pos_only_toast: '"{label}" is available on the POS only',
            error_loading_items: 'Error loading items',
            error_loading_products: 'Error loading products',
            select_client_wallet: 'Select a customer to credit the wallet',
            select_client_subscription: 'Select a customer to sell a subscription',
            item_added: '{name} added',
            error_adding_item: 'Could not add the item',
            cart_title: 'Cart',
            global_note_placeholder: 'Add a global note',
            voucher_tag: 'Gift voucher',
            validate_voucher: 'Validate gift voucher',
            locked_line_tip: 'Linked to a booking — cannot be deleted from checkout',
            last_line_tip: 'Last item of the sale — delete the sale to cancel it',
            line_total: 'Line total',
            subtotal_label: 'Subtotal',
            old_price_label: 'Original price',
            promo_already_applied: 'A discount is already applied to this order',
            closed_readonly: 'Closed sale — read-only',
            // Counter sale of an activity that needs a real reservation (bowling) —
            // same-day walk-in: two fields (party size, duration) then a slot.
            booking_participants: 'Players',
            booking_duration: 'Duration',
            booking_players: '{n} player | {n} players',
            booking_confirm: 'Confirm',
            closed_readonly_payment: 'Closed sale — read-only. Refunds are done from the invoices page.',
            view_btn: 'View details',
            new_sale_btn: 'New sale',
            total_ttc: 'TOTAL',
            remaining_to_pay: 'Already paid {paid} · remaining {remains}',
            already_paid: 'Already paid',
            remaining_to_pay_label: 'Remaining to pay',
            cash_in_btn: 'Cash in',
            validate_voucher_first: 'Validate the gift voucher before cashing in.',
            on_hold_soon: 'Available soon',
            on_hold_btn: 'Put on hold',
            sale_on_hold: 'Sale put on hold',
            error_deleting: 'Could not delete',
            error_changing_price: 'Could not change price',
            error_changing_quantity: 'Could not change quantity',
            add_item_first: 'Add an item to the cart first',
            note_global_title: 'Global note',
            note_line_title: 'Note — {name}',
            note_saved: 'Note saved',
            error_saving_note: 'Could not save note',
            payment_title: 'Payment',
            recap_title: 'Summary',
            already_paid_label: 'ALREADY PAID',
            refund_btn: 'Refund',
            discount_label: 'Discount',
            already_collected: 'Already collected',
            overpaid_warning: 'The customer paid {amount} € too much. Remember to refund them before closing the order.',
            confirm_close_title: 'Confirm closing?',
            confirm_close_overpaid:
                'The customer paid {amount} € too much. You can refund them from the invoices page. Close anyway?',
            confirm_close_anyway: 'Close anyway',
            reste_label: 'REMAINING',
            to_pay_label: 'TO PAY',
            total_ttc_short: 'TOTAL',
            paid_status: 'SETTLED',
            remaining_status: 'REMAINING TO COLLECT',
            promo_placeholder: 'Discount / promo code...',
            custom_discount_placeholder: 'Instant discount',
            custom_discount_applied: 'Instant discount applied',
            reductions_group: 'Discounts',
            promos_group: 'Promo codes',
            apply_btn: 'Apply',
            payment_methods_label: 'PAYMENT METHODS',
            no_payment_methods: 'No payment methods configured for this establishment.',
            voucher_code_placeholder: 'Gift voucher code...',
            verify_btn: 'Verify',
            saved_cards_btn: 'Load saved cards',
            no_saved_cards: 'No saved cards for this customer.',
            choose_card_placeholder: 'Choose a card...',
            wallet_balance: 'balance {balance}',
            use_balance_btn: 'Use balance',
            dedicated_flow_soon: 'Dedicated flow coming soon',
            fidelity_label: 'Loyalty',
            fidelity_balance: '{points} pts ≈ {amount}',
            no_points: 'No points available',
            cash_in_acompte: 'Cash in deposit',
            close_sale_btn: 'Close sale',
            error_invalid_refund_amount: 'Invalid refund amount',
            refund_success: 'Refund successful',
            error_refund_failed: 'Could not refund',
            error_voucher_already_added: 'This gift voucher is already added',
            error_loading_cards: 'Could not load cards',
            error_choose_card: 'Choose a saved card',
            error_payment_failed: 'Payment failed',
            error_max_amount: 'Maximum amount exceeded',
            error_min_amount: 'Minimum amount not reached',
            error_promo_failed: 'Invalid or expired promo code',
            error_voucher_failed: 'Invalid or expired gift voucher',
            promo_applied: 'Promo code applied',
            note_title_default: 'Note',
            note_placeholder_default: 'Enter a note...',
            save_btn: 'Save',
            open_sales_title: 'Open sales',
            open_sales_sub: '{count} waiting · max {max}',
            no_open_sales: 'No open sales.',
            client_sales_label: 'Sales for {name}',
            global_sales_label: 'Global sales',
            open_sale_success: 'Sale opened',
            open_sale_btn: 'Open sale',
            error_opening_sale: 'Could not open sale',
            recipient_label: 'Recipient',
            recipient_none: 'No recipient',
            recipient_other: 'Other person',
            first_name_placeholder: 'First name',
            last_name_placeholder: 'Last name',
            email_placeholder: 'Email',
            phone_placeholder: 'Phone',
            recipient_first_name_placeholder: 'Recipient first name',
            recipient_last_name_placeholder: 'Recipient last name',
            recipient_email_placeholder: 'Recipient email',
            given_by_label: 'Offered by',
            sending_label: 'Sending',
            no_mail_label: 'Do not send email',
            message_placeholder: 'Message (optional)',
            voucher_validated: 'Gift voucher validated',
            error_validating_voucher: 'Could not validate gift voucher',
            prepaid_title: 'Prepaid series & cures',
            session: 'session',
            sessions: 'sessions',
            remaining_f: 'remaining',
            remaining_f_plural: 'remaining',
            invoice_company_label: 'Establish a company invoice',
            send_thank_you_email: 'Send thank you email',
            include_review_links: 'Include review links (Google, Facebook...)',
            seller_label: 'Seller',
            adviser_label: 'Adviser',
            error_assigning_seller: 'Could not assign seller',
            error_assigning_adviser: 'Could not assign adviser',
            no_experience: 'No experience',
            error_loading_catalog: 'Error loading catalog',
            experiences_label: 'Experiences',
            all_tags: 'All',
            uncategorized: 'Uncategorized',
            tickets_selection_total: '{count} ticket(s) · {total}€',
            no_info_required_hint: 'No information required — you can validate directly.',
            client_type_label: 'Customer type',
            client_individual: 'Individual',
            client_professional: 'Professional',
            gender_label: 'Title',
            gender_male: 'Male',
            gender_female: 'Female',
            gender_other: 'Other',
            identity_label: 'Identity',
            social_reason_placeholder: 'Company name',
            siret_placeholder: 'SIRET',
            tva_placeholder: 'VAT number',
            fonction_placeholder: 'Role',
            required_fields_hint: 'First name, last name and email are required.',
            add_btn: 'Add',
            client_created: 'Customer created',
        },
        payment_stripe: {
            card_label: 'Payment card',
            no_results: 'No results',
            currency_suffix: 'in {currency}',
            collect: 'Charge',
            wrong_format: 'Incorrect format {format}',
            required: 'Required field.',
            rest_is: 'The remaining is: {amount}{currency}',
            error: 'An error occurred',
        },
        devis: {
            change_template: 'Change',
            add_template: 'Add',
            template_model: 'template model',
            no_template: 'no template model',
            due_date: 'Due date:',
            saving: 'Saving…',
            loading: 'Loading…',
            configure_signature: 'Configure signature',
            save: 'Save',
            generate: 'Generate Quote',
            send: 'Send Quote',
            validating: 'Validating…',
            validate: 'Validate Quote',
            prepare_signature: 'Prepare the electronic signature',
        },
        thanks_mail: {
            title: 'Thank you email',
            setup_title: 'Thank you email settings',
            notice_links: 'Review links',
            rebooking: 'Rebooking offer',
            review_links: 'Review links',
            send_thanks_mail: 'Send thank you email',
            rebooking_offer: 'Rebooking offer',
        },
        payment: {
            title: 'Payment Method',
            remain_to_pay: 'Remain to pay:',
            collect: 'Collection',
            cash_in: 'CASH IN',
            cash_in_and_close: 'CASH IN & CLOSE',
            paid: 'Already paid',
            excess_amount_warning: 'Warning, you are about to collect more money than the cart value.',
            advantages: 'Advantages',
            promo_code_limit: '(*) You can only use one promo code per order.',
            add_promo_code: 'Add a discount code',
            add_another_promo_code: 'Add another promo code',
            apply: 'Apply',
            applied: 'Applied',
            global_discount: '(global discount)',
            quantity: 'Quantity',
            amount_category: 'Amount {category}',
            errors: {
                expired: 'The promo code has expired.',
                expired_since: 'The promo code has expired since {date}.',
                disabled: 'The promo code is disabled.',
                limit_reached: 'The maximum use of the promo code has been reached.',
                min_amount: 'Minimum amount required: {amount} {symbol}',
                max_amount: 'Maximum amount required: {amount} {symbol}',
                already_used: 'Promo code already used.',
                not_applicable: 'Promo code not applicable.',
                not_found: 'Promo code not found.',
                internal_error: 'An internal error occurred',
                overpaid_warning: 'Warning, you are going to collect more money than the cart value.',
            },
            info: {
                applicable: 'Applicable promo code.',
            },
        },
        series: {
            title: 'Subscriptions',
            remaining_quantity: 'Remaining quantity:',
            remaining_qty: 'Remaining quantity:',
            no_subscriptions: 'No subscription for this customer.',
            no_series: 'No subscription for this customer.',
            remove: 'Remove',
            apply: 'Apply',
        },
        treatments: {
            title: 'Bundles',
            remaining_quantity: 'Remaining quantity:',
            no_treatments: 'No offers for this customer.',
        },
        voucher: {
            title: 'Vouchers',
            setup_title: 'Voucher setup',
            validate_undated: 'Validate undated ticket',
            validate_gift: 'Validate gift voucher',
            valid_until: 'valid until',
            total_available: 'Total amount of {type} {amount} available',
            blocked: 'This {type} has been blocked.',
            already_used: 'This {type} has already been used.',
            beneficiary: 'Beneficiary',
            this_customer: 'This customer',
            another_customer: 'To another customer',
            search_customer: 'Search for a customer',
            choose_customer: 'Choose a customer',
            no_email: 'No email',
            new_beneficiary: 'New beneficiary',
            first_name: 'First name*',
            last_name: 'Last name*',
            email: 'Email*',
            phone: 'Phone*',
            email_beneficiary: 'Beneficiary email',
            phone_beneficiary: 'Beneficiary phone',
            no_beneficiary: 'No beneficiary',
            undated_ticket: 'Undated ticket',
            gift_voucher: 'Gift voucher',
            send_by_email: 'Send by email',
            send_date_email: 'Email send date',
            custom_message: 'Custom message',
            custom_message_placeholder: 'Add a custom message (optional)...',
            characters: 'characters',
            total_amount_of: 'Total amount of',
            available: 'available',
            errors: {
                fill_required: 'Please fill',
                blocked: 'This ... has been blocked.',
                already_used: 'This ... has already been used.',
            },
        },
        treatment_modal: {
            select_activities: 'Select activities',
            select_activities_for: 'Select the activities to apply to:',
            no_activities: 'No activities for this bundle',
        },
    },
    products: {
        stats: {
            products: 'Products',
            categories: 'Categories',
            suppliers: 'Suppliers',
            brands: 'Brands',
        },
        actions: {
            export: 'Export',
            add: 'Add',
            edit: 'Edit',
            duplicate: 'Duplicate',
            delete: 'Delete',
            deleteSelection: 'Delete selection',
            filter: 'Filter',
        },
        filters: {
            title: 'Advanced filters',
            categories: 'Categories',
            selectCategories: 'Select categories',
            subcategories: 'Subcategories',
            selectSubcategories: 'Select subcategories',
            brands: 'Brands',
            selectBrands: 'Select brands',
            suppliers: 'Suppliers',
            selectSuppliers: 'Select suppliers',
            tags: 'Tags',
            selectTags: 'Select tags',
            priceRange: 'Price range',
            minPrice: 'Min',
            maxPrice: 'Max',
            inventory: 'Inventory',
            selectInventory: 'Select status',
            inventoryAlert: 'Stock alert',
            inventoryOut: 'Stock out',
            inventoryOrdering: 'In ordering',
            status: 'Status (Active)',
            selectStatus: 'Select status',
            visibleOnline: 'Online visibility',
            selectVisibility: 'Select visibility',
            isCabin: 'Cabin only',
            reset: 'Reset',
            apply: 'Apply',
        },
        table: {
            name: 'Name',
            status: 'Status',
            brand: 'Brand',
            category: 'Category',
            price: 'Price',
            stock: 'Stock',
            visible: 'Visible',
            actions: 'Actions',
            duplicationSuccess: 'Product duplicated successfully',
        },
        status: {
            active: 'Active',
            inactive: 'Inactive',
            visible: 'Visible',
            hidden: 'Hidden',
        },
        export: {
            csv: 'CSV format',
            xls: 'Excel format',
        },
        deletePopup: {
            title: 'Confirm deletion',
            message: 'Are you sure you want to delete the selection?',
            cancel: 'Cancel',
            confirm: 'Delete',
        },
    },
    product: {
        title: 'Products',
        edit_title: 'Edit a product',
        add_title: 'Add a product',
        general_info: 'General information',
        name: 'Name',
        name_placeholder: 'Ex: Fasting_Milk...',
        category: 'Category',
        category_placeholder: 'Select a category',
        description: 'Description',
        description_placeholder: 'Describe your product',
        usage: 'Illustration',
        usage_placeholder: 'How to use this product?',
        change_image: 'Change image',
        choose_image: 'Choose an image or drag and drop your file',
        pricing: 'Pricing',
        apply_discount: 'Apply a discount',
        sale_price: 'Sale price (incl. VAT)',
        vat_rate: 'VAT rate',
        new_price: 'Price after discount',
        discount_percentage: 'Discount percentage',
        variants_features: 'Variants and features',
        available_sizes: 'Available sizes',
        sizes_placeholder: 'Ex: XS, S, M, L...',
        unit: 'Unit',
        unit_placeholder: 'Select a unit',
        value: 'Value',
        active: 'Enabled',
        visible_online: 'Show on site',
        history: 'History',
        published_on: 'Published on',
        by: 'by',
        modified_on: 'Modified on',
        access_product_sheet: 'Access product sheet',
        supply: 'Supply',
        supplier: 'Supplier',
        supplier_placeholder: 'Select a supplier',
        supplier_reference: 'Supplier reference',
        brand: 'Brand',
        brand_placeholder: 'Select a brand',
        purchase_cost: 'Purchase cost',
        recommanded_quantity: 'Quantity to order',
        stock: 'Stock',
        consumable_product: 'Consumable product',
        stock_quantity: 'Stock quantity',
        stock_quantity_help:
            'Leave empty for unlimited stock. When set, it is decremented on each add-on sale and may go negative.',
        threshold_alert: 'Alert threshold',
        consumption_duration: 'Consumption duration in days',
        days: 'days',
        back: 'Back',
        validate: 'Validate',
        exit_dialog: {
            title: 'Do you want to leave?',
            message: 'You have unsaved changes. Do you really want to leave?',
            exit: 'Leave',
            stay: 'Stay',
        },
        validation: {
            name_required: 'Product name is required.',
            category_required: 'Category is required.',
            description_required: 'Description is required.',
            price_required: 'Sale price must be greater than or equal to 0.',
            vat_required: 'VAT rate is required.',
            purchase_cost_required: 'Purchase cost is required and must be positive.',
            recommanded_quantity_required: 'Quantity to order is required and must be positive.',
            stock_quantity_required: 'Stock quantity is required and must be positive.',
            threshold_alert_required: 'Alert threshold is required and must be positive.',
        },
        notifications: {
            price_warning: 'The new price must be lower than the base price',
            update_success: 'Product updated successfully',
            add_success: 'Product added successfully',
            save_error: 'An error occurred while saving',
        },
    },
    productCategories: {
        title: 'Categories',
        title2: 'Category',
        table: {
            name: 'Name',
            products_count: 'Number of products',
            subcategories_count: 'Number of subcategories',
            status: 'Status',
            actions: 'Actions',
        },
        status: {
            active: 'Active',
            inactive: 'Inactive',
        },
        deletePopup: {
            title: 'Delete category',
            message: 'Are you sure you want to delete this category? This action is irreversible.',
            cancel: 'Cancel',
            confirm: 'Delete',
        },
        actions: {
            create: 'Add',
            edit: 'Edit category',
            delete: 'Delete category',
            deleteSelection: 'Delete selection',
        },
        createPopup: {
            titleCategory: 'Add a category',
            titleSubcategory: 'Add a subcategory',
            titleUpdateCategory: 'Edit category',
            titleUpdateSubcategory: 'Edit subcategory',
            nameLabel: 'Category Name',
            nameSubcategoryLabel: 'Subcategory Name',
            namePlaceholder: 'Ex: Burgers, Desserts...',
            slugLabel: 'Custom Slug',
            slugPlaceholder: 'Ex: homemade-burgers',
            illustrationLabel: 'Illustration',
            chooseImage: 'Choose an image or drag and drop your file',
            uploadText: 'Click to upload or drag and drop your file',
            formatText: 'JPG, JPEG, PNG - under 5 MB',
            validate: 'Confirm',
            successCategory: 'Category created successfully',
            successSubcategory: 'Subcategory created successfully',
        },
        validation: {
            nameRequired: 'The name is required',
            slugRequired: 'The slug is required',
        },
    },
    productSupplier: {
        title: 'Suppliers',
        table: {
            name: 'Name',
            email: 'Email',
            phone: 'Phone',
            ref: 'Reference',
            address: 'Address',
            actions: 'Actions',
        },
        actions: {
            create: 'Add',
            edit: 'Edit',
            delete: 'Delete',
            deleteSelection: 'Delete selection',
            export: 'Export',
        },
        createPopup: {
            title: 'Add supplier',
            editTitle: 'Edit supplier',
            nameLabel: 'Name',
            namePlaceholder: 'Ex : My Supplier',
            emailLabel: 'Email',
            emailPlaceholder: 'Ex : contact@supplier.com',
            phoneLabel: 'Phone',
            phonePlaceholder: 'Ex : 0123456789',
            refLabel: 'Reference',
            refPlaceholder: 'Ex : REF-123',
            addressLabel: 'Address',
            addressPlaceholder: 'Ex : 123 Main Street',
            validate: 'Validate',
            success: 'Supplier added successfully',
        },
        validation: {
            nameRequired: 'The name is required',
            emailRequired: 'The email is required',
            phoneRequired: 'The phone is required',
            refRequired: 'The reference is required',
            addressRequired: 'The address is required',
        },
        deletePopup: {
            title: 'Delete supplier',
            message: 'Are you sure you want to delete this supplier? This action cannot be undone.',
            cancel: 'Cancel',
            confirm: 'Delete',
        },
    },
    productBrand: {
        title: 'Brands',
        table: {
            name: 'Name',
            email: 'Email',
            phone: 'Phone',
            actions: 'Actions',
        },
        actions: {
            create: 'Add',
            edit: 'Edit',
            delete: 'Delete',
            deleteSelection: 'Delete selection',
            export: 'Export',
        },
        createPopup: {
            title: 'Add brand',
            nameLabel: 'Name',
            namePlaceholder: 'Ex : My Brand',
            emailLabel: 'Email',
            emailPlaceholder: 'Ex : contact@brand.com',
            phoneLabel: 'Phone',
            phonePlaceholder: 'Ex : 0123456789',
            validate: 'Validate',
            success: 'Brand added successfully',
        },
        editPopup: {
            title: 'Edit brand',
            success: 'Brand updated successfully',
        },
        validation: {
            nameRequired: 'The name is required',
            emailRequired: 'The email is required',
            phoneRequired: 'The phone number is required',
        },
        deletePopup: {
            title: 'Delete brand',
            message: 'Are you sure you want to delete this brand? This action cannot be undone.',
            cancel: 'Cancel',
            confirm: 'Delete',
        },
    },
    food: {
        title: 'Food',
        sellingPrice: 'Selling Price',
        vat_rate: 'VAT',
        navigation: {
            products: 'Products',
            menu: 'Catalog',
            categories: 'Categories',
            packs: 'Formulas',
            options: 'Variants & Extras',
            tables: 'Tables & QR Codes',
            options_supplements: 'Variants & Extras',
            qr_codes: 'Tables & QR Codes',
            table_categories: 'Table categories',
            tags: 'Tags',
        },
        status: {
            active: 'Active',
            inactive: 'Inactive',
        },
        columns: {
            name: 'Name',
            price: 'Price',
            category: 'Category',
            type: 'Type',
            status: 'Status',
            stock: 'Stock',
            actions: 'Actions',
        },
        options: {
            add_option: 'Add a variant',
            add_supplement: 'Add an extra',
            info_option: 'Options allow your customers to customize their products (e.g., cooking level, sauce, etc.).',
            type: 'Type',
            select_type: 'Select a type',
            name_label: 'Name',
            name_placeholder: 'Ex: Cooking, Sauce...',
            price_label: 'Price',
            description_label: 'Description',
            description_placeholder: 'Option description...',
            modal_title_option: 'Edit option',
            info_option_group: 'Create an option group to allow your customers to choose from multiple choices.',
            group_name_label: 'Group Name',
            group_name_placeholder: 'Ex: Choose your cooking',
            option_item_placeholder: 'Option Name',
            modal_title_supplement: 'Edit supplement',
            info_supplement_group: 'Supplements are additional products your customers can add (e.g., fries, drink, etc.).',
            supplement_name_label: 'Supplement Name',
            supplement_name_placeholder: 'Ex: Choose your sides',
            min_quantity: 'Min Quantity',
            max_quantity: 'Max Quantity',
            optional: 'Optional',
            supplement_item_placeholder: 'Supplement Name',
            included: 'Included',
            required: 'Required',
            limit_one: 'Limit to 1',
            add_modal_title: 'Add',
            unclassified: 'Uncategorized',
            info_addon_modal_addon:
                'The client can choose <strong>one or more supplements</strong> from those offered.<br />The choice is <strong>optional</strong> and each supplement can have a specific price.',
            info_addon_modal_option:
                'The client must choose <strong>only one option</strong> from those offered.<br />The choice is <strong>mandatory</strong> and each option can have a specific price.',
            option_category_name_label: 'Option Category Name',
            addon_category_placeholder: 'Ex: Sauces, Toppings...',
            option_category_placeholder: 'Ex: Size, Cooking...',
            choice_name_placeholder: 'Choice Name',
            create_supplement: 'Create a supplement',
        },
        tables: {
            title: 'QR Codes',
            add_modal_title: 'Add a QR Code',
            edit_modal_title: 'Edit a QR Code',
            download_qr: 'Download QR Code',
            info_message: 'Create a QR code to easily share your menu with your customers.',
            count_label: 'Number of QR Codes to generate',
            count_placeholder: '0',
            categories_label: 'Target Categories',
            categories_placeholder: 'Entire menu (default)',
            name_label: 'Name',
            name_placeholder: 'QR Code Name',
            columns: {
                name: 'Name',
                order_link: 'Order Link',
                actions: 'Actions',
            },
            delete_single_confirm: 'Delete this QR Code?',
            delete_multiple_confirm: 'Delete {count} QR Code(s)?',
            duplicate_confirm: 'Are you sure you want to duplicate this QR Code?',
            duplicate_success: 'QR Code successfully duplicated',
            update_success: 'QR Code successfully updated',
            create_success: 'QR Codes successfully created',
            copy_link_title: 'Copy link',
            download_all_qr: 'Export QR Codes',
            selected_items: '{count} selected',
            errors: {
                generic: 'Error',
                duplicate: 'Error during duplication',
                update: 'Error during QR Code update',
                create: 'Error during QR Code creation',
                export: 'An error occurred during export.',
            },
            added_success: 'Tables added successfully',
            select_at_least_one: 'Please select at least one table.',
            deleted_success: 'Table deleted successfully',
            order_cutoff: {
                label: 'Order closing',
                block_title: 'Block table orders',
                disabled: 'Disabled',
                min_before_close: '{count} min before closing',
                short_min_before: '{count} min before',
                one_hour_before_close: '1 h before closing',
                short_one_hour: '1 h before',
                save_success: 'Orders blocked {count} min before closing',
                disabled_success: 'Order blocking disabled',
                save_error: 'Error while saving',
                today_last_order: 'Today - last order at {time}',
                closed_today: 'Closed today',
            },
        },
        table_categories: {
            columns: {
                category: 'Category',
                tables: 'Tables',
                actions: 'Actions',
            },
            add_title: 'Add a table category',
            edit_title: 'Edit table category',
            name_label: 'Name',
            save: 'Save',
            delete_title: 'Delete category',
            delete_cancel: 'Cancel',
            delete_confirm: 'Delete',
            confirm_delete: 'Are you sure you want to delete this category?',
            confirm_delete_multiple: 'Are you sure you want to delete {count} categor(y/ies)?',
            linked_tables: '{count} table(s) will be unassigned. Are you sure you want to continue?',
            selected: '{count} category selected | {count} categories selected',
            added_success: 'Category added successfully.',
            updated_success: 'Category updated successfully.',
            deleted_success: 'Category(ies) deleted successfully.',
            save_error: 'Error saving the category.',
            delete_error: 'Error deleting.',
            export_error: 'Export error.',
        },
        messages: {
            confirm_bulk_tags: 'Manage {count} tag(s)',
            confirm_bulk_category: 'Manage {count} category(ies)',
            load_error: 'Unable to load details',
            save_error: 'Error saving',
            delete_error: 'Error deleting',
            create_error: 'Error creating',
            status_update_error: 'Error updating status',
            export_error: 'An error occurred during export.',
            confirm_delete_option: 'Are you sure you want to delete this option?',
            confirm_delete_options: 'Are you sure you want to delete {count} option(s)?',
            name_required: 'Name is required',
            option_name_required: 'Option name is required',
            option_item_name_required: 'Option name {index} is required',
            option_item_price_required: 'Option price {index} must be greater than 0',
            supplement_name_required: 'Supplement name is required',
            selected_items: '{count} item selected | {count} items selected',
            confirm_delete_product: 'Are you sure you want to delete this product?',
            confirm_delete_products: 'Are you sure you want to delete {count} product(s)?',
            confirm_delete_category: 'Are you sure you want to delete this category?',
            confirm_delete_categories: 'Are you sure you want to delete {count} category(ies)?',
            confirm_duplicate_category: 'Are you sure you want to duplicate this category?',
            save_success: 'Product saved successfully',
            product_saved_success: 'Product saved successfully',
            product_save_error: 'Error saving product',
            confirm_duplicate_option: 'Are you sure you want to duplicate this option?',
            confirm_duplicate_supplement: 'Are you sure you want to duplicate this supplement?',
            option_duplicated_success: 'Option duplicated successfully',
            supplement_duplicated_success: 'Supplement duplicated successfully',
            duplicate_error: 'Error duplicating',
            confirm_bulk_discount: 'Apply a discount to {count} selected products',
        },
        carte: {
            title: 'Products',
            clear_filter: 'Clear filter',
            add: 'Add',
            add_product: 'Create a product',
            add_pack: 'Create a formula',
            select: 'Select',
            create_category: 'Create a category',
            bulk: {
                edit_category: 'Edit category',
                edit_tag: 'Edit tag',
                apply_discount: 'Apply discount',
                discount_percent: 'Discount (%)',
                discount_amount: 'Amount ({symbol})',
                discount_type: 'Discount type',
                percentage: 'Percentage (%)',
                fixed_amount: 'Fixed amount ({symbol})',
                value: 'Value',
                tags_label: 'Tags',
                tags_placeholder: 'Select or create tags...',
            },
            savingPositions: 'Please wait for the current save to finish...',
            positions_updated: 'Order updated successfully',
        },
        categories: {
            columns: {
                subcategories_count: 'Subcategories',
                content: 'Products',
            },
            updated_success: 'Category updated successfully!',
            bulk: {
                edit_tag: 'Edit tag',
            },
            modal: {
                title_create: 'Add a category',
                title_edit: 'Edit category',
                title_create_sub: 'Add a subcategory',
                title_edit_sub: 'Edit subcategory',
                name_label: 'Category name',
                name_placeholder: 'Ex: Burgers, Desserts...',
                name_label_sub: 'Subcategory name',
                name_placeholder_sub: 'Ex: Classic Burger, Fries...',
                parent_label: 'Parent category',
                parent_placeholder: 'Select a parent category',
                slug_label: 'Custom slug',
                slug_placeholder: 'Ex: burgers-maison',
                tags_label: 'Tags',
                tags_placeholder: 'Add tags...',
                status_label: 'Status',
                active: 'Active',
                inactive: 'Inactive',
                color_label: 'POS display color',
                image_label: 'Category image',
            },
        },
        packForm: {
            name: 'Name',
            namePlaceholder: 'Ex: Kids Formula, Gourmet Formula, etc...',
            titleEdit: 'Edit formula',
            titleCreate: 'Add a formula',
            imageLabel: 'Illustration',
            pricingTitle: 'Pricing',
            newPriceLabel: 'New price',
            discountPercentLabel: 'Discount percentage',
            compositionTitle: 'Compose your formula',
            compositionNameLabel: 'Name',
            compositionNamePlaceholder: 'Ex: Side, Drink, Dessert, etc...',
            compositionSelectPlaceholder: '- Select one or more options -',
            activeLabel: 'Enable',
            showOnMenuLabel: 'Show on menu',
            viewOnMap: 'View formula on map',
            takeawayTitle: 'Available for takeaway',
            availableDelivery: 'Available for delivery',
        },
        productForm: {
            titleEdit: 'Edit product',
            titleCreate: 'Add a product',
            nameLabel: 'Name',
            namePlaceholder: 'Ex: House Burger, Royal Pizza...',
            categoryLabel: 'Category',
            categoryPlaceholder: '- Select a category -',
            descriptionLabel: 'Description',
            descriptionPlaceholder: 'Describe your product...',
            imageLabel: 'Illustration',
            pricingTitle: 'Pricing',
            optionsTitle: 'Options',
            createOption: 'Create an option',
            addOption: 'Add an option',
            supplementsTitle: 'Supplements',
            createSupplement: 'Create a supplement',
            addSupplement: 'Add a supplement',
            boissonsTitle: 'Drinks',
            createBoisson: 'Create a drink',
            addBoisson: 'Add a drink',
            saucesTitle: 'Sauces',
            createSauce: 'Create a sauce',
            addSauce: 'Add a sauce',
            complementsTitle: 'Complements',
            createComplement: 'Create a complement',
            addComplement: 'Add a complement',
            activeLabel: 'Enabled',
            showOnMenuLabel: 'Show on menu',
            viewOnMap: 'View product on map',
            stockTitle: 'Stock management',
            stockLabel: 'Stock quantity',
            stockPlaceholder: '0',
            stockInfo: 'Leave empty or 0 for out of stock.',
            isOutOfStockLabel: 'Force out of stock',
            isOutOfStockInfo: 'Enable this option to force the "Out of stock" status, even if the quantity is positive.',
            stockUnlimited: 'Stock is unlimited for this product.',
            takeawayTitle: 'Available for takeaway',
            deliveryTitle: 'Available for delivery',
            back: 'Back',
            availableValues: 'Available values',
            noValueConfigured: 'No value configured for this option.',
            noChoiceConfigured: 'No choice configured for this group.',
            option: 'An option',
        },
        packs: {
            created_success: 'Pack created successfully',
            updated_success: 'Pack updated successfully',
        },
        menus: {
            updated_success: 'Menu updated successfully!',
            included_items_exceeds_supplements: 'The number of included items must be less than or equal to supplements',
            included_items_exceeds_drinks: 'The number of included items must be less than or equal to drinks',
            included_items_exceeds_sides: 'The number of included items must be less than or equal to sides',
            included_items_exceeds_sauces: 'The number of included items must be less than or equal to sauces',
        },
        noCategory: 'No category',
        illustration: 'Picture',
    },
    tags: {
        title: 'Tags',
        columns: {
            name: 'Name',
            slug: 'Slug',
            foods_count: 'Number of products',
            category_count: 'Number of categories',
            printer: 'Printer',
            status: 'Status',
            actions: 'Actions',
        },
        form: {
            name_label: 'Tag name',
            name_placeholder: 'Ex: Burgers, Desserts...',
            slug_label: 'Slug',
            slug_placeholder: 'Ex: burgers, desserts (leave empty to auto-generate)',
            printer_label: 'Printer',
            printer_placeholder: 'Select a printer',
            status_label: 'Status',
            status_active: 'Active',
            status_inactive: 'Inactive',
            modal_title_create: 'Add a tag',
            modal_title_edit: 'Edit tag',
        },
        actions: {
            create: 'Add',
            edit: 'Edit',
            delete: 'Delete',
            deleteSelection: 'Delete selection',
            export: 'Export',
            confirm_bulk_printer: 'Change printer for {count} selected tags',
            confirm_delete_tag: 'Confirm tag deletion',
            confirm_delete_tags: 'Confirm deletion of selected tags',
        },
        create_success: 'Tag created successfully!',
        update_success: 'Tag updated successfully!',
    },
    statistics: {
        welcome: 'Hello',
        welcomeSuffix: 'here is your performance',
        lastUpdate: 'Last updated',
        minutes: 'minutes ago',
        vsLastWeek: 'Vs last week',
        experiences: 'Experiences',
        dateRange: {
            today: 'Today',
            yesterday: 'Yesterday',
            last7Days: 'Last 7 days',
            last30Days: 'Last 30 days',
            custom: 'Custom',
            selectPeriod: 'Select a period',
        },
        kpi: {
            caRealise: 'Realized Revenue',
            caEncaisse: 'Cashed Revenue',
            panierMoyen: 'Average Basket',
            entrees: 'Entries',
        },
        charts: {
            turnover: 'Turnover',
            salesStats: 'Sales Statistics',
            topSales: 'Top Sales',
            clientStats: 'Customer Statistics',
            clientBase: 'Customer Base',
            frequencyStats: 'Attendance Statistics',
            frequency: 'Attendance',
            paymentMethods: 'Payment Methods',
            salesTypes: 'Sales Types',
            productTypes: 'Product Types',
            prestationTypes: 'Prestation Types',
            bookingStats: 'Booking Statistics',
            occupancyRate: 'Occupancy Rate',
            honored: 'Honored Bookings',
            noshow: 'No-show',
            cancelled: 'Cancellations',
        },
        legend: {
            encaisse: 'Cashed',
            realise: 'Realized',
            currentYear: 'N',
            previousYear: 'N-1',
        },
        clientStats: {
            men: 'Men',
            women: 'Women',
            retentionRate: 'Retention Rate',
            newClients: 'New Customers',
            noShowRate: 'No-show Rate',
            cancellationRate: 'Cancellation Rate',
            subscribers: 'Subscribers',
        },
        frequencyStats: {
            todayBookings: "Today's Bookings",
            mostRequestedSlot: 'Most Requested Slot',
            occupancyRate: 'Occupancy Rate',
            averageVisitTime: 'Average Visit Time',
            peakTime: 'Peak Time',
            average: 'Average',
            vsYesterday: 'Vs Yesterday',
        },
        salesMiniStats: {
            tickets: 'Tickets',
            orders: 'Orders',
            groupSize: 'Average Group Size',
        },
        downloadExcel: 'Download Excel',
        loading: 'Loading data...',
        noData: 'No data available',
        error: 'Error loading data',
        total: 'Total',
        ttc: 'Inc. Tax',
        ht: 'Exc. Tax',
    },
    dashboard: {
        greeting: {
            hello: 'Hello',
            morning: 'Good morning',
            evening: 'Good evening',
        },
        periods: {
            today: 'Today',
            tomorrow: 'Tomorrow',
            yesterday: 'Yesterday',
            choose: 'Choose',
            last7Days: 'Last 7 days',
            thisMonth: 'This month',
            thisYear: 'This year',
        },
        kpis: {
            upcomingReservations: 'Upcoming Reservations',
            completedEntries: 'Completed Entries',
            noShows: 'No-shows',
            cancellations: 'Cancellations',
            vsYesterday: 'Vs Yesterday',
        },
        tables: {
            arrivingToday: 'Arriving Today',
            orderedToday: 'Ordered Today',
            viewCalendar: 'View Calendar',
            viewAll: 'View All',
            hour: 'Time',
            reservation: 'Reservation',
            client: 'Client',
            count: 'Cnt.',
            quantity: 'Qty',
            status: 'Status',
            note: 'Note',
            name: 'Name',
            empty: 'No reservations',
            anonymous: 'Anonymous',
            reservation_id: 'Reservation #{id}',
            order_id: 'Order #{id}',
            vue_stats: 'Statistics view',
            vue_ops: 'Operational view',
        },
        statuses: {
            paid: 'Paid',
            pending: 'To Pay',
            partial: 'Remaining',
            cancelled: 'Cancelled',
            confirmed: 'Confirmed',
            noshow: 'No-show',
        },
        trends: {
            title: 'Reservation Trends',
            today: 'Today',
            tomorrow: 'Tomorrow',
            nextSaturday: 'Next Saturday',
            nextSunday: 'Next Sunday',
        },
        delays: {
            title: 'Average Lead Time',
            days: 'days',
            vsLastWeek: 'Vs last week',
        },
        tooltip: {
            reservation: 'Reservation',
            confirmed: 'Confirmed',
            viewDetail: 'View Detail',
            modify: 'Modify',
            cancel: 'Cancel',
            total: 'Total',
            formula: 'Formula',
            persons: 'people',
            room: 'Room',
        },
        loading: 'Loading...',
        noData: 'No data',
        takeReservation: 'Take a reservation',
    },
    sidebar: {
        dashboard: 'Dashboard',
        calendar: 'Calendar',
        nomad_checkout: 'Nomad Checkout',
        nomad_checkout_v3: 'Nomad Checkout V3',
        sales: 'Sales',
        customers: 'Customers',
        quotes: 'Quotes',
        orders: 'Orders',
        invoices: 'Invoices',
        marketing: 'Marketing',
        promo_codes: 'Promo Codes',
        abandoned_cart: 'Abandoned carts',
        premium_badge: 'Premium',
        newsletters: 'Newsletter',
        auto_mails: 'Automatic Mails',
        push_notifications: 'Push Notifications',
        blog: 'Blog',
        team: 'Team',
        planning: 'Planning',
        users: 'Users',
        roles_access: 'Roles & Access',
        rewards: 'Rewards',
        accounting: 'Accounting',
        exports: 'Exports',
        sales_reports: 'Sales Reports',
        settings: 'Settings',
        establishment: 'Establishment',
        experiences: 'Experiences',
        quote_templates: 'Quote Templates',
        installations: 'Installations',
        website: 'Website',
        widgets: 'Widgets',
        products: 'Products',
        restoration: 'POS Catalog',
        tables_qr_codes: 'Tables & QR Codes',
        google_calendar: 'Google Calendar',
        pos_devices: 'POS Devices',
        api: 'API',
        api_documentation: 'API documentation',
        support: 'Support',
        client: 'Customers',
        annonces: 'Annonces',
        formQuestion: 'Quote Requests',
        resource: 'Resources',
        integration: 'Integrations',
    },
    navbar: {
        light_theme: 'Light theme',
        dark_theme: 'Dark theme',
        manage_account: 'Manage my account',
        change_account: 'Change account',
        subscription_billing: 'Subscription',
        product_news: 'Product news',
        help_center: 'Support',
        training_solutions: 'Training and solutions',
        referral: 'Referral',
        offered: 'offered',
        days_remaining: 'day remaining | days remaining',
        logout: 'Log out',
    },
    header: {
        titles: {
            adminHome: 'Dashboard',
            adminPlanning: 'Calendar',
            getCheckouts: 'Nomad Checkout',
            getCustomersBOV2: 'Sales',
            getDevis: 'Sales',
            getInvoices: 'Sales',
            getPromotions: 'Marketing',
            newsletters_index: 'Marketing',
            getMailsCustoms: 'Marketing',
            notifications_index: 'Marketing',
            blog_list: 'Marketing',
            staffPlanning: 'Staff planning',
            getStaffs: 'Users',
            getRoles: 'Roles',
            GamificationViewAll: 'Rewards',
            getStats: 'Accounting',
            editViewEstablishmentV2: 'Settings',
            list_categ: 'Settings',
            getSpaces: 'Settings',
            getWebsiteSettings: 'Settings',
            widgets_index: 'Settings',
            getProduit: 'Settings',
            bo_foods_index: 'Settings',
            google_calendar: 'Settings',
            adminIndexPos: 'Settings',
            adminIndexApplication: 'Settings',
            getInvoicesV2: 'Sales',
            getInvoicesV3: 'Sales',
            getInvoicesEnAttente: 'Sales',
            indexViewExperienceV3: 'Experiences',
            indexViewEquipementsV3: 'Equipments',
            indexViewFoodV3: 'Catalog',
            indexViewProductV3: 'Products',
            createProductV3: 'Add a product',
            editProductV3: 'Edit a product',
            default: 'Page',
        },
    },
    profil: {
        canBeClient: 'Assign client role',
        title: 'My profile',
        first_name: {
            label: 'First Name',
            placeholder: 'Enter a first name',
            required: 'First name is required.',
        },
        last_name: {
            label: 'Last Name',
            placeholder: 'Enter a last name',
            required: 'Last name is required.',
        },
        email: {
            label: 'Email',
            placeholder: 'Enter an email',
            required: 'Email is required.',
        },
        phone_number: {
            label: 'Phone number',
            placeholder: 'Enter a phone number',
            required: 'Phone number is required.',
        },
        pin: {
            label: 'Code PIN caisse',
            placeholder: 'Enter a PIN code',
            required: 'PIN code is required.',
        },
        edit: 'Edit',
        edit_profile: 'Edit my profile',
        change_password: 'Change my password',
        admin: 'Admin',
        user: 'User',
        password_modal: {
            title: 'Change password',
            current: 'Current password',
            new: 'New password',
            confirm: 'Confirm new password',
            current_placeholder: 'Enter your current password',
            new_placeholder: 'Enter your new password',
            confirm_placeholder: 'Confirm your new password',
        },
    },
    roles: {
        names: {
            admin: 'Administrator',
            manager: 'Manager',
            operator: 'Operator',
            accounter: 'Accountant',
        },
        title: 'Roles',
        add: 'Add a role',
        edit: 'Edit a role',
        general_info: 'General information',
        display_name: 'Display name',
        unique_name: 'Unique name',
        placeholder_display_name: 'Ex: Manager',
        placeholder_unique_name: 'Ex: manager',
        permissions: 'Permissions',
        select_all: 'Select all',
        deselect_all: 'Deselect all',
        user_assignment: 'User assignment',
        no_users: 'No users available.',
        privileged_access_tooltip: 'Grant as privilege (bypass plan level)',
        accessible_with_plan: 'Accessible with your plan',
        higher_plan_required: 'Higher plan required',
        access_granted_by_admin: 'Access granted by administrator',
        delete_title: 'Delete a role',
        delete_confirm_single: 'Are you sure you want to delete this role?',
        delete_confirm_multiple: 'Are you sure you want to delete these roles?',
        selected_count: '{count} selected',
        subscription_short: 'Sub.',
        errors: {
            load_error: 'An error occurred while loading data.',
            save_error: 'An error occurred while saving.',
            display_name_required: 'Display name is required',
            unique_name_required: 'Unique name is required',
            form_validation: 'Please fix validation errors.',
            fetch_role: 'Error while loading role.',
        },
        messages: {
            save_matrix_success: 'Permission matrix saved successfully.',
            create_success: 'Role created successfully.',
            update_success: 'Role updated successfully.',
        },
        title_v3: 'Permission management',
        content_v3: 'Configure the permissions for each role',
        subscription_access: 'Subscription access',
        click_to_unlock: 'Unlock (Included in the subscription)',
        click_to_lock: 'Block (Not included in subscription)',
        with_of_subscription: 'with subscription',
        switch_role_perm_fonct: {
            toogle: {
                permissions: 'Permissions',
                features: 'Features',
            },
        },
    },
    staff: {
        title: 'Users',
        availabilities: 'Availabilities',
        no_preference: 'No preference',
        or: 'Or',
        choose_staff_placeholder: 'Choose your preferred staff member',
        you_have_chosen: 'You have chosen:',
        add_employee: 'Add a user',
        external_resource: {
            add: 'Add an external resource',
            edit: 'Edit',
            delete: 'Delete',
            name: 'Resource name',
            email: 'Resource email',
        },
        edit_employee: 'Edit an employee',
        main_info: 'Main Information',
        assignments: 'Assignments',
        roles: 'Roles',
        prestations: 'Prestations',
        planning_visible: 'Planning visible',
        calendar_visible: 'Calendar visible',
        status: 'Status',
        form: {
            last_name_placeholder: 'Enter last name',
            first_name_placeholder: 'Enter first name',
            email_placeholder: 'Enter email',
            phone_placeholder: 'Enter phone number',
            password_placeholder: 'Enter password',
            password_edit_placeholder: 'Leave blank to keep unchanged',
            select_role: 'Select a role...',
            select_prestation: 'Select a prestation...',
            pin_edit_placeholder: 'Enter the PIN',
            validation: {
                last_name_required: 'Last name is required',
                first_name_required: 'First name is required',
                email_required: 'Email is required',
                phone_required: 'Phone number is required',
                role_required: 'Role is required',
                pin_required: 'PIN is required',
            },
        },
        table: {
            columns: {
                status: 'Status',
                first_name: 'First Name',
                last_name: 'Last Name',
                email: 'Email',
                phone: 'Phone',
                roles: 'Roles',
                actions: 'Actions',
            },
            delete_popup: {
                title: 'Delete a staff member',
                description_single: 'Are you sure you want to delete this staff member?',
                description_multiple: 'Are you sure you want to delete these staff members?',
                error: 'An error occurred during deletion.',
            },
        },
        statuses: {
            active: 'Active',
            suspended: 'Suspended',
            forbidden: 'Forbidden',
            deleting: 'Deleting',
            deleted: 'Deleted',
        },
        exit_dialog: {
            title: 'Exit?',
            description: 'You have unsaved changes. Are you sure you want to exit?',
            stay: 'Stay',
            exit: 'Exit',
        },
        planning_sent_email: 'Planning for {name} sent by email successfully',
        planning_send_error: 'Error sending planning',
    },
    serie: {
        step_label: 'Step',
        step1: {
            subtitle: 'General information',
            content: 'Create a subscription',
            name_label: 'Subscription Name',
            name_placeholder: 'Name your subscription',
            description_label: 'Description of your subscription',
            description_placeholder: 'Describe your subscription (optional)',
            image_label: 'Subscription Illustration',
            validation: {
                name_required: 'This field is required',
                description_required: 'This field is required',
            },
            error_save: 'Error saving general information',
        },
        notifications: {
            success_add: 'the subscription has been successfully added',
            success_update: 'the subscription has been successfully modified',
            validationStepFirst: 'Please validate the current step before continuing.',
        },
        step2: {
            subtitle: 'Usage rules',
            content: '',
            renewal_period: 'Renewal Period',
            subscription_duration: 'Subscription Duration',
            end_date_optional: 'End Date (optional)',
            auto_renewal: 'Automatic Renewal',
            accumulate_prestations: 'Accumulate Prestations on Renewal',
            included_usages: 'Included Usages (at each renewal)',
            limit_total_usages: 'Limit Total Usages',
            limit_peak_hours: 'Limit Peak Hours Usages',
            limit_off_peak_hours: 'Limit Off-Peak Hours Usages',
            allow_peak_for_off_peak: 'Peak hours can be consumed during off-peak hours',
            limit_usage_rate: 'Limit Usage Rate',
            per_period: 'Per Period',
            limit_max_peak_per_period: 'Limit max peak hours per period.',
            limit_max_off_peak_per_period: 'Limit max off-peak hours per period.',
            limit_access_experiences: 'Limit Access to Certain Experiences',
            add_activity: 'Add an Activity',
            select_activity: 'Select an Activity',
            duration: 'Duration',
            select_duration: 'Select Duration...',
            choice: 'Choice',
            tickets: {
                participant_label: 'Per Participant',
                participant_subtitle: 'The pass is sold per seat, each participant must have their own ticket.',
                space_label: 'Per Space',
                space_subtitle: 'The pass applies to the entire booked space, regardless of the number of participants.',
            },
            options: {
                week: 'week',
                month: 'month',
                days_7: '7 days',
                days_15: '15 days',
                month_1: '1 month (30 days)',
                month_2: '2 months (60 days)',
                month_3: '3 months (90 days)',
                month_4: '4 months (120 days)',
                month_6: '6 months (180 days)',
                year_1: '1 year (365 days)',
            },
            validation: {
                add_one_activity: 'Please add at least one activity',
                complete_all_activities: 'Please complete all activities',
            },
            error_save: 'Error saving configuration',
        },
        step3: {
            subtitle: 'Pricing',
            content: '',
            price: 'Price',
            vat: 'VAT Rate',
            pricing_title: 'Subscription Price',
            price_ht: 'Price Excl. Tax',
            select: 'Select...',
            validation: {
                price_required: 'Please define a selling price',
                vat_required: 'Please select a VAT rate',
                duration_required: 'Please select a duration',
            },
            error_save: 'Error saving pricing',
        },
        step4: {
            subtitle: 'Activities',
            content: '',
        },
        step5: {
            subtitle: 'Options',
            content: '',
            online_display: 'Online & Display',
            visible_label: 'Make this subscription visible to my clients',
            ticketing_options: 'Ticketing Options',
            undated_label: 'Offer this subscription as an undated ticket',
            success_save: 'Subscription saved successfully',
            error_save: 'Error finalizing subscription',
        },
        preview: {
            live_preview: 'Live Preview',
            estimated_time: 'Total Estimated Time',
            minutes: 'minutes',
            subscription_name: 'Subscription Name',
            subscription_description: 'Subscription Description',
            hours_config: 'Hours Configuration',
            peak_hours: 'Peak Hours',
            off_peak_hours: 'Off-Peak Hours',
            price_label: 'Subscription Price',
            price_value: 'Price: {price}{symbol}',
            vat: 'VAT',
            undated_ticket: 'Undated Ticket',
            visible_online: 'Visible Online',
            hidden_online: 'Hidden Online',
        },
    },
    registration: {
        welcome: 'Welcome to PlayPro',
        welcome_text: 'Play your next level — join PlayPro and start creating amazing experiences.',
        play_like_pro_text:
            'Level up your workflow — discover our features to schedule, track, manage, report and connect. All the tools, in one place.',
        no_credit_card: 'No credit card required to get started.',
        where_is_located: 'Where is your establishment located?',
        other_country: 'Other country',
        personal_info: 'Personal Information',
        tell_us_more: 'Tell us a bit about yourself',
        create_account: 'Create your account',
        configure_access: 'Configure your secure access and personalized address.',
        ready_to_launch: 'Ready to launch?',
        final_step: 'Final step',
        seconds_away: 'Just a few seconds before accessing your new workspace.',
        finish_registration: 'Create my account',
        creating_account: 'Creating account...',
        back: 'Back',
        next: 'Continue configuration',
        terms_label: 'I accept the {cgvu} and the {privacy}.',
        offers_label: 'I want to receive exclusive offers and deals.',
        start_now: 'Start now',
        testimonials_title: 'Real stories from real pros - discover why they love PlayPro.',
        play_like_pro: 'Play like a Pro.',
        subdomain_label: 'Desired URL',
        subdomain_hint: 'Use letters, numbers and hyphens.',
        subdomain_setup_later: 'You can configure a custom domain later.',
        your_store: 'Your store',
        administration: 'Administration',
        privacy_policy: 'Privacy policy',
        password_label: 'Password',
        confirm_password_label: 'Confirm password',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Professional email address',
        phone: 'Phone',
        company: 'Company name',
        company_address: 'Company address',
        city: 'City',
        placeholders: {
            firstName: 'John',
            lastName: 'Doe',
            email: 'john.doe@company.com',
            phone: ' 000 000 000',
            company: 'My Great Company',
            company_address: '123 Peace Street, 10001 New York',
            city: 'New York',
            country: 'Country',
            subdomain: 'establishment-name',
            password: 'At least 8 characters',
        },
        validation: {
            subdomain_format: 'Invalid format (only letters, numbers and hyphens are allowed).',
            subdomain_unavailable: 'This name is already in use.',
            password_length: 'Password must be at least 8 characters long.',
            password_mismatch: 'Passwords do not match.',
        },
        countries: {
            FR: 'France',
            BE: 'Belgium',
            LU: 'Luxembourg',
            CH: 'Switzerland',
            ES: 'Spain',
            IT: 'Italy',
            US: 'United States',
            GB: 'United Kingdom',
            AD: 'Andorra',
            GP: 'Guadeloupe',
            MQ: 'Martinique',
            RE: 'Réunion',
            PF: 'French Polynesia',
            NC: 'New Caledonia',
            CA: 'Canada',
            MG: 'Madagascar',
            OTHER: 'Other country',
        },
        reviews: {
            title: 'Trusted by global leaders.',
            subtitle: 'PlayPro already helps over 5,000 establishments across Europe digitalize their customer experience.',
            quote1: 'PlayPro has completely transformed the way we manage bookings. It is intuitive and extremely powerful.',
            author1: 'Marc Robs',
            role1: 'Sports Club Director',
            quote2: 'The support is exceptional and the interface is the cleanest I have seen on the market.',
            author2: 'Jane Copper',
            role2: 'Aquatic Center Manager',
            quote3: "PlayPro's onboarding process is the simplest I have ever used. In 2 minutes, everything was configured and ready.",
            author3: 'Camila Souza',
            role3: 'Franchise Manager',
            quote4: 'A complete solution that saves us hours every week. A must-have for any manager.',
            author4: 'Antoine Leroy',
            role4: 'CEO Fitness Group',
        },
        email_verification_error: 'An error occurred while verifying the email.',
        create_workspace: 'Create your workspace',
        subdomain_description:
            'This is the address your customers will use to book online. You can configure a custom domain later.',
        terms_suffix: 'Terms & Conditions',
        country: 'Country',
    },
    exports_v3: {
        comptable_title: 'Accounting Documents',
        comptable_description:
            'Official documents for accounting: accounting entries (FEC), sales reports, and PDF sales invoices.',
        date_range_label: 'Date or period',
        ticket_x_period_hint: 'Period: the current day, since the last cash closing.',
        document_label: 'Document',
        options: {
            ticket_z_pdf: 'Sales Report (PDF)',
            fec: 'Accounting Entries',
            ticket_z_excel: 'Sales Report (Excel)',
            factures_pdf: 'Sales Invoices (PDF)',
            ticket_x_encaissements: 'Collections X-Ticket (PDF)',
            ticket_x_ventes: 'Sales X-Ticket (PDF)',
            ticket_x_encaissements_excel: 'Collections X-Ticket (Excel)',
            ticket_x_ventes_excel: 'Sales X-Ticket (Excel)',
            mes_commandes: 'My Orders (Excel)',
            reservations: 'Reservations (Excel)',
        },
        operationnel_title: 'Operational Reports',
        operationnel_description: 'View daily activity and control your cash registers. Non-accounting – for internal use only.',
        report_label: 'Report',
        history_title: 'History',
        columns: {
            file: 'File',
            period: 'Period',
            generated_at: 'Generated on',
            size: 'Size',
            generated_by: 'Generated by',
            action: 'Action',
        },
        messages: {
            fetch_history_error: 'Error loading history',
            select_dates_error: 'Please select a start date and an end date.',
            export_success: 'Export started successfully!',
            export_error: 'Error generating document',
            operationnel_success: 'Operational report generated!',
            operationnel_error: 'Error generating report',
            download_error: 'Download link unavailable',
        },
        period_popup: {
            title: 'Période non disponible',
            message:
                'Le téléchargement ne peut être effectué en une fois sur la période sélectionnée. Veuillez sélectionner une période se terminant ou débutant au 1er juin 2026.',
            button: "D'accord",
        },
        generate: 'Generate',
    },
    promotions: {
        in_use: {
            title: 'Delete this promo code?',
            description:
                'It is currently used on {count} pending quote(s). You can disable it (it stays on those quotes but is no longer offered for new ones) or revoke it (also removed from them).',
            disable: 'Disable only',
            revoke: 'Revoke on quotes',
        },
        title: 'Internal name',
        title_promotion: 'Promo codes',
        add: 'Add a promotion',
        btn_add: 'Create',
        not_defined: 'Not defined',
        every_day: 'Every day',
        unlimited_uses: 'Unlimited',
        edit: 'Edit a promotion',
        repetition_by_days: 'Repetition by days',
        apply_on_reservation_date: 'Apply on reservation date',
        description: 'Manage your promo codes and discounts.',
        description_title: 'Description',
        description_placeholder: 'Describe your promo code (optional)',
        form_description: 'Configure your promotion details, usage limits, and linked items.',
        no_expiration: 'No expiration date',
        number_of_uses: 'Number of uses',
        generate_randomly: 'Generate randomly',
        usage_limits: 'Usage Limits',
        total_uses: 'Total uses',
        uses_per_user: 'Uses per customer',
        validation_uses_required: 'The number of uses is required.',
        amount_limits: 'Amount Limits',
        min_amount: 'Min amount',
        max_amount: 'Max amount',
        options: 'Options',
        back_office_only: 'Point of Sale only (Back-office)',
        has_linked_items: 'Restrict to specific items',
        linked_items_configuration: 'Linked Items Configuration',
        prestation_categories: 'Prestation Categories',
        product_categories: 'Product Categories',
        food_categories: 'Food Categories',
        prestations: 'Prestations',
        products: 'Products',
        packages: 'Packages',
        series: 'Series',
        treatments: 'Subscriptions',
        success: 'Success',
        promotion_added: 'Promotion added successfully',
        promotion_updated: 'Promotion updated successfully',
        promotion_deleted: 'Promotion deleted successfully',
        fetch_error: 'Error fetching promotions',
        promotion_enabled: 'Promotion enabled',
        promotion_disabled: 'Promotion disabled',
        delete_promotion_title: 'Delete Promotion',
        delete_promotion_confirm: 'Are you sure you want to delete this promotion?',
        active: 'Active',
        activated: 'Activated',
        disabled: 'Disabled',
        expired: 'Expired',
        no_expiration_date: 'None',
        start_date: 'Start date',
        end_date: 'End date',
        discount_type: 'Discount type',
        discount_amount: 'Amount',
        discount_pourcent: 'Percentage',
        percentage: 'Percentage',
        fixed_amount: 'Fixed amount',
        main_information: 'Main information',
        code: 'Code',
        discount_details: 'Discount',
        datatable: {
            title: 'Internal name',
            code: 'Code',
            discount_type: 'Discount type',
            discount_amount: 'Discount',
            start_date: 'Start date',
            expiration_date: 'Expiration date',
            status: 'Status',
            actions: 'Actions',
            uses: 'Qty.',
            used: 'Times used',
        },
        actions: {
            edit: 'Edit',
            enable: 'Enable',
            disable: 'Disable',
            delete: 'Delete',
        },
        linked_items: {
            prestation_categories: 'Experience categories',
            product_categories: 'Product categories',
            food_categories: 'Food categories',
            prestations: 'Experiences',
            products: 'Products',
            packages: 'Packages',
            series: 'Subscriptions',
            treatments: 'Subscriptions',
            combo: 'Combos packages',
            foods: 'Food',
            foodPacks: 'Combo meals ',
        },
        limit_order_type: 'Limit usage to an order type',
        order_types: {
            voucher: 'Gift voucher',
            prestation: 'Experience',
            product: 'Product',
            food: 'Food',
        },
        reviews: {
            code: 'Promo code',
            uses: 'Number of uses',
            remise: 'Discount',
            expiration: 'Expiration',
            limit_per_user: 'Usage limit per customer',
            shop_min_amount: 'Minimum cart amount',
        },
        title_eligibility: 'Eligibility',
        days: {
            mon: 'M',
            tue: 'TU',
            wed: 'W',
            thu: 'T',
            fri: 'F',
            sat: 'SA',
            sun: 'S',
        },
    },
    subscription: {
        status: {
            active: 'Active',
            canceled: 'Canceled',
            past_due: 'Past Due',
            incomplete: 'Incomplete',
            trialing: 'Trial',
            unpaid: 'Unpaid',
            inactive: 'Inactive',
        },
        hero: {
            title: 'From booking to performance.',
            subtitle: 'Built for Experience Creators who want to manage, sell, and retain customers. Simply.',
        },
        plans: {
            free: {
                name: 'Free',
                subtitle: 'To discover PlayPro',
                button: 'Continue with Free',
                features: ['Bookings', 'Online and on-site payments', 'Standard website', 'Customer database management'],
            },
            essentiel: {
                name: 'Essential',
                subtitle: 'To manage your business',
                button: 'Continue with Essential',
                features: ['Autonomous billing', 'Payment by installments', 'Multi-activity pack', 'Entry book'],
            },
            pro: {
                name: 'Pro',
                subtitle: 'To boost your growth',
                button: 'Continue with Pro',
                badge: 'Popular',
                features: [
                    'Additional sales add-on',
                    'Customer loyalty tools',
                    'Quote management',
                    'Professional POS application',
                ],
            },
            premium: {
                name: 'Premium',
                subtitle: 'For multi-activity centers or networks',
                button: 'Continue with Premium',
                features: [
                    'Custom mobile app',
                    'QR Code table ordering',
                    'Quote signature & follow-up',
                    'Priority WhatsApp support 24/7',
                ],
            },
        },
        plan_required: {
            essentiel: 'Essential plan required',
            premium: 'Premium plan required',
        },
        common: {
            monthly_ht: 'Price excl. VAT / month',
            unlimited: 'unlimited',
            unlimited_singular: 'unlimited',
            on_quote: 'on quote',
            limit_300: '300',
            limit_2: '2',
            limit_1: '1',
            optional: 'Optional',
            free_price: '0€',
            essentiel_price: '39€',
            pro_price: '119€',
            premium_price: '199€',
            soon: 'Soon',
            '1_pos': '1 POS',
            '2_pos': '2 POS',
            '5_pos': '5 POS',
            price_145: '145€ / excl. VAT',
            price_65: '65€ / excl. VAT',
            price_85: '85€ / excl. VAT',
            error_checkout: 'Unable to initiate payment. Please try again.',
            error_portal: 'Unable to access the customer portal. Please try again.',
            upgrade: 'Upgrade',
            current_plan: 'Current plan',
            continue_free: 'Continue for free',
            activate_plan: 'Activate {plan}',
            continue_free_done: 'You are now on the free plan.',
            unlimited_feminine: 'unlimited',
        },
        table: {
            categories: {
                booking: 'Booking and experiences',
                website: 'Website & Visibility',
                payment: 'Payment & Collection',
                billing: 'Billing & Quotes',
                collection: 'Collection',
                marketing: 'Marketing & Loyalty',
                automation: 'AI & Automations',
                team: 'Team & HR',
                support: 'Support & Training',
                complementary_services: 'Complementary services',
            },
            features: {
                manual_booking: 'Manual bookings',
                multi_activity_creation: 'Multi-activity creation',
                multi_activity_packs: 'Multi-activity packs creation',
                registered_customers: 'Registered customers',
                crm_access: 'Customer CRM access',
                absent_tracking: 'Absent customer tracking & management',
                quote_requests: 'Online quote requests',
                additional_sales: 'Additional sales',
                customer_export: 'Customer database export',
                monthly_reservations: 'Monthly reservations',
                activity_creation: 'Activity creation',
                unpaid_followup: 'Unfinished reservation follow-up',
                multi_languages: 'Multi-languages',
                custom_website: 'Custom website',
                booking_widget: 'Booking widget on your site',
                custom_domain: 'Custom domain name',
                remove_playpro_logo: 'PlayPro logo removal',
                custom_mobile_app: 'Custom mobile app',
                online_payment: '100% secure online payment (Stripe)',
                on_site_payment: 'On-site payment',
                deposit_percentage: 'Payment with percentage deposit',
                deposit_fixed: 'Payment with fixed amount deposit',
                invoice_edition: 'Invoice edition',
                quote_generation: 'Quote generation & edition',
                kanban_quotes: 'Quote tracking in Kanban view',
                brochure_with_quote: 'Brochure creation & sending with quote',
                deposit_management: 'Deposit tracking and management',
                auto_quote_followup: 'Automatic quote follow-up',
                electronic_signature: 'Electronic signature of quotes',
                pos_app: 'POS application (iOS/Android)',
                offline_pos: 'Offline mode for POS',
                qr_code_order: 'QR Code order',
                stock_management: 'Stock management',
                promo_codes: 'Promo code generation',
                entry_books: 'Entry book creation',
                newsletters: 'Newsletter email campaigns',
                loyalty_programs: 'Loyalty programs',
                gift_cards: 'Automated gift card management',
                cse_ticketing: 'Corporate Committee ticketing (CSE)',
                subscriptions: 'Subscription creation & management',
                wallet: 'Wallet (e-wallet)',
                referral_program: 'Referral program',
                dynamic_pricing: 'Dynamic pricing (Early Birds)',
                advanced_stats: 'Advanced statistics',
                auto_emails: 'Automatic emails (reminder, anniversary,..)',
                karafun_integration: 'Karafun integration',
                google_calendar_sync: 'Google Calendar synchronization',
                booking_api: 'Booking API',
                mcp_server: 'MCP server connection',
                custom_email_server: 'Send emails from your own mailbox',
                multi_establishment: 'Multi-establishment management',
                employee_accounts: 'Number of employee accounts',
                employee_permissions: 'Employee permissions & roles',
                team_planning: 'Team planning',
                ai_assistant: 'Personalized AI assistant',
                email_support: 'Email support',
                whatsapp_support: '24/7 Whatsapp support',
                data_migration_file: 'Data migration (by file)',
                onboarding_training: 'Hands-on training (per hour)',
                exceptional_intervention: 'Exceptional intervention (per hour)',
                data_migration: 'Data migration (on quote)',
                events_tracking: 'Advanced data tracking via GTM/Matomo',
            },
        },
        manage: {
            title: 'Manage my subscription',
            subtitle: 'Manage your plans, invoices and payment options',
            current_offer: 'CURRENT OFFER',
            trial: 'Trial',
            active_since: 'ACTIVE SINCE',
            billing: 'BILLING',
            monthly: 'Monthly',
            manage: 'Manage',
            change_plan: 'Change plan',
            invoices: 'Invoices',
            stripe_portal_title: 'Find your invoices on our Stripe portal',
            stripe_portal_desc: 'Manage and easily view all your invoices from our secure billing portal powered by Stripe.',
            access_invoices: 'Access my invoices',
            cancel_confirm_title: 'Cancel subscription?',
            cancel_confirm_text: 'Your subscription will remain active until the end of the current billing period.',
            cancel_success: 'Subscription canceled.',
            current_offer_badge: 'CURRENT OFFER',
            renewal: 'RENEWAL',
            billing_cycle: 'BILLING CYCLE',
            status: 'STATUS',
            manage_button: 'Manage',
            change_plan_button: 'Change plan',
            invoices_title: 'Invoices',
            stripe_text:
                'Find your invoices on our Stripe portal. Easily manage and view all your invoices from our secure billing portal powered by Stripe.',
            access_invoices_button: 'Access my invoices',
            table_badge: 'Plans & pricing',
            table_title: 'Comparison of offers',
            table_subtitle: 'Choose the plan suited to your business',
            upgrade_to: 'Switch to {plan}',
            change_offer: 'Change plan',
            cancel_subscription: 'Cancel subscription',
            resume_subscription: 'Resume subscription',
            downgrade: 'Change plan',
            trial_badge: 'Trial',
        },
        faq: {
            title_top: 'Frequently Asked',
            title_bottom: 'Questions',
            subtitle: 'All the answers to your questions about our offers and features.',
            items: [
                {
                    question: 'Is PlayPro free?',
                    answer: 'PlayPro offers plans tailored to teams of all sizes, with a free option ideal for small structures or starting projects. Our paid subscriptions offer advanced features for growing teams or those needing more management tools.',
                },
                {
                    question: 'What payment methods are available?',
                    answer: 'We accept all major credit cards and bank transfer payments.',
                },
                {
                    question: 'Can I import data from other tools?',
                    answer: 'Yes, PlayPro allows importing your data from other platforms to facilitate your migration.',
                },
                {
                    question: 'Do you offer monthly and annual subscriptions?',
                    answer: 'Yes, we offer both monthly and annual subscriptions. Annual subscriptions often benefit from discounts.',
                },
                {
                    question: 'Does PlayPro have an API?',
                    answer: 'Yes, PlayPro has a full API for Pro and Premium plans, allowing you to integrate our platform with your existing tools.',
                },
            ],
        },
        redirecting_portal: 'Redirecting to portal...',
        redirecting_stripe: 'Redirecting to Stripe...',
        cancelling: 'Cancelling...',
        cancelled: 'Subscription cancelled: it stays active until the end of the current period.',
        cancelled_until: 'Subscription cancelled: it stays active until {date}.',
        resumed: 'Subscription resumed: the cancellation has been called off.',
        banner: {
            payment_failed_title: 'Payment failed',
            payment_failed_message:
                'Your subscription payment has failed. Please update your payment method to avoid account suspension.',
            canceling_title: 'Subscription being cancelled',
            canceling_message: 'Your subscription will remain active until {date}. After this date, your access will be limited.',
            warning_title: 'Warning',
            warning_message: 'An action is required on your subscription.',
        },
    },
    widget: {
        load_activities_error: 'Error loading activities',
        verify_activity_error: 'Error verifying activity',
        load_quotes_error: 'Error loading quotes',
        load_categories_error: 'Error loading categories',
        load_services_error: 'Error loading services and packages',
        load_combos_error: 'Error loading combo formulas',
        load_events_error: 'Error loading events',
        load_series_error: 'Error loading series',
        load_vouchers_error: 'Error loading undated tickets',
    },
    website_settings: {
        title: 'Website',
        tabs: {
            general: 'Appearance',
            sections: 'Sections',
            pages: 'Pages',
            footer: 'Footer',
            faq: 'FAQ',
            seo: 'SEO',
            menu: 'Menu',
            mobile_intro: 'Mobile App',
            privacy: 'Privacy Policy',
            cguv: 'Legal Notice',
            outils: 'Tools',
        },
        general: {
            title: 'Appearance',
            sections_banner_info:
                'These sections appear on several pages of your website to highlight your content, products or important information.',
            customize_style: 'Template Selection',
            template_section: 'Template Selection',
            slider_section: 'Slider Images',
            slider_images: 'Slider Images',
            click_or_drop: 'Click or drop an image',
            position_image: 'Position Image',
            preview: 'Preview',
            no_preview: 'No preview available',
            aspect_16_9: '16:9 (Landscape)',
            aspect_4_3: '4:3 (Standard)',
            aspect_square: 'Square 1:1',
            aspect_free: 'Free',
            slider_title: 'Welcome Title',
            slider_desc: 'Welcome Description',
            welcome_title: 'Welcome Title',
            welcome_desc: 'Welcome Description',
            colors_section: 'Theme Colors',
            primary_color: 'Primary Color',
            secondary_color: 'Secondary Color',
            tertiary_color: 'Tertiary Color',
            menus_color: 'Menu Color',
            action_text_color: 'Action Text Color',
            options_section: 'Options',
            show_reservation_header: 'Show Reservation Header',
            show_available_places: 'Show Available Places',
            reservation_section: 'Reservation Page',
            reservation_title: 'Page Title',
            reservation_image: 'Header Image',
            cover: 'Cover Image',
            gift_card_section: 'Gift Card',
            gift_card_title: 'Title',
            gift_card_desc: 'Description',
            gift_card_image: 'Image',
            undated_ticket_section: 'Undated Ticket',
            undated_ticket_title: 'Title',
            undated_ticket_desc: 'Description',
            undated_ticket_image: 'Image',
            undated_title: 'Title',
            undated_cover: 'Cover Image',
            undated_desc: 'Description',
            undated_image: 'Image',
            vouchers_warning: 'Offer gift vouchers for sale to activate this section.',
            undated_tickets_warning: 'Offer undated tickets on an experience to activate this section.',
            restoration_section: 'Catering',
            restoration_title: 'Title',
            restoration_desc: 'Description',
            restoration_image: 'Image',
            configure_now: 'Configure now',
            discovery_offer_section: 'Discovery Offer',
            discovery_offer_title: 'Title',
            discovery_offer_desc: 'Description',
            discovery_offer_image: 'Image',
            discovery_section: 'Discovery Offer',
            discovery_title: 'Title',
            discovery_desc: 'Description',
            discovery_image: 'Image',
            partners_section: 'Partners',
            partner_name: 'Partner Name',
            partner_name_placeholder: 'Ex: Make your audience vibrate.',
            partner_logos: 'Partner Logos',
            partner_logo: 'Partner Logo',
            partner_link: 'Partner Link',
            partner_link_placeholder: 'Link...',
            partner_delete_confirm: 'Are you sure you want to delete this partner?',
            partner_deleted: 'Partner deleted',
            add_partner: 'Add Partner',
            category_section: 'Categories',
            categories_section: 'Categories',
            enable_shop: 'Enable Shop',
            category_men_title: 'Men Category Title',
            category_men_desc: 'Men Category Description',
            category_men_image: 'Men Category Image',
            category_women_title: 'Women Category Title',
            category_women_desc: 'Women Category Description',
            category_women_image: 'Women Category Image',
            category_child_title: 'Children Category Title',
            category_child_desc: 'Children Category Description',
            category_child_image: 'Children Category Image',
            men_category: 'Men Category',
            women_category: 'Women Category',
            children_category: 'Children Category',
            category_title: 'Title',
            category_desc: 'Description',
            category_image: 'Image',
            choices_section: 'Why us?',
            first_choice_title: 'Section Title',
            first_choice_desc: 'Description',
            second_choice_title: 'Section Title',
            second_choice_desc: 'Description',
            third_choice_title: 'Section Title',
            third_choice_desc: 'Description',
            choice_title: 'Section Title',
            choice_desc: 'Description',
            choice_icon: 'Icon',
            choice_title_placeholder: 'Ex: Make your audience vibrate.',
            choice_desc_placeholder:
                'Ex: Buy your ticket now and choose the day of your visit whenever you want! Perfect for offering or enjoying our park when it suits you.',
            slider_delete_confirm: 'Are you sure you want to delete this slider image?',
            image_deleted: 'Image deleted',
            tooltips: {
                gift_card: 'Configure the gift cards section on your site.',
                partners: 'Display your partners and their logos.',
                choices: 'Highlight your strengths.',
                undated_ticket: 'Offer tickets without a fixed date.',
                restoration: 'Offer a catering menu on your website.',
                discovery_offer: 'Highlight your welcome offers.',
                shop: 'Manage your online shop categories.',
                demande_devis: 'Configure the quote request section on your website.',
            },
            visual_identity: 'Visual Identity',
            logo: 'Logo',
            theme: 'Theme',
            home_banner: 'Home Banner',
            welcome_subtitle: 'Subtitle',
            welcome_subtitle_placeholder: 'Ex: Transform your idea into a memorable experience...',
            welcome_title_placeholder: 'Ex: Make your audience vibrant.',
            image_right: 'Image on right',
            carousel: 'Carousel',
            background_image: 'Background image',
            background_video: 'Background video',
            add_image: 'Add an image',
            themes: {
                v1: {
                    title: 'V1 - Image on right',
                    desc: 'A description A description',
                },
                v2: {
                    title: 'V2 - Carousel',
                    desc: 'A description A description',
                },
                v3: {
                    title: 'V3 - Background image',
                    desc: 'A description A description',
                },
                v4: {
                    title: 'V4 - Background video',
                    desc: 'A description A description',
                },
            },
            errors: {
                title_welcome_required: 'The welcome title is required',
                desc_welcome_required: 'Text is required',
                image_header_required: 'Image is required',
                primary_color_required: 'Primary color is required',
                secondary_color_required: 'Secondary color is required',
                menus_color_required: 'Menu color is required',
                action_text_color_required: 'Action text color is required',
            },
            demande_devis_section: 'Quote request',
            demande_devis_title: 'Section title',
            demande_devis_desc: 'Description',
            demande_devis_image: 'Image',
            demande_devis_logo: 'Logo',
            demande_devis_title_placeholder: 'Ex: Request a quote.',
            demande_devis_desc_placeholder: 'Ex: We will get back to you as soon as possible.',
        },
        footer: {
            title: 'Footer',
            global_toggle: 'Enable footer',
            global_toggle_tooltip: 'Show or hide the footer across your entire site.',
            identity_section: 'Visual Identity',
            footer_logo: 'Footer Logo',
            presentation_section: 'Presentation of your establishment',
            presentation_title_label: 'Presentation Title',
            presentation_title_placeholder: 'Ex: About us',
            contact_section: 'Contact Us',
            contact_info_banner: 'Your contact information is automatically retrieved from your establishment settings.',
            configure_now: 'Configure now',
            contact_title: 'Contact Title',
            contact_desc: 'Contact Description',
            contact_button_text: 'Button Text',
            footer_desc_section: 'Footer Description',
            opening_hours_section: 'Opening Hours',
            hours_label: 'Enable custom opening hours',
            hours_info_banner_1: 'Your opening hours are automatically retrieved from your',
            hours_info_banner_link: 'establishment settings',
            hours_info_banner_2: 'You can customize them in text format, they will replace those displayed on your website.',
            hours_placeholder: 'Ex: Closed, 9am - 6pm, on request...',
            social_networks: 'Social networks',
            social: {
                facebook: 'Facebook',
                linkedin: 'LinkedIn',
                youtube: 'YouTube',
                twitter: 'Twitter/X',
                instagram: 'Instagram',
                tiktok: 'TikTok',
                pinterest: 'Pinterest',
                snapchat: 'Snapchat',
                telegram: 'Telegram',
                threads: 'Threads',
            },
            analytics: {
                google_analytics: 'Google Analytics',
                facebook_pixel: 'Facebook Pixel',
            },
            analytics_tracking: 'Analytics & Tracking',
            custom_script: 'Custom Script',
            save_success: 'Footer saved successfully',
            placeholders: {
                logo: 'Logo...',
                presentation_desc:
                    'Present your activity in a few words: what you do, for whom, and what makes you unique. Ideally, use relevant keywords to improve your referencing.',
                contact_title: 'Contact us',
                contact_desc: 'Do you have questions ?...',
                contact_button: 'Send...',
                facebook: 'https://facebook.com/..',
                linkedin: 'https://linkedin.com/..',
                youtube: 'https://youtube.com/..',
                twitter: 'https://twitter.com/..',
                instagram: 'https://instagram.com/..',
                tiktok: 'https://tiktok.com/..',
                footer_desc: 'Footer description',
                custom_script: 'Custom script code...',
                pinterest: 'https://pinterest.com/..',
                snapchat: 'https://snapchat.com/..',
                telegram: 'https://telegram.me/..',
                threads: 'https://threads.net/..',
            },
            days: {
                monday: 'Monday',
                tuesday: 'Tuesday',
                wednesday: 'Wednesday',
                thursday: 'Thursday',
                friday: 'Friday',
                saturday: 'Saturday',
                sunday: 'Sunday',
            },
        },
        about: {
            title: 'About',
            reservation_section: 'Reservation',
            reservation_url: 'https://demotenant.playpro.fr/reservation',
            display_order: 'Display Order',
            display_orders: {
                experiences_first: 'Experiences first',
                categories_first: 'Categories first',
            },
            background_color: 'Background Color',
            main_info: 'Main Information',
            main_title: 'Main Title',
            second_title: 'Second Title',
            description: 'Description',
            description_placeholder: 'Enter description',
            content: 'Content',
            image: 'Presentation Image',
            presentation_image: 'Presentation Image',
            cover_image: 'Cover Image',
            cover_image_recommendation: '1500 x 450 pixels recommended',
            missions_section: 'Our Missions',
            mission_section: 'Our Mission',
            add_mission: 'Add Mission',
            mission_title_placeholder: 'Mission title',
            mission_desc_placeholder: 'Mission description',
            mission_number: 'Mission #',
            missions_empty: 'No missions added',
            gallery_section: 'Photo Gallery',
            gallery_image_recommendation: '440 x 320 pixels recommended',
            save_success: 'About saved successfully',
            gallery_delete_confirm: 'Are you sure you want to delete this image from the gallery?',
            gallery_empty: 'No images in the gallery',
            add_photo: 'Add Photo',
            delete_image: 'Delete image',
            reset_success: 'Form reset',
            delete_success_gallery: 'Image deleted from the gallery',
            content_management: 'Content Management',
        },
        cguv: {
            title: 'Terms and Conditions of Sale',
            label: 'T&C Content',
            placeholder: 'Enter your T&C here...',
            privacy_title: 'Privacy Policy',
            privacy_label: 'Privacy Policy Content',
            privacy_placeholder: 'Enter your privacy policy here...',
            show_cguv: 'Use a link to my Terms and Conditions of Sale and Use (CGUV).',
            show_privacy: 'Use a link to my Privacy Policy.',
            link_label: 'Link to CGUV',
            link_placeholder: 'Enter the link to your CGUV here...',
            privacy_link_label: 'Link to Privacy Policy',
            privacy_link_placeholder: 'Enter the link to your privacy policy here...',
            save_success: 'Legal notice saved successfully',
        },
        mobile_intro: {
            title: 'Configure: Mobile App Intro',
            screen_section: 'Introduction Screen',
            name_label: 'Name',
            name_placeholder: 'Enter the name',
            description_label: 'Description',
            description_placeholder: 'Enter the description',
            image_label: 'Image',
            upload_image: 'Upload image',
            save_success: 'Mobile intro saved successfully',
        },
        menu: {
            title: 'Menu settings',
            info_banner:
                "Manage the elements displayed in your website's navigation menu. You can enable or disable each element and modify its label.",
            placeholder: 'Menu title',
            placeholder_prefix: 'Ex: ',
            footer_title: 'Site footer',
            footer_label: 'Enable site footer (Yes/No)',
            save_success: 'Menu settings saved',
            sections: {
                about: 'About',
                about_placeholder: 'Concept, Who are we?',
                about_label: 'Menu title "About"',
                discover: 'Our Offers',
                res: 'Book',
                res_label: 'Menu title "Book"',
                offer: 'Discovery Offer',
                offer_label: 'Menu title "Discovery Offer"',
                gift: 'Gift Voucher',
                gift_label: 'Menu title "Gift Voucher"',
                event: 'Events',
                event_label: 'Menu title "Events"',
                sub: 'Subscriptions',
                sub_label: 'Menu title "Subscriptions"',
                rest: 'Restaurant',
                rest_label: 'Menu title "Restaurant"',
                help: 'Help Us',
                help_label: 'Menu title "Help Us"',
                contact: 'Contact Us',
                contact_placeholder: 'Contact Us',
                contact_label: 'Menu title "Contact Us"',
                shop: 'Shop',
                shop_placeholder: 'Shop',
                shop_label: 'Menu title "Shop"',
                blog: 'Blog',
                blog_placeholder: 'Blog',
                blog_label: 'Menu title "Blog"',
                evg: 'Bachelor Party Quote',
                evg_placeholder: 'Bachelor Party Quote',
                evg_label: 'Menu title "Bachelor Party"',
                ent: 'Company Quote',
                ent_placeholder: 'Company Quote',
                ent_label: 'Menu title "Company"',
                anv: 'Birthday Quote',
                anv_placeholder: 'Birthday Quote',
                anv_label: 'Menu title "Birthday"',
            },
        },
        seo: {
            title: 'SEO Management',
            info_banner: 'Optimize the referencing of each page on search engines by customizing the SEO tags.',
            section_prefix: '',
            configured: 'Configured',
            configured_badge: 'Configured',
            to_configure_badge: 'To configure',
            no_description: 'No description configured',
            title_label: 'SEO Title',
            title_placeholder: 'Ex: [Main activity] in [City] - [Establishment name]',
            description_label: 'Meta description',
            description_placeholder:
                'Ex: Discover [main activity] in [city]. Ideal for [birthdays / family outings / team building]. Book your session online now.',
            image_label: 'Image displayed when sharing the URL on social networks',
            image_size_recommendation: 'JPG, JPEG, PNG - less than 5 MB',
            empty_state: 'No pages to configure at the moment',
            char_max: '{max} characters max',
            save_success: 'SEO settings saved successfully',
        },
        faq: {
            title: 'FAQ',
            info_banner: 'The FAQ appears on several pages of your website to answer general questions your customers may have.',
            question_label: 'Question',
            question_label_numbered: 'Question #{n}',
            question_placeholder: 'Ex: How to book an activity?',
            answer_label: 'Answer',
            answer_label_numbered: 'Answer #{n}',
            answer_placeholder:
                'Ex:\n1. Choose your activity (tennis, paintball, VR, painting workshop, etc.)\n2. Select the available date and time\n3. Indicate the number of participants\n4. Pay online\n5. Receive a confirmation by email',
            add_question_button: 'Add a question',
            ai_helper_button: 'Ask AI for help',
            ai_helper_label: 'Describe the topic of your FAQs',
            ai_helper_placeholder: 'Ex: Questions about opening hours and prices of an amusement park',
            ai_generate_button: 'Generate FAQs',
            ai_generating: 'Generating...',
            move_up: 'Move up',
            move_down: 'Move down',
            remove: 'Remove',
            add: 'Add',
            empty_state: 'No questions have been added',
            save_success: 'FAQ saved successfully',
            ai_success: 'FAQs generated successfully!',
            ai_empty: 'No FAQs generated. Try another description.',
            ai_error: 'Error generating FAQs',
            errors: {
                question_required: 'Question is required',
                answer_required: 'Answer is required',
            },
        },
        outils: {
            title: 'Tools: Integrate Advanced Features on Your Site',
            empty: 'No tools available',
            integrate: 'Integrate',
            visit_website: 'Visit website',
            modal: {
                title_default: 'Add Script',
                title_google_search: 'Paste your Google file content',
                title_google_analytics: 'Add Google Analytics key',
                label_default: 'Script',
                label_google_search: 'Content',
                label_google_analytics: 'Key',
                placeholder_default: 'script',
                placeholder_google_search: 'Paste your Google file content',
                placeholder_google_analytics: 'Enter Google Analytics key GTM-XXXXXX',
                error_required: 'The script is required',
                add: 'Add',
                clear: 'Clear',
                update_success: 'Tool updated successfully',
            },
        },
        privacy: {
            title: 'Privacy Policy',
            content_label: 'Privacy policy content',
            placeholder: 'Enter your privacy policy here...',
            save_success: 'Privacy policy saved successfully',
        },
        actions: {
            save: 'Save',
            saving: 'Saving...',
            save_success: 'Saved successfully',
            save_error: 'Error while saving',
            integrate_widget: 'Integrate Widgets',
            view_site: 'View Website',
            delete_error: 'Error deleting',
            reset: 'Reset',
        },
        reservation: {
            title: 'Reservation',
            main_title: 'Main title',
            description_placeholder: 'Ex: Our activities',
            display_order: 'Display order',
            reservation_url: 'https://demotenant.playpro.fr/reservation',
            display_orders: {
                experiences_first: 'Experiences first',
                categories_first: 'Categories first',
            },
            background_color: 'Background color',
        },
    },
    pos: {
        title: 'Points of sales (POS)',
        downloadPOS: 'Download PlayProPOS',
        add: 'Add a POS',
        edit: 'Edit a POS',
        save_success: 'POS saved successfully',
        delete_success: 'POS deleted successfully',
        deactivated: 'POS deactivated',
        activated: 'POS activated',
        device_id_label: 'Device ID',
        device_id_placeholder: 'Ex: POS-001',
        device_name_label: 'Device Name',
        device_name_placeholder: 'Ex: Main Register',
        status_label: 'Status',
        exit_title: 'Exit Form',
        exit_message: 'Are you sure you want to leave? Unsaved changes will be lost.',
        exit_confirm: 'Leave',
        exit_cancel: 'Stay',
        validation_device_id: 'The device ID is required.',
        validation_device_name: 'The device name is required.',
        status_active: 'Active',
        status_pending: 'Pending',
        status_inactive: 'Inactive',
        action_edit: 'Edit',
        action_deactivate: 'Deactivate',
        action_activate: 'Activate',
        action_delete: 'Delete',
        selected_items: '{count} item selected',
        selected_items_plural: '{count} items selected',
        delete_title: 'Delete register',
        delete_confirm_single: 'Are you sure you want to delete this register?',
        column_requested_by: 'Requested by',
    },
    applications: {
        delete_success: 'Application deleted successfully',
        save_success: 'Application saved successfully',
        selected_items: '{count} item selected',
        selected_items_plural: '{count} items selected',
        delete_title: 'Delete application',
        delete_confirm_single: 'Are you sure you want to delete this application?',
        column_id: 'Application ID',
        column_name: 'Application name',
    },
    api: {
        title: 'API',
        create: 'Create an application',
        download_documentation: 'Download API documentation',
        form: {
            title_edit: 'Edit API',
            title_add: 'Add API',
            name: {
                label: 'Application name',
                placeholder: 'e.g. Planea',
            },
            regenerate_secret: {
                label: 'Regenerate secret',
                placeholder: 'Regenerate secret',
            },
            scopes: {
                label: 'Allowed scopes',
                help: 'What this key may call. The partner requests these scopes when issuing a token; any other one is refused.',
                all: 'Select all',
                none: 'Clear all',
                empty: 'No scope available.',
                unrestricted: 'No scope selected: the key may call everything (behaviour of existing keys).',
            },
        },
        errors: {
            name_required: 'The application name is required.',
        },
        view_documentation: 'View documentation',
        add: 'Add an application',
        view: {
            identifiant: 'Application ID',
            secret: 'Application secret',
            title: 'Application details',
        },
    },
    cart: {
        title: 'Cart',
        empty: 'No items in the cart.',
        columns: {
            qty: 'Qty',
            designation: 'Description',
            unit_price: 'Unit Price',
            total_ttc: 'Total TTC',
        },
        item_types: {
            subscription: 'Subscription',
            package: 'Package',
        },
        alerts: {
            select_prepayment: 'Please select the prepayment to apply.',
            sale_clotured: 'This sale is closed',
        },
        fidelity: {
            points: 'Loyalty points',
            remaining: 'Remaining point(s):',
            discount: 'Loyalty discount',
        },
        payment: {
            acompte: 'Down payment',
            acompte_and_rest: 'Deposit and balance',
            acompte_to_pay: 'Deposit to pay:',
            already_paid: 'Already paid:',
            rest_to_pay: 'Balance to pay:',
            promo_code: 'Discount & Promo Code:',
            total_ttc: 'Total TTC:',
        },
        errors: {
            no_date: 'No date available',
            invalid_date: 'Invalid date',
        },
    },
    survey: {
        description: 'General description',
        image: 'Image',
        upload_image: 'Upload an image',
        question: 'Question',
        response_type: 'Response type',
        correct_answers_count: 'Number of correct answers',
        required_response: 'Required response',
        response_possibilities: 'Response possibilities',
        add_response: 'Add a new response',
        delete_question: 'Delete question',
        save_form: 'Save form',
        ai_help: 'Ask AI for help',
        ai_placeholder: 'Write your subject here...',
        question_placeholder: 'ex: How did you find your service?',
        number_placeholder: 'ex: 3',
        min_value: 'Minimum value',
        max_value: 'Maximum value',
        min_value_placeholder: 'ex: 0',
        max_value_placeholder: 'ex: 500',
        default_fields: {
            last_name: 'Last Name',
            first_name: 'First Name',
            phone: 'Phone',
            email: 'Email',
        },
        types: {
            multiple_choice: 'Multiple choice',
            single_choice: 'Single choice',
            choice_list: 'Choice list',
            free_choice_text: 'Free choice (text)',
            free_choice_number: 'Free choice (numbers)',
            date_time: 'Date and Time',
            date: 'Date',
            time: 'Time',
            long_text: 'Long text',
        },
    },
    available_soon: {
        title: 'This feature is coming back soon',
        description: 'This feature is temporarily unavailable during its redesign. It will return soon in an improved version.',
        back_home: 'Back to home page',
        image_alt: 'Maintenance illustration',
    },
    customerInfo: {
        customer_details: 'Customer details',
        professional: 'Professional',
        individual: 'Individual',
        form: {
            email: {
                label: 'Email address',
            },
            phone_number: {
                label: 'Phone number',
            },
            civility: {
                label: 'Civility',
            },
            address: {
                label: 'Address',
            },
            source_of_acquisition: {
                label: 'Source of acquisition',
                placeholder: '- Select a source of acquisition -',
            },
            note: {
                label: 'Note',
            },
            registered_for_communications: {
                label: 'Subscribed to communications',
            },
            groups: {
                label: 'Customer groups',
            },
        },
        titles: {
            additional_information: 'Additional information',
            orders_and_reservations: 'Orders and reservations',
            packages_and_subscriptions: 'Packages & Subscriptions',
            vouchers: 'Gift vouchers',
            groups: 'Groups',
        },
        metrics: {
            loyalty_points: 'Loyalty points',
            wallet: 'Wallet',
            reservations: 'Reservations',
            total_spent: 'Total amount spent',
            packages_and_subscriptions: 'Packages & Subscriptions',
            vouchers: 'Gift vouchers',
            groups: 'Groups',
            date_created: 'Creation date',
        },
        types: {
            treatment: 'Package',
            serie: 'Subscription',
        },
        status: {
            cancelled: 'Cancelled',
            upcoming: 'Upcoming',
            partially_paid: 'Partially paid',
            paid: 'Paid',
            pending: 'Pending',
            in_progress: 'In progress',
            closed: 'Closed',
        },
    },
    helpdesk: {
        index: {
            title: 'Help Centre',
            subtitle: 'Manage your support requests and track their progress',
            create_button: 'Create a ticket',
            loading: 'Loading tickets...',
            empty_title: 'No tickets at the moment',
            empty_subtitle: 'Do you need help?',
            empty_note: 'Please do not follow up with our teams as soon as you have submitted a ticket',
            info_banner: {
                label: 'Response time:',
                has_tickets:
                    'our team is committed to processing your ticket within 4 business days. The response will be communicated to you by email.',
                no_tickets:
                    'Our team is committed to processing your ticket within 3 to 14 days depending on the priority level. The response will be communicated to you by email.',
            },
            statuses: {
                active: 'Open',
                pending: 'In progress',
                closed: 'Resolved',
            },
        },
        form: {
            create_title: 'Create a support ticket',
            view_title: 'Ticket #{id}',
            create_description: 'Fill out the form below to create a new support ticket',
            view_description: 'Support ticket details',
            close: 'Close',
            send_ticket: 'Send ticket',
            subject: 'Subject',
            subject_placeholder: 'Enter the subject of your ticket',
            category: 'Category',
            priority: 'Priority',
            message: 'Message',
            text_placeholder: 'Describe your issue or suggestion with as much detail as possible',
            attachments: 'Attachments (optional)',
            status: 'Status',
            created_at: 'Creation date',
            client: 'Client',
            support: 'Support',
            download: 'Download',
            file: 'File',
            success_message:
                'Your request has been successfully transmitted. Our team will respond within 24 to 48 business hours.',
            user_not_available: 'User not available',
            priorities: {
                low: 'Low',
                normal: 'Normal',
                high: 'High',
                urgent: 'Urgent',
            },
            statuses: {
                active: 'Active',
                closed: 'Closed',
                pending: 'Pending',
            },
            categories: {
                technical: 'Technical issue',
                billing: 'Subscription / PlayPro Billing',
                suggestion: 'Improvement suggestion',
                onboarding: 'Onboarding',
            },
        },
    },
    planning_v3: {
        reservations: 'Reservations',
        today: 'Today',
        filters: 'Filters',
        saved_filters: 'Saved Filters',
        create_filter_placeholder: 'Create a new filter',
        no_filter: 'No saved filters',
        deselect_filter: 'Deselect filter',
        practitioners: 'Practitioners',
        spaces: 'Spaces',
        search_reservation: 'Search reservation...',
        add_reservation: 'Add a new reservation',
        take_reservation: 'Book a reservation',
        block_slot: 'Block time slot',
        export: 'Export',
        exporting: 'Exporting...',
        export_error: 'An error occurred during export.',
        select_all: 'Select all',
        clear: 'Clear',
        no_result: 'No results found',
        mixing_disabled_warning: 'The customer has disabled mixing authorization.',
        capacity: 'Capacity',
        generic_error: 'Oops! An error occurred.',
        label_total: 'Total:',
        search_placeholder: 'Search...',
        listing: {
            space: 'Space',
            qty: 'Qty.',
            persons: 'Pers.',
            note: 'Note',
            client_note: 'Client note',
            paid: 'Paid',
            free: 'Free',
            to_pay: '{amount} to pay',
            to_pay_short: 'to pay',
            no_reservations: 'No reservations',
            no_reservations_desc: 'There are no reservations scheduled for the selected period.',
            reservations_count: 'reservation',
            clients_count: '{n} client | {n} clients',
            days_count: '{n} day | {n} days',
        },
        modal_add: {
            title: 'Take a reservation',
            new_reservation: 'New reservation',
            client_section: 'CUSTOMER',
            client_existing: 'Existing client',
            client_new: 'New',
            client_walkin: 'Walk-in',
            select_client: 'Select a client',
            search_client: 'Search for a client...',
            experiences_section: 'EXPERIENCES',
            linked_only: 'Linked facilities only',
            date: 'DATE',
            time: 'TIME',
            duration: 'DURATION',
            players: 'PLAYERS',
            tickets: 'TICKETS',
            tickets_required: 'Choose at least one ticket for each ticketing experience.',
            space: 'SPACE',
            practitioner: 'PRACTITIONER',
            slot: 'SLOT',
            options_label: 'OPTIONS',
            total_price: 'TOTAL PRICE',
            add_experience: 'Add an experience',
            options_section: 'OPTIONS',
            payment_link: 'Send payment link',
            send_quote: 'Generate and send quote',
            internal_note_section: 'INTERNAL NOTE',
            internal_note_placeholder: 'Add a note visible ONLY to the team',
            create_reservation: 'Create reservation',
        },
        modal_view: {
            title_resa: 'Reservation',
            title_lunch: 'Lunch break',
            title_indispo: 'Unavailability',
            tickets: 'TICKETS',
            optional_products: 'OPTIONAL PRODUCTS',
            reassort: 'RESTOCK/REASSORT',
            order_section: 'ORDER',
            no_description: 'No description provided.',
            tab_slots: 'Slots',
            tab_booking: 'Booking',
            tab_options: 'Tickets/Options',
            confirm_absent: 'Mark this client as absent?',
            confirm_delete_booking: 'Are you sure you want to delete this booking?',
            confirm_delete_slot: 'Are you sure you want to delete this time slot?',
            timeslot_label: 'Time',
            activity_label: 'Activity',
            duration_label: 'Duration',
            modify_btn: 'Modify',
            cancel_slot_btn: 'Cancel slot',
            delete_irreversible: 'Deleting this slot is irreversible',
            confirm_btn: 'Confirm',
            cancel_btn: 'Cancel',
            encaisser_btn: 'Process reservation',
            send_to_client_section: 'Send to customer',
            booking_reminder_btn: 'Booking reminder',
            payment_link_btn: 'Payment link',
            management_section: 'Management',
            order_detail_btn: 'Order detail',
            duplicate_btn: 'Duplicate',
            absent_client_btn: 'Absent customer',
            merge_btn: 'Merge',
            select_locker_title: 'Select a locker',
            modify_staffs_label: 'Modify staffs',
            no_result_for: 'No results for',
            total_order: 'Order total:',
            generate_payment_link: 'Generate payment link',
            confirm_and_create: 'Confirm and Create',
            internal_note_section: 'Internal note',
            internal_note_placeholder: 'Add a note visible only to the team',
            history_section: 'History',
            no_history: 'No history available',
            cancel_booking_btn: 'Cancel booking',
            reminder_sent_alert: 'Reminder sent!',
            payment_link_sent_alert: 'Payment link sent!',
            cancel_view: {
                absent_message:
                    'Your customer did not show up for their appointment. You can cancel this appointment according to the following actions:',
                quit_btn: 'Exit',
                view_details_btn: 'View Details',
                order_closed_alert: 'The order has already been closed.',
                activate_actions_btn: 'Activate actions',
                collect_rest_label: 'Collect the rest of the order:',
                collect_btn: 'collect',
                refund_btn: 'refund',
                confirm_and_action: 'Confirm and {action}',
                system_refund_criteria: 'Collect / Refund according to system refund criteria:',
                refund_without_conditions: 'Cancel and refund without taking into account system refund criteria',
                cancel_without_refund_or_collect: 'Cancel only, without refunding or collecting.',
                cancel_only_btn: 'Cancel only',
                success_delete_msg: 'Deletion {msg}',
                success_absent_msg: 'Cancellation {msg}',
                success_completion_msg: ' was completed successfully and you have {action} {amount} {currency}.',
                earned: 'earned',
                lost: 'lost',
            },
            tabs: {
                details: 'Details',
                client: 'Client',
                options: 'Options',
            },
            sections: {
                experience: 'EXPERIENCE',
                space: 'SPACE',
                practitioner: 'PRACTITIONER',
                date_time: 'DATE & TIME',
                players: 'PLAYERS',
                price: 'PRICE',
                internal_note: 'INTERNAL NOTE',
                cancel_reservation: 'CANCEL RESERVATION',
            },
            cancel_section: {
                title: 'Cancel reservation',
                reason_placeholder: 'Cancellation reason...',
                confirm_button: 'Confirm cancellation',
                success_msg: 'Reservation cancelled successfully.',
            },
            select_locker: 'Select a locker',
            edit_staffs: 'Edit staffs',
            loading: 'Loading...',
        },
        anonymous_client: 'Anonymous Client',
        payment_status: {
            to_pay: '{amount}€ to pay',
            paid: 'Paid',
        },
        modal_block: {
            title: 'Block time slot',
            period_section: 'PERIOD',
            start: 'Start',
            end: 'End',
            recurrent: 'Enable recurrence',
            targets_section: 'TARGETS',
            spaces: 'Spaces',
            all_spaces_placeholder: 'All spaces',
            internal_note_section: 'INTERNAL NOTE',
            internal_note_placeholder: 'Why block this slot?',
            block_button: 'Block time slot',
            error_block: 'An error occurred while blocking the time slot.',
        },
    },
    statistics_v3: {
        hello: 'Hello',
        stats_view: 'Statistics View',
        ops_view: 'Operational View',
        last_updated: 'Last updated',
        force_update: 'Force update',
        loading_insights: 'Preparing your insights...',
        never: 'never',
        few_seconds_ago: 'a few seconds ago',
        minutes_ago: '{n} minute ago | {n} minutes ago',
        hours_ago: '{n} hour ago | {n} hours ago',
        days_ago: '{n} day ago | {n} days ago',
        kpis: {
            total_sales: 'Total sales',
            total_sales_tooltip: 'Total amount of issued invoices (incl. tax), whether already paid or not',
            turnover: 'Realized turnover',
            turnover_tooltip:
                'Amount of services already performed (excl. tax). This is the indicator to track to compare your activity against your costs and measure your profitability',
            collections: 'Collections',
            collections_tooltip: 'Total amount of payments received (incl. tax)',
            avg_basket: 'Average basket',
            realized_entries: 'Realized entries',
            weather: 'Weather',
        },
        charts: {
            turnover: 'Turnover',
            total_sales: 'Total sales',
            collections: 'Collections',
            collection_stats: 'Collection statistics',
            best_sellers: 'Best sellers',
            category: 'Category',
            sales_stats: 'Sales statistics',
            services: 'Services',
            products: 'Products',
            restoration: 'Restoration',
            loyalty: 'Loyalty',
            customer_base: 'Customer base',
            customer_stats: 'Customer statistics',
            attendance: 'Attendance',
            reservation_trends: 'Reservation trends',
            conversion_peaks: 'Conversion peaks',
            order_to_resa_delays: 'Order to reservation delays',
            last_12p_vs_prev: 'Last 12 months vs previous year',
            tickets: 'Tickets',
            orders: 'Orders',
            avg_group_size: 'Average group size',
            nb_customers: 'Number of customers',
            comm_subscribers: 'Communication subscribers',
            men: 'Men',
            women: 'Women',
            others: 'Others',
            retention_rate: 'Retention rate',
            new_customers: 'New customers',
            noshow_rate: 'No-show rate',
            cancellation_rate: 'Cancellation rate',
            reservations: 'reservations',
            reservation: 'reservation',
            hour_suffix: 'h',
        },
        date_picker: {
            cancel: 'Cancel',
            apply: 'Apply',
            today: 'Today',
            next_7_days: 'Next 7 days',
            last_7_days: 'Last 7 days',
            current_month: 'Current month',
            last_month: 'Last month',
            current_year: 'Current year',
            last_year: 'Last year',
            current_exercise: 'Current exercise',
            last_exercise: 'Previous exercise',
        },
    },
    banners: {
        payment_failed: {
            message: 'Payment failed: {amount}{symbol} on {date} (Card {card}). Please update your payment information.',
            action: 'Update payment method',
        },
        subscription_canceled: {
            message: 'Subscription canceled: it will be active until {date}. After this date, your access will be limited.',
            action: 'Reactivate my subscription',
        },
        trial_ending: {
            message: 'Your trial period ends in {days} days. Some features will no longer be accessible without a subscription.',
            action: 'Upgrade',
        },
    },
    calendar: {
        spaces: 'Spaces',
        day_short_1: '1D',
        day_short_4: '4d',
        day_short_7: '7d',
        modal: {
            principal: 'Primary',
            calculating: 'calculating ...',
            full_booking_warning: 'This is a full booking, you cannot modify it',
            delete_warning: 'Deleting this slot is irreversible',
            activity: 'Activity',
            client: 'Client:',
            no_results_for: 'No results for',
            no_results: 'No results',
            entry: 'Entry',
            no_client_response: 'No response from the client.',
            voucher_applied: 'The gift voucher has been successfully applied.',
            voucher_blocked: 'This gift voucher has been blocked.',
            tickets: 'Tickets:',
            optional_products: 'Optional products:',
            reassort: 'Reassort:',
            order_date: 'Order date:',
            start_time: 'Start time:',
            change_parent_client: 'Change main client',
            modify_client: 'Modify client',
            swap_coach: 'Swap a coach for another',
            modify_order: 'Modify order:',
            invalid_date_error: 'Invalid date. Please enter a valid date.',
            invalid_time_format: 'Invalid time format. Please enter a valid time.',
            reservation_locked: 'This reservation has been locked',
            smart_booking_title: 'Smart booking',
            select_day: 'Select a day',
            time_slots: 'Time slots:',
            at: 'at',
            week_day: 'Day of the week:',
            wanted_clients: 'Number of clients:',
            employee: 'Employee:',
            load_possibilities: 'Load possibilities',
            days_short: {
                mon: 'Mon.',
                tue: 'Tue.',
                wed: 'Wed.',
                thu: 'Thu.',
                fri: 'Fri.',
                sat: 'Sat.',
                sun: 'Sun.',
            },
            days_enum: {
                monday: 'Monday',
                tuesday: 'Tuesday',
                wednesday: 'Wednesday',
                thursday: 'Thursday',
                friday: 'Friday',
                saturday: 'Saturday',
                sunday: 'Sunday',
            },
            client_alert: 'Client alert',
            product: 'Product',
            days_count: 'Number of days',
            status: 'Status',
            actions: 'Actions',
            finished: 'Finished',
            in_progress: 'In progress',
            create_sale: 'Create a sale',
            create_sale_product: 'Create a sale for this product',
            clients_title: 'Clients:',
            passing_customer: 'Passing customer',
            payment_mode: 'Payment method',
            prescription: 'Prescription',
            prescription_step2: 'Prescription step 2',
            prescription_step3: 'Prescription step 3',
            invoiced_to: 'Invoiced to:',
            client_note: 'Client note:',
            questions_answers: 'Questions and answers:',
            delete_order_confirm: 'Are you sure you want to delete this order?',
            delete_order_text:
                'If you confirm this action, the order and all its components: services, packages, products, options, and other associated elements will be permanently deleted.',
            must_be_number: 'The value must be a number',
            must_be_positive: 'The value must be a positive number',
            voucher_error: 'Gift voucher error:',
            voucher_number: 'Gift voucher no.',
            valid_until: 'valid until',
            booking_already_paid: 'Reservation already paid',
            total_voucher_amount: 'Total amount of gift voucher(s) {amount}{symbol} available',
            voucher_code: 'Bon cadeau',
        },
    },
    customer: {
        reactivate_confirm: 'Do you want to <b>reactivate</b> this customer?',
        deactivate_confirm: 'Do you want to <b>deactivate</b> this customer?',
        first_name: 'First Name',
        last_name: 'Last Name',
        email: 'Email',
        phone: 'Phone',
        phone_number: 'Phone Number',
        birthday: 'Birthday',
        addresses: 'Addresses (full)',
        age: 'Age',
        gender: 'Gender',
        origin: 'Origin',
        spent: 'Spent (in {symbol})',
        loyalty_points: 'Loyalty points',
        first_coming: 'First coming',
        last_coming: 'Last coming',
        created_at: 'Date added',
        actions: 'Actions',
        add_customer: 'Add Customer',
        columns: 'Columns',
        exporter: 'Export',
        export_loading: 'Exporting...',
        fusionner: 'Merge',
        set_password: 'Set password',
        caisse: 'Cash Desk',
        edit: 'Edit',
        deactivate_client_tooltip: 'Deactivate customer',
        reactivate_client_tooltip: 'Reactivate customer',
        plan_reservation: 'Plan reservation',
        deactivate: 'Deactivate',
        activate: 'Activate',
        close: 'Close',
        deactivated_success: 'User deactivated successfully',
        activated_success: 'User activated successfully',
        error_occurred: 'An error occurred.',
        emails_sent_count: 'Number of emails sent',
        sms_sent_count: 'Number of SMS sent',
        sms_count: 'Number of SMS',
        email_count: 'Number of emails',
        start: 'start',
        month: 'Month',
        view_details: 'View details',
        content: 'Content',
        operation: 'Operation',
        object: 'Subject',
        hour: 'Hour',
        date: 'Date',
        previous: 'Previous',
        next: 'Next',
        page: 'Page',
        general_info: 'General Information',
        sms_send_info: 'Number of SMS to send is {total}: price per SMS 0.07 {symbol}',
        char_limit_note: '(Character limit is 150 per message)',
        message_label: 'Message',
        sms_placeholder: 'Your SMS..',
        chars_remaining: '{count} characters remaining',
        variables: 'Variable(s)',
        send: 'Send',
        loading: 'Loading...',
    },
    model_template: {
        title: 'Quote Templates',
        create: 'Create a template',
    },
    combo: {
        add_title: 'Add a combo',
        edit_title: 'Edit combo',
        name_label: 'Combo name',
        name_placeholder: 'Example: "Fun Afternoon", "Adventure Pack".',
        description_label: 'Description',
        visible_online_label: 'Visible online',
        illustration_label: 'Illustration',
        upload_image: 'Upload an image',
        type_label: 'Combo type',
        slot_succession_label: 'Time between activities',
        slot_succession_placeholder: 'Time between activities',
        slot_succession_help:
            'The time between activities allows you to define an interval between each activity. For example, to offer a 30-minute break between two activities so your customers can enjoy the bar, simply enter "30" in the field provided. If you want activities to happen successively without a delay, just enter "0". Example: between each activity, take a 30-minute break to let customers rest/drink, or 0 to chain them.',
        same_time_question: 'Are the schedules identical for each activity?',
        same_time_help:
            'Means that activities share the same specifications, particularly in terms of duration and start times. For example, every 10 minutes or every 30 minutes.',
        multi_participants_question: 'Can participants choose to do only certain activities?',
        discounts_title: 'Discounts',
        discount_type: 'Discount type',
        select_type: 'Select a type',
        amount: 'Amount',
        value: 'Value',
        elements_title: 'Combo items',
        min_elements_label: 'Minimum number of items to select',
        min_elements_help:
            'If you want your customers to choose a specific number of services/activities, e.g., 2 out of 6, enter 2 for both minimum and maximum.',
        max_elements_label: 'Maximum number of items to select',
        max_elements_help:
            'If you want your customers to choose a specific number of services/activities, e.g., 2 out of 6, enter 2 for both minimum and maximum.',
        elements_qty_placeholder: 'Number of items',
        elements_qty_empty_help: 'Leave empty if all activities must be included.',
        durations_diff_warning: 'This is indeed an <i>identical calendar</i>, but the selected durations <b>differ</b>.',
        null_duration_warning: 'You have one or more unselected durations.',
        select_element_label: 'Select item X {index}',
        ticket_options: 'Ticket Options',
        select_activity: 'Select activity',
        no_results: 'No results found for {search}',
        no_elements: 'No items found.',
        duration: 'Duration',
        select_duration: 'Select duration',
        option_and_duration: 'Option and duration',
        select_option: 'Select an option',
        required_item: 'Make item mandatory',
        order_required_question: 'Should this order be mandatory?',
        price_vat_title: 'Price & VAT',
        barcode: 'Barcode',
        vat_rate: 'VAT rate (%)',
        selling_price: 'Selling price (in {currency})',
        price_ht: 'Price excl. tax in ({currency})',
        deposit: 'Deposit',
        request_deposit: 'Request a deposit?',
        deposit_type: 'Deposit type',
        please_select: 'Please select',
        discount: 'Discount',
        activate_discount: 'Activate discount',
        discount_help: '(Allows specifying whether the discount will be activated for activities)',
        discount_percent: 'Discount percentage',
        advanced_options: 'Advanced options',
        merge_questions: 'Merge identical questions',
        merge_questions_help: 'Avoid duplicates: if several activities share the same question, it will only appear once.',
        categories_title: 'Combo categories',
        choose_categories: 'Choose one or more categories',
        select_categories_aria: 'Select category(ies)',
        update_success: 'Combo updated successfully!',
        create_success: 'Combo created successfully!',
        error_general: 'Error while saving',
        error_durations: 'The selected durations are not the same.',
        error_val_zero: 'Field cannot contain the value 0.',
        types: {
            all: 'All services',
            specific: 'Custom service combos',
            family: 'Group Leisure Combo',
            specific_desc:
                "Create bespoke offers by freely selecting activities of your choice and defining the duration of each service. This flexible system allows you to adapt your combos to your customers' specific needs, for unique and personalized experiences.",
            family_desc:
                'Designed to easily manage group bookings, offering your customers a collective experience while allowing maximum flexibility. This module allows you to group several activities under a single booking, with the possibility of assigning different activities to each member of the group, while ensuring the group starts at the same time.',
        },
        yes: 'Yes',
        no: 'No',
        order_required: {
            yes: 'Customers must follow the activities in the defined order.',
            no: 'Customers can do them in any order.',
        },
        multi_participants: {
            yes: 'The customer can set a different number of participants for each activity.',
            no: 'All reserved participants will do all activities.',
        },
    },
    chatbot: {
        button_label: 'AI Assistant',
        header_title: 'Louise, your AI assistant',
        input_placeholder: 'Ask Louise',
        error_no_response: "Sorry, I couldn't process your request.",
        error_connection: 'Connection error. Please try again.',
        status_online: 'Online',
        status_offline: 'Not connected',
        close: 'Close',
        good_morning: 'Good morning',
        good_evening: 'Good evening',
        greet_question: 'What would you like to do?',
        action_day: 'Summarise my day',
        action_calendar: 'Open my calendar',
        action_search: 'Find a booking / a customer',
        action_stats: 'See my stats',
        action_devis: 'Create a quote',
        action_booking: 'Create a booking',
        action_performance: 'Analyse my performance',
        suggestion_reservations: 'How many reservations today?',
        suggestion_turnover: 'What is my revenue this week?',
        suggestion_invoices: 'Where can I see my invoices?',
        coach_title: 'Louise answers your questions about your business',
        coach_body:
            'Your assistant reads your bookings, sales and invoices. Ask a question in plain language and she looks up the answer in PlayPro.',
        coach_item_1: "Today's schedule in one sentence",
        coach_item_2: 'Revenue, no-shows, free slots',
        coach_item_3: 'Find an invoice or a customer',
        coach_cta: 'Discover Louise',
        coach_later: 'Later',
        gemini_key_badge: 'Louise has a message for you',
        gemini_key_request: 'Your AI assistant needs your Gemini key to give you real-time answers.',
        gemini_key_hint_before: 'Create your key on',
        gemini_key_hint_after: ' then paste it here.',
        gemini_key_activate: 'Activate',
        gemini_key_saving: 'Activating…',
        gemini_key_saved_inline: 'Key saved',
        gemini_key_empty: 'Paste your key before activating.',
        gemini_key_forbidden: 'You do not have permission to edit integrations. Ask an administrator to save the key.',
        gemini_key_error: 'The key could not be saved. Please try again.',
    },
    staff_planning_v3: {
        toolbar: {
            employees: '{count} employee | {count} employees',
            current_week: 'Current week',
            download: 'Download',
            duplicate: 'Duplicate',
            save: 'Save',
            publish: 'Publish',
            send: 'Send',
            week_display: 'Week {week}, {year}',
        },
        main: {
            loading: 'Loading...',
            shift_created: 'Shift created successfully',
            shift_modified: 'Shift modified successfully',
            shift_create_error: 'Error creating shift',
            absence_saved: 'Absence saved successfully',
            absence_modified: 'Absence modified successfully',
            absence_error: 'Error saving absence',
            planning_saved: 'Planning saved successfully',
            planning_published: 'Planning published successfully',
            publish_error: 'Error publishing planning',
            planning_sent: 'Planning sent successfully',
            send_error: 'Error sending planning',
            select_employee: 'Please select at least one employee',
            planning_duplicated: 'Planning duplicated successfully',
            duplicate_error: 'Error duplicating planning',
            planning_downloaded: 'Planning downloaded successfully',
            download_error: 'Error downloading planning',
            copy_week_to: 'Copy week to...',
            send_week: 'Send week',
            delete_week: 'Delete week',
            source_undetermined: 'Cannot determine the planning source.',
            copy_error: 'Error copying planning',
            staff_undetermined: 'Cannot determine the staff member.',
            load_error: 'Error loading planning',
            planning_cloned: 'Planning successfully cloned',
            hours_copied: 'Schedule successfully copied',
            absence_deleted: 'Absence successfully deleted',
            absence_delete_error: 'Error deleting absence',
            shift_deleted: 'Shift successfully deleted',
            shift_delete_error: 'Error deleting shift',
            fill_hours: 'Please fill in the shift hours.',
            select_employee_only: 'Please select an employee.',
            invalid_date: 'Invalid date.',
            load_hours_error: 'Error loading hours',
            no_planning_found: 'No planning found for this employee',
            no_shift_found: 'No shift found for this day',
            select_source: 'Please select an employee and a source week.',
            select_target: 'Please select a target employee.',
            select_all: 'Select all',
            deselect_all: 'Deselect all',
            team_title: 'Team',
            total: 'Total',
            confirm_delete_title: 'Confirm deletion',
            confirm_shift_delete_desc: 'Are you sure you want to delete this shift?',
            confirm_delete_resource_title: 'Delete external resource',
            confirm_delete_resource_desc: 'Are you sure you want to delete this external resource? This action cannot be undone.',
            resource_updated: 'External resource updated successfully',
            resource_update_error: 'Error updating the external resource',
            resource_deleted: 'External resource deleted successfully',
            resource_delete_error: 'Error deleting the external resource',
            confirm_overwrite_title: 'Confirm overwrite',
            confirm_overwrite_desc: 'Existing data on target weeks may be overwritten. Do you want to continue?',
            published_upcoming_weeks: 'Published upcoming weeks',
            personalized_weeks: 'Personalized weeks',
        },
        row: {
            external_resource: 'External resource',
            edit_shift: 'Edit a shift',
            delete_shift: 'Delete a shift',
            create_shift: 'Create an shift',
            add_absence: 'Add an absence',
            add_entry: 'Add an entry',
        },
        components: {
            absence_modal: {
                title_edit: 'Edit absence for',
                title_add: 'Add absence for',
                employee: 'Employee',
                select_employee: 'Select an employee',
                motif: 'Reason',
                select_motif: 'Select a reason',
                planning: 'Planning',
                date: 'Date',
                start_time: 'Start time',
                end_time: 'End time',
                add_schedule: 'Add schedule',
                advanced_options: 'Advanced Options',
                add_recurrence: 'Add recurrence',
                frequency: 'Frequency',
                recurrence_end: 'RECURRENCE END',
                choose_days: 'Choose days to repeat this absence:',
                copy_planning: 'Copy from existing planning',
                copy_desc: 'Copy schedules from the previous week or another employee.',
                note: 'Note',
                add_note: 'Add a note (visible by the team)',
                cancel: 'Cancel',
                edit_absence: 'Edit absence',
                add_absence: 'Add absence',
                paid_leave: 'Paid leave',
                sickness: 'Sickness',
                rest: 'Rest',
                other: 'Other',
                every_week: 'Every week',
                every_2_weeks: 'Every 2 weeks',
                every_month: 'Every month',
            },
            create_shift: {
                title_edit: 'Edit shift',
                title_create: 'Create shift',
                for: 'for',
                employee: 'Employee',
                select_employee: 'Select an employee',
                planning: 'Planning',
                date: 'DATE',
                start_time: 'START TIME',
                end_time: 'END TIME',
                add_schedule: 'Add schedule',
                advanced_options: 'Advanced Options',
                add_recurrence: 'Add recurrence',
                frequency: 'Frequency',
                recurrence_end: 'RECURRENCE END',
                choose_days: 'Choose days to repeat this shift:',
                copy_planning: 'Copy from existing planning',
                copy_from: 'Copy from',
                copy_period: 'Period to copy',
                select_week: 'Select a week',
                note: 'Note',
                add_note: 'Add a note (visible by the team)',
                cancel: 'Cancel',
                edit_shift: 'Edit shift',
                create_shift: 'Create shift',
                every_week: 'Every week',
                every_2_weeks: 'Every 2 weeks',
                every_month: 'Every month',
                week: 'Week',
            },
            copy_planning: {
                title: 'Duplicate planning',
                target_employees: 'Target employee(s)',
                select_employees: 'Select employee(s)',
                source_week: 'Source week',
                select_source_week: 'Select source week',
                target_weeks: 'Target week(s)',
                select_target_weeks: 'Select week(s)',
                warning_title: 'Warning',
                warning_desc: 'Duplication will overwrite existing schedules on target weeks.',
                cancel: 'Cancel',
                duplicate: 'Duplicate',
            },
            send_planning: {
                title: 'Send planning',
                format: 'Send format',
                select_format: 'Select format',
                employees: 'Employees',
                all_employees: 'All employees of the week',
                weeks: 'Weeks',
                select_weeks: 'Select week(s)',
                message: 'Message',
                message_placeholder: 'Add an optional message...',
                cancel: 'Cancel',
                send: 'Send',
            },
            download_planning: {
                title: 'Download planning',
                format: 'Export format',
                select_format: 'Select format',
                employees: 'Employees',
                all_employees: 'All employees of the week',
                weeks: 'Weeks',
                select_weeks: 'Select week(s)',
                cancel: 'Cancel',
                download: 'Download',
            },
            confirm_delete_week: {
                title: 'Confirmation',
                message: 'Are you sure you want to delete all shifts for week {week}?',
                cancel: 'Cancel',
                delete: 'Delete',
            },
            resource_externe_modal: {
                title_edit: 'Edit external resource',
                title_create: 'Add external resource',
                name: 'Name',
                name_placeholder: 'Resource name',
                email: 'Email',
                email_placeholder: 'Resource email',
                phone: 'Phone',
                phone_placeholder: 'Resource phone',
                cancel: 'Cancel',
                save: 'Save',
            },
            note_section: {
                title: 'Note',
                placeholder: 'Add a note (visible by the team)',
            },
            staff_selector: {
                search: 'Search an employee',
                all: 'All',
                select_all: 'Select all',
                deselect_all: 'Deselect all',
                send_to: 'Send to',
                show_for: 'Shown on the schedule',
            },
            planning_type_selector: {
                week: 'Week {week}',
                month: 'Month',
                personalized: 'Personalized',
                min_hint: '2 wks min.',
                min_weeks_hint: 'Minimum 2 published weeks required',
            },
        },
        copy_modal: {
            title: 'Copy the week',
            source_employee: 'Source employee',
            target_employee: 'Target employee',
            weeks_to_copy: 'Weeks to copy',
            select_employee: 'Select an employee',
            select_week: 'Select a week',
            cancel: 'Cancel',
            validate: 'Validate',
            error_source: 'Please select a source employee.',
            error_target: 'Please select a target employee.',
            error_weeks: 'Please select at least one target week.',
            confirm: 'Confirm',
        },
        send_modal: {
            title: 'Send schedule',
        },
        download_modal: {
            title: 'Download schedule',
        },
    },
    categories: {
        dashboard: 'Dashboard',
        bookings: 'Bookings',
        orders: 'Orders',
        customers: 'Customers',
        customer_groups: 'Customer Groups',
        gift_vouchers: 'Gift Vouchers',
        open_tickets: 'Open Tickets',
        quotes: 'Quotes',
        invoices: 'Invoices',
        announcements: 'Announcements',
        promo_codes: 'Promo Codes',
        email_campaigns: 'Email Campaigns',
        automated_emails: 'Automated Emails',
        push_notifications: 'Push Notifications',
        blog: 'Blog',
        staff_scheduling: 'Staff Scheduling',
        users: 'Users',
        roles_permissions: 'Roles & Permissions',
        accounting: 'Accounting',
        facility_settings: 'Facility Settings',
        website: 'Website',
        experiences: 'Experiences',
        experience_categories: 'Experience Categories',
        bundles: 'Packages & Bundles',
        packages: 'Packages',
        subscriptions: 'Subscriptions',
        facilities: 'Facilities',
        equipment: 'Equipment',
        widgets: 'Widgets',
        add_ons: 'Add-ons / Upsells',
        add_on_categories: 'Add-on Categories',
        suppliers: 'Suppliers',
        brands: 'Brands',
        catering: 'Catering / F&B',
        catering_categories: 'F&B Categories',
        tags: 'Tags',
        qr_codes: 'QR Codes',
        quote_templates: 'Quote Templates',
        quote_requests: 'Quote Requests',
        pos: 'Point of Sale (POS)',
        integrations: 'Integrations',
        api: 'API',
        reservations_experiences: 'Reservations and experiences',
        website_visibility: 'Website & visibility',
        payment_collection: 'Payment & Collection',
        billing_quotes: 'Billing & Quotes',
        encaissement: 'Collection',
        marketing_fidélisation: 'Marketing & Loyalty',
        ai_automation: 'AI & Automation',
        team_hr: 'Team & HR',
    },
    permissions: {
        dashboard: {
            view_operational: 'View operational dashboard',
            view_financial: 'View financial dashboard',
        },
        bookings: {
            create: 'Create a booking',
            view: 'View bookings',
            edit: 'Edit a booking',
            delete: 'Delete a booking',
            export: 'Export bookings',
            block_slot: 'Block/unblock a time slot',
        },
        orders: {
            create: 'Create an order',
            view: 'View orders',
            edit: 'Edit an order',
            delete: 'Delete an order',
            export: 'Export orders',
        },
        customers: {
            create: 'Create a customer',
            view: 'View customers',
            edit: 'Edit a customer',
            delete: 'Delete a customer',
            export: 'Export customer database',
        },
        customer_groups: {
            create: 'Create a customer group',
            view: 'View customer groups',
            edit: 'Edit a customer group',
            delete: 'Delete a customer group',
            export: 'Export customer groups',
        },
        gift_vouchers: {
            create: 'Create a gift voucher',
            view: 'View gift vouchers',
            edit: 'Edit gift vouchers',
            delete: 'Delete gift vouchers',
            export: 'Export gift vouchers',
        },
        open_tickets: {
            create: 'Create an open ticket',
            view: 'View open tickets',
            edit: 'Edit an open ticket',
            delete: 'Delete an open ticket',
            export: 'Export open tickets',
        },
        quotes: {
            create: 'Create a quote',
            view: 'View quotes',
            edit: 'Edit a quote',
            delete: 'Delete a quote',
            remind: 'Send a quote reminder',
            export: 'Export quotes',
        },
        invoices: {
            create_sales: 'Create a sales invoice',
            create_credit_note: 'Create a credit note',
            view: 'View invoices',
            remind: 'Send an invoice reminder',
            export: 'Export invoices',
        },
        announcements: {
            create: 'Create an announcement',
            view: 'View announcements',
            edit: 'Edit an announcement',
            delete: 'Delete an announcement',
        },
        promo_codes: {
            create: 'Create a promo code',
            view: 'View promo codes',
            edit: 'Edit a promo code',
            delete: 'Delete a promo code',
        },
        email_campaigns: {
            create: 'Create a campaign',
            view: 'View campaigns',
            edit: 'Edit a campaign',
            delete: 'Delete a campaign',
        },
        automated_emails: {
            view: 'View automated emails',
            edit: 'Edit automated emails',
        },
        push_notifications: {
            send: 'Send a notification',
            view: 'View notifications',
        },
        blog: {
            create: 'Create an article',
            view: 'View articles',
            edit: 'Edit an article',
            delete: 'Delete an article',
        },
        staff_scheduling: {
            create_shift: 'Create a shift',
            view: 'View schedule',
            edit: 'Edit schedule',
            delete_shift: 'Delete a shift',
            send: 'Send schedule',
            download: 'Download schedule',
        },
        users: {
            create: 'Create a user',
            view: 'View users',
            edit: 'Edit a user',
            delete: 'Delete a user',
        },
        roles_permissions: {
            create: 'Create a role',
            view: 'View roles',
            edit: 'Edit a role',
            delete: 'Delete a role',
        },
        accounting: {
            download_accounting: 'Download accounting documents',
            download_operational: 'Download operational documents',
        },
        facility_settings: {
            view: 'View settings',
            edit: 'Edit a setting',
            delete: 'Delete a setting',
        },
        website: {
            view: 'View website settings',
            edit: 'Edit website settings',
            publish_forms: 'Publish quote request forms',
            custom_domain: 'Configure custom domain',
        },
        experiences: {
            create: 'Create an experience',
            view: 'View experiences',
            edit: 'Edit an experience',
            delete: 'Delete an experience',
        },
        experience_categories: {
            create: 'Create an experience category',
            view: 'View experience categories',
            edit: 'Edit an experience category',
            delete: 'Delete an experience category',
        },
        bundles: {
            create: 'Create a bundle formula',
            view: 'View bundle formulas',
            edit: 'Edit a bundle formula',
            delete: 'Delete a bundle formula',
            export: 'Export bundle formulas',
        },
        packages: {
            create: 'Create a package',
            view: 'View packages',
            edit: 'Edit a package',
            delete: 'Delete a package',
        },
        subscriptions: {
            create: 'Create a subscription',
            view: 'View subscriptions',
            edit: 'Edit a subscription',
            delete: 'Delete a subscription',
        },
        facilities: {
            create: 'Add a facility',
            view: 'View facilities',
            edit: 'Edit a facility',
            delete: 'Delete a facility',
            export: 'Export facilities',
        },
        equipment: {
            create: 'Add equipment',
            view: 'View equipment',
            edit: 'Edit equipment',
            delete: 'Delete equipment',
            export: 'Export equipment',
        },
        widgets: {
            access: 'Access widgets',
        },
        add_ons: {
            create: 'Create an add-on product',
            view: 'View add-on products',
            edit: 'Edit an add-on product',
            delete: 'Delete an add-on product',
            publish: 'Publish add-on products',
        },
        add_on_categories: {
            create: 'Create an add-on category',
            view: 'View add-on categories',
            edit: 'Edit an add-on category',
            delete: 'Delete an add-on category',
            export: 'Export add-on categories',
        },
        suppliers: {
            create: 'Add a supplier',
            view: 'View suppliers',
            edit: 'Edit a supplier',
            delete: 'Delete a supplier',
            export: 'Export suppliers',
        },
        brands: {
            create: 'Add a brand',
            view: 'View brands',
            edit: 'Edit a brand',
            delete: 'Delete a brand',
            export: 'Export brands',
        },
        catering: {
            create: 'Create a product',
            view: 'View products',
            edit: 'Edit a product',
            delete: 'Delete a product',
            export: 'Export products',
        },
        catering_categories: {
            create: 'Create an F&B product category',
            view: 'View F&B product categories',
            edit: 'Edit an F&B product category',
            delete: 'Delete an F&B product category',
            export: 'Export F&B product categories',
        },
        tags: {
            create: 'Create a tag',
            view: 'View tags',
            edit: 'Edit a tag',
            delete: 'Delete a tag',
            export: 'Export tags',
        },
        qr_codes: {
            create: 'Create a QR Code',
            view: 'View QR Codes',
            edit: 'Edit a QR Code',
            delete: 'Delete a QR Code',
            export: 'Export QR Codes',
        },
        quote_templates: {
            create: 'Create a template',
            view: 'View templates',
            edit: 'Edit a template',
            delete: 'Delete a template',
        },
        quote_requests: {
            create: 'Create a quote request form',
            view: 'View a quote request form',
            edit: 'Edit a quote request form',
            delete: 'Delete a quote request form',
        },
        pos: {
            create: 'Create a point of sale',
            view: 'View points of sale',
            edit: 'Edit a point of sale',
            delete: 'Delete a point of sale',
        },
        integrations: {
            create: 'Create an integration',
            view: 'View integrations',
            edit: 'Edit an integration',
            delete: 'Delete an integration',
        },
        api: {
            create: 'Create a key',
            view: 'View keys',
            edit: 'Edit a key',
            delete: 'Delete a key',
        },
        reservations_experiences: {
            creation_formules_combines: 'Creation of combined packages',
            demandes_devis_en_ligne: 'Online quote requests',
            ventes_additionnelles: 'Upselling & cross-selling',
            export_base_clients: 'Customer database export',
            relance_paniers_abandonnes: 'Abandoned cart recovery',
        },
        website_visibility: {
            nom_domaine_personnalise: 'Custom domain name',
            suppression_logo_playpro: 'Removal of the PlayPro logo',
            application_mobile_personnalisee: 'Custom mobile app',
        },
        payment_collection: {
            paiement_avec_acompte: 'Deposit payment',
            paiement_avec_apple_pay: 'Payment with Apple Pay',
            paiement_avec_google_pay: 'Payment with Google Pay',
        },
        billing_quotes: {
            generation_edition_devis: 'Quote generation & editing',
            suivi_devis_vue_kanban: 'Quote tracking in Kanban view',
            creation_envoi_brochure_devis: 'Brochure creation & sending with quotes',
            relance_automatique_devis: 'Automated quote follow-ups',
            signature_electronique_devis: 'Electronic signature for quotes',
        },
        encaissement: {
            commande_qr_code: 'QR code ordering',
            gestion_stocks: 'Inventory management',
        },
        marketing_fidélisation: {
            creation_carnets_entrees: 'Creation of pass booklets',
            campagnes_email_newsletters: 'Newsletter email campaigns',
            programmes_fidelite: 'Loyalty programs',
            gestion_automatisee_bons_cadeaux: 'Automated gift voucher management',
            billetterie_cse: 'Works council (CSE) ticketing',
            tracking_avance_gtm_matomo: 'Advanced data tracking via GTM/Matomo',
            creation_gestion_abonnements: 'Subscription creation & management',
            wallet_portefeuille_electronique: 'Wallet (e-wallet)',
            programme_parrainage: 'Referral program',
            tarification_dynamique_early_birds: 'Dynamic pricing (Early Birds)',
        },
        ai_automation: {
            emails_automatiques: 'Automated emails (reminders, birthdays, etc.)',
            liaison_karafun: 'Integration with Karafun',
            synchronisation_google_agenda: 'Google Calendar synchronization',
            api_reservations: 'Booking API',
            envoi_emails_boite_mail: 'Send emails using your own mailbox',
            gestion_multi_etablissements: 'Multi-location management',
        },
        team_hr: {
            planning_equipe: 'Team scheduling',
            suivi_objectifs_gamification: 'Goal tracking (gamification)',
        },
    },
    subscription_info: {
        pro: 'Pro',
        essentiel: 'Essential',
        premium: 'Premium',
    },
    errors_permission: {
        noPermission: 'You do not have permission to perform this action.',
    },
}
